webpackJsonp([1],{

/***/ "+4L3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+7at":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/GABRIEL_MARTINEZ.bd55c48.jpg";

/***/ }),

/***/ "0L3U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "12/8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Ktb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3npI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/EMMANUEL_GARCIA.16cc0bb.jpg";

/***/ }),

/***/ "4/gc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/POWERPAOLA.0b2288f.jpg";

/***/ }),

/***/ "6gDJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/MARIANA_MAGDALENO.392a6ec.jpg";

/***/ }),

/***/ "7jAL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/data/data.a382a88.json";

/***/ }),

/***/ "8mfa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8mw6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8sw3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/MANUEL_MONROY.c35400a.jpg";

/***/ }),

/***/ "9FTa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9I0h":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DR_LAKRA.9e344de.jpg";

/***/ }),

/***/ "AG5z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/MARCOS_CASTRO.eaa2b5b.jpg";

/***/ }),

/***/ "AMuy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BXD5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CCLV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/JOSE_ANGEL.1b5285a.jpg";

/***/ }),

/***/ "Cuwq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/data/data.fffcda8.json";

/***/ }),

/***/ "DSe6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/TRINE_ELLITSGAARD.298119d.jpg";

/***/ }),

/***/ "Dt7p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ea38":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EsQN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/KRAKEN.a0c8782.jpg";

/***/ }),

/***/ "EwuT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F9vg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G9b2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HBZW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IHlG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/play.6e08296.svg";

/***/ }),

/***/ "KF8U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KZWA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/MIKE_SANDOVAL.e83bedb.jpg";

/***/ }),

/***/ "LVez":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NFa9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/sanitize.css/sanitize.css
var sanitize = __webpack_require__("9FTa");
var sanitize_default = /*#__PURE__*/__webpack_require__.n(sanitize);

// EXTERNAL MODULE: ./src/main.styl
var main = __webpack_require__("tLzU");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/url-polyfill/url-polyfill.js
var url_polyfill = __webpack_require__("Xk2i");
var url_polyfill_default = /*#__PURE__*/__webpack_require__.n(url_polyfill);

// EXTERNAL MODULE: ./src/app/utils/polyfills/index.js
var polyfills = __webpack_require__("Xg4b");
var polyfills_default = /*#__PURE__*/__webpack_require__.n(polyfills);

// EXTERNAL MODULE: ./node_modules/gsap/TweenMax.js
var gsap_TweenMax = __webpack_require__("+Uzz");
var TweenMax_default = /*#__PURE__*/__webpack_require__.n(gsap_TweenMax);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/get-prototype-of.js
var get_prototype_of = __webpack_require__("Zx67");
var get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(get_prototype_of);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("zwoO");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("Pf15");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__("/5sW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var core_js_promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(core_js_promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/freeze.js
var freeze = __webpack_require__("u2KI");
var freeze_default = /*#__PURE__*/__webpack_require__.n(freeze);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./src/config/defaultConfig.js


var DEFAULT_ENVIRONMENT = {
    vars: {
        debug: true
    },
    url: {
        base: "",
        subdirectory: "",
        public: "/static",
        api: "/api"
    },
    analytics: [{
        adapter: "google",
        id: "uaXXXXXXXX"
    }],
    properties: {
        fb: "XXXXXXXXXXXXXXX",
        gp: "XXXXXXXXXXXXXXX.apps.googleusercontent.com",
        xeerpa: ""
    }
};

/**
 * Default config
 * @readonly
 */
/* harmony default export */ var defaultConfig = (freeze_default()({
    locale: "es-MX",
    data_loading: true,
    asset_loading: true,
    facebook_permissions: "email",
    google_scopes: "https://www.googleapis.com/auth/plus.login",
    sdks: [],
    vars: {
        animate: true,
        resize: true
    },
    environments: {
        staging: extends_default()({}, DEFAULT_ENVIRONMENT, {
            priority: 1
        }),
        qa: extends_default()({}, DEFAULT_ENVIRONMENT, {
            priority: 2
        }),
        production: extends_default()({}, DEFAULT_ENVIRONMENT, {
            priority: 3
        }),
        development: extends_default()({}, DEFAULT_ENVIRONMENT, {
            priority: 4
        })
    }
}));
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// CONCATENATED MODULE: ./src/config/getEnvironment.js



/**
 * @param {{}} environments
 * @return {Readonly<{}>}
 */
/* harmony default export */ var getEnvironment = (function (environments) {
    var environment = entries_default()(environments)
    // Sort environments by priority
    .sort(function (a, b) {
        return a[1].priority - b[1].priority;
    }).reduce(function (prev, _ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            key = _ref2[0],
            env = _ref2[1];

        if (prev === null) {
            var isSameHref = void 0;
            if (env.url.subdirectory) {
                var url = new URL('' + env.url.base + env.url.subdirectory);
                isSameHref = url.host === location.host && location.pathname.indexOf(url.pathname) !== -1;
            } else {
                var _url = new URL(env.url.base);
                isSameHref = _url.host === location.host;
            }
            // Default is development env
            if (isSameHref || key === 'development') return env;
        }
        return prev;
    }, null);
    return freeze_default()(environment);
});
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./src/config/index.js





/**
 * @typedef EnvironmentVars
 * @prop {Boolean} debug
 *
 * @typedef EnvironmentUrl
 * @prop {String} base
 * @prop {String} subdirectory
 * @prop {String} public
 * @prop {String} api
 *
 * @typedef EnvironmentAnalytics
 * @prop {String} adapter
 * @prop {String} id
 *
 * @typedef EnvironmentProperties
 * @prop {String} fb
 * @prop {String} gp
 * @prop {String} xeerpa
 *
 * @typedef Environment
 * @prop {Number} priority
 * @prop {EnvironmentVars} vars
 * @prop {EnvironmentUrl} url
 * @prop {EnvironmentAnalytics[]} analytics
 * @prop {EnvironmentProperties} properties
 *
 * @typedef ConfigEnvironments
 * @prop {Environment} production
 * @prop {Environment} staging
 * @prop {Environment} qa
 * @prop {Environment} development
 *
 * @typedef ConfigVars
 * @prop {Boolean} animate
 * @prop {Boolean} resize
 *
 * @typedef Config
 * @prop {String} locale
 * @prop {Boolean} data_loading
 * @prop {Boolean} asset_loading
 * @prop {String} facebook_permissions
 * @prop {String} google_scopes
 * @prop {String[]} sdks
 * @prop {ConfigVars} vars
 * @prop {ConfigEnvironments} environments
 */

/**
 * @type {Config}
 */
var CUSTOM_CONFIG = {
    environments: {
        production: {
            vars: {
                debug: false
            },
            url: {
                base: "https://epicmoleskine.com"
            }
        },
        staging: {
            url: {
                base: "http://fooprojects.com",
                subdirectory: "/clients/moleskine/epic-moleskine-2/",
                public: "/clients/moleskine/epic-moleskine-2/static",
                api: "/clients/moleskine/epic-moleskine-2/api"
            }
        },
        qa: {
            url: {
                base: "http://qa-url.com"
            }
        },
        development: {
            url: {
                base: "http://localhost:8080"
            }
        }
    }
};

/**
 * @type {Readonly<Config>}
 */
var config_config = freeze_default()(Object(lodash["defaultsDeep"])(CUSTOM_CONFIG, defaultConfig));

/**
 * @type {Readonly<Environment>}
 */
var config_environment = getEnvironment(config_config.environments);
// EXTERNAL MODULE: ./src/config/data.json
var config_data = __webpack_require__("7jAL");
var data_default = /*#__PURE__*/__webpack_require__.n(config_data);

// EXTERNAL MODULE: ./node_modules/signals/dist/signals.js
var signals = __webpack_require__("FiaD");
var signals_default = /*#__PURE__*/__webpack_require__.n(signals);

// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__("+X65");
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// EXTERNAL MODULE: ./node_modules/superagent/lib/client.js
var client = __webpack_require__("GG98");
var client_default = /*#__PURE__*/__webpack_require__.n(client);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/app/store/modules/app.js


var _actions, _mutations;



var LOCALE_CHANGED = 'locale/changed';
var LOCALE_LOADING = 'locale/loading';
var ASSET_LOADING = 'app/loading';
var DATA = 'app/data';
var ACTIVE_CHAPTER_ID = 'app/active-chapter-id';

var state = {
    public: config_environment.url.public,
    locale: '',
    locale_loading: false,
    loading: true,
    data: null,
    activeChapterId: '',
    mainNavVisible: false
};

var actions = (_actions = {}, defineProperty_default()(_actions, LOCALE_LOADING, function (_ref) {
    var commit = _ref.commit;

    commit(LOCALE_LOADING, true);
}), defineProperty_default()(_actions, LOCALE_CHANGED, function (_ref2, locale) {
    var commit = _ref2.commit;

    commit(LOCALE_CHANGED, locale);
}), defineProperty_default()(_actions, ASSET_LOADING, function (_ref3, payload) {
    var commit = _ref3.commit;

    commit(ASSET_LOADING, payload);
}), _actions);

var mutations = (_mutations = {}, defineProperty_default()(_mutations, LOCALE_CHANGED, function (state, locale) {
    state.locale = locale;
    state.locale_loading = false;
}), defineProperty_default()(_mutations, LOCALE_LOADING, function (state) {
    state.locale_loading = true;
}), defineProperty_default()(_mutations, ASSET_LOADING, function (state, payload) {
    state.loading = payload;
}), defineProperty_default()(_mutations, DATA, function (state, payload) {
    state.data = payload;
}), defineProperty_default()(_mutations, ACTIVE_CHAPTER_ID, function (state, payload) {
    state.activeChapterId = payload;
}), _mutations);

var getters = {
    locale: function locale(state) {
        return state.locale;
    },
    public: function _public(state) {
        return state.public;
    },
    data: function data(state) {
        return state.data;
    },
    activeChapterId: function activeChapterId(state) {
        return state.activeChapterId;
    }
};

/* harmony default export */ var app = ({ state: state, actions: actions, mutations: mutations, getters: getters });
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/preloader/index.js
var preloader = __webpack_require__("2S2c");
var preloader_default = /*#__PURE__*/__webpack_require__.n(preloader);

// CONCATENATED MODULE: ./src/app/store/modules/loader.js




var loader__actions, loader__mutations;

/**
 * Created by mendieta on 11/4/16.
 */



var LOADING = "loader/loading";
var LOADED = "loader/loaded";
var PROGRESS = "loader/progress";
var LOAD = "loader/load";

var loader_state = {
    loading: false,
    progress: 0,
    assets: []
};

var loader_actions = (loader__actions = {}, defineProperty_default()(loader__actions, LOADING, function (_ref, loading) {
    var commit = _ref.commit;

    commit(LOADING, loading);
}), defineProperty_default()(loader__actions, LOADED, function (_ref2) {
    var commit = _ref2.commit;

    commit(LOADED);
}), defineProperty_default()(loader__actions, PROGRESS, function (_ref3, progress) {
    var commit = _ref3.commit;

    commit(PROGRESS, progress);
}), defineProperty_default()(loader__actions, LOAD, function (_ref4, assets) {
    var commit = _ref4.commit;

    return new promise_default.a(function (resolve, reject) {
        commit(PROGRESS, 0);
        commit(LOAD, assets);
        commit(LOADING, true);
        if ((typeof assets === "undefined" ? "undefined" : typeof_default()(assets)) === "object") {
            var loader = new preloader_default.a();
            assets.foreach(function (file) {
                return loader.add(file);
            });
            loader.on("progress", function (val) {
                return commit(PROGRESS, val);
            });
            loader.on("complete", function () {
                commit(PROGRESS, 1);
                commit(LOADED);
                resolve();
            });
            loader.load();
        } else if (typeof assets === "string") {
            client_default.a.get(assets).then(function (response) {
                commit(LOADED);
                resolve(response.body);
            }).catch(function (error) {
                console.error("Error Loading asset: " + assets + " with error - " + error);
                commit(LOADED);
                reject(new Error("Error"));
            });
        }
    });
}), loader__actions);

var loader_mutations = (loader__mutations = {}, defineProperty_default()(loader__mutations, LOADED, function (state) {
    state.loading = false;
}), defineProperty_default()(loader__mutations, LOADING, function (state, loading) {
    state.loading = loading;
}), defineProperty_default()(loader__mutations, PROGRESS, function (state, progress) {
    state.progress = progress;
}), defineProperty_default()(loader__mutations, LOAD, function (state, assets) {
    state.assets = assets;
}), loader__mutations);

var loader_getters = {
    loading: function loading(state) {
        return state.loading;
    },
    progress: function progress(state) {
        return state.progress;
    },
    loaderAssets: function loaderAssets(state) {
        return state.assets;
    }
};

/* harmony default export */ var modules_loader = ({ state: loader_state, actions: loader_actions, mutations: loader_mutations, getters: loader_getters });
// EXTERNAL MODULE: ./node_modules/load-script/index.js
var load_script = __webpack_require__("PirY");
var load_script_default = /*#__PURE__*/__webpack_require__.n(load_script);

// CONCATENATED MODULE: ./src/foo/net/api/AbstractApi.js





var AbstractApi_AbstactApi = function () {
    function AbstactApi() {
        classCallCheck_default()(this, AbstactApi);
    }

    createClass_default()(AbstactApi, null, [{
        key: "setup",


        /**
         * The User Data Object
         * @property userData
         * @default null
         * @static
         * @type {Object}
         */


        /**
         * Flag determining if the SDK is loaded
         * @property loaded
         * @default false
         * @static
         * @type {boolean}
         */

        /**
         * @property name
         * @default "AbstractApi"
         * @static
         * @public
         * @type {string}
         */
        value: function setup() {
            var _this = this;

            return new promise_default.a(function (resolve) {
                _this.resolve = resolve;
                _this._load();
            });
        }

        /**
         * Loads the SDK.
         * @method _load
         * @private
         * @static
         */


        /**
         * The setup Promise resolve function
         * @static
         * @property resolve
         * @default null
         * @type {function}
         */


        /**
         * Variable determining if the SDK has been inited.
         * @property inited
         * @static
         * @type {boolean}
         */


        /**
         * The SDK url;
         * @property url
         * @default ""
         * @static
         * @override
         * @type {string}
         */

    }, {
        key: "_load",
        value: function _load() {
            if (this.url) {
                load_script_default()(this.url, this._init.bind(this));
            } else {
                console.warn("SdkManager: no sdk url has been set for " + this.apiName + ".");
            }
        }

        /**
         * Initialize the SDK.
         * @param {object} error The error that could occur loading the SDK.
         * @private
         * @static
         */

    }, {
        key: "_init",
        value: function _init(error) {
            if (error) {
                throw new Error("SdkManager: Error loading SDK! - " + error);
            }
            if (this.loaded) return;
            this.loaded = true;
            this.configSDK();
        }
    }, {
        key: "configSDK",
        value: function configSDK() {
            this.sdkConfigured();
        }
    }, {
        key: "sdkConfigured",
        value: function sdkConfigured() {
            this.inited = true;
            this.resolve();
            this.resolve = null;
        }
    }]);

    return AbstactApi;
}();

AbstractApi_AbstactApi.apiName = "AbstractApi";
AbstractApi_AbstactApi.url = "";
AbstractApi_AbstactApi.loaded = false;
AbstractApi_AbstactApi.inited = false;
AbstractApi_AbstactApi.userData = null;
AbstractApi_AbstactApi.resolve = null;
/* harmony default export */ var AbstractApi = (AbstractApi_AbstactApi);
// CONCATENATED MODULE: ./src/foo/net/api/FacebookApi.js











/**
 * Helper static class for working with Facebook API
 * @class Facebook
 * @namespace net.api
 * @author Mendieta
 */

var FacebookApi_Facebook = function (_AbstractApi) {
    inherits_default()(Facebook, _AbstractApi);

    function Facebook() {
        classCallCheck_default()(this, Facebook);

        return possibleConstructorReturn_default()(this, (Facebook.__proto__ || get_prototype_of_default()(Facebook)).apply(this, arguments));
    }

    createClass_default()(Facebook, null, [{
        key: "configSDK",

        /**
         * The Facebook permissions array
         * @property permissions
         * @default "email"
         * @static
         * @type {string}
         */
        value: function configSDK() {
            this.permissions = config_config.facebook_permissions;
            this.appID = config_environment.properties.fb;
            FB.init({
                appId: this.appID,
                status: false,
                xfbml: true,
                version: "2.8"
            });
            this.sdkConfigured();
        }

        /**
         * Facebook login method
         * @public
         * @static
         * @param {function} resolve
         * @param {function} reject
         * @method login
         * @return Promise
         */


        /**
         * The Facebook App ID
         * @property appID
         * @default ""
         * @static
         * @type {string}
         */


        /**
         * The Facebook SDK url
         * @property url
         * @static
         * @type {string}
         * @default "//connect.facebook.net/es_MX/all.js"
         */

    }, {
        key: "login",
        value: function login(resolve, reject) {
            var _this2 = this;

            if (!this.loaded) reject("Facebook SDK not loaded! call Facebook.setup() before login. You should enable the Facebook from the config file.");
            FB.login(function (res) {
                if (res["status"] === "connected") {
                    _this2._getUserData(res["authResponse"]["accessToken"], resolve);
                } else {
                    reject("Access Denied");
                }
            }, this.permissions);
        }

        /**
         * Fetches user data and stores it in userData
         * @param {string} token The facebook session token
         * @param {function} resolve
         * @return {void}
         * @method _getUserData
         * @static
         * @private
         */

    }, {
        key: "_getUserData",
        value: function _getUserData(token, resolve) {
            var count = 0;
            var userData = {
                auth: {},
                profile: {}
            };
            userData.auth = {
                access_token: token
            };

            FB.api("/me?fields=email,first_name,gender,id,locale,last_name,middle_name,name", function (res) {
                userData.profile = extends_default()({ profile_pic: userData.profile.profile_pic }, res);
                solve();
            });

            FB.api("me/picture", { "width": "200" }, function (res) {
                userData.profile["profile_pic"] = res.data;
                solve();
            });

            var solve = function solve() {
                count++;
                if (count === 2) {
                    resolve(userData);
                }
            };
        }

        /**
         * Open Facebook share ui with options
         * @param {object} opts The options object
         * @return {Promise}
         * @static
         * @method share
         */

    }, {
        key: "share",
        value: function share(opts) {
            return new promise_default.a(function (resolve, reject) {
                FB.ui({
                    method: opts.method || "feed",
                    name: opts.name || "",
                    link: opts.link || "",
                    picture: opts.picture || "",
                    caption: opts.caption || "",
                    description: opts.description || ""
                }, function (response) {
                    resolve(response);
                });
            });
        }

        /**
         * Get user Facebook friends
         * TODO: build get users API request
         * @param {function} cb The callback
         * @return {void}
         * @static
         * @method getUserFriend
         */

    }, {
        key: "getUserFriends",
        value: function getUserFriends(cb) {}

        /**
         *
         * @param {string} token Facebook session token
         * @param {number }limit The locations amount limit
         * @return {Promise}
         */

    }, {
        key: "getUserLocations",
        value: function getUserLocations() {
            var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

            return new promise_default.a(function (resolve, reject) {
                FB.api("/me/tagged_places", { token: token, limit: limit }, function (response) {
                    resolve(response.data);
                });
            });
        }

        /**
         *
         * @param {string} token Facebook session token
         * @param {number} limit The likes amount limit
         * @return {Promise}
         */

    }, {
        key: "getUserLikes",
        value: function getUserLikes() {
            var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

            var likes = [];
            return new promise_default.a(function (resolve, reject) {
                FB.api("/me/likes", { token: token, limit: limit }, function (response) {
                    likes = likes.concat(response.data);
                    if (response.paging.next) {
                        nextPage(response.paging.next);
                    } else {
                        resolve(likes);
                    }
                });

                var nextPage = function nextPage(url) {
                    client_default.a.get(url).then(function (response) {
                        likes = likes.concat(response.body.data);
                        if (response.body.paging.next) {
                            nextPage(response.body.paging.next);
                        } else {
                            resolve(likes);
                        }
                    });
                };
            });
        }
    }]);

    return Facebook;
}(AbstractApi);

FacebookApi_Facebook.apiName = "Facebook";
FacebookApi_Facebook.url = "//connect.facebook.net/es_MX/all.js";
FacebookApi_Facebook.premissions = "email";
FacebookApi_Facebook.appID = "";
/* harmony default export */ var FacebookApi = (FacebookApi_Facebook);
// CONCATENATED MODULE: ./src/foo/net/api/GoogleApi.js








var GoogleApi_GoogleApi = function (_AbstractApi) {
    inherits_default()(GoogleApi, _AbstractApi);

    function GoogleApi() {
        classCallCheck_default()(this, GoogleApi);

        return possibleConstructorReturn_default()(this, (GoogleApi.__proto__ || get_prototype_of_default()(GoogleApi)).apply(this, arguments));
    }

    createClass_default()(GoogleApi, null, [{
        key: "configSDK",


        /**
         * @static
         * @property GoogleAuth
         * @type {Object}
         */


        /**
         * The Google SDK url;
         * @property url
         * @default "https://apis.google.com/js/platform.js"
         * @static
         * @type {string}
         */
        value: function configSDK() {
            var _this2 = this;

            gapi.load("auth2", function () {
                _this2.loaded = true;
                _this2.GoogleAuth = gapi.auth2.init({ client_id: config_environment.properties.gp });
                _this2.GoogleAuth.then(function () {
                    _this2.sdkConfigured();
                });
            });
        }

        /**
         * Login method.
         * @param {function} resolve
         * @param {function} reject
         * @static
         * @public
         */


        /**
         * @static
         * @property GoogleUser
         * @type {Object}
         */


        /**
         * The default SDK params.
         * @property params
         * @static
         * @type {{clientid: null, callback: null, scope: string, cookiepolicy: string}}
         */


        /**
         * @property apiName
         * @static
         * @type {string}
         */

    }, {
        key: "login",
        value: function login(resolve, reject) {
            var _this3 = this;

            if (!this.inited) throw new Error("Google SDK not loaded! call Google.setup() before login. You should enable the Google from the config file.");
            this.GoogleAuth.signIn().then(function () {
                _this3.GoogleUser = _this3.GoogleAuth.currentUser.get();
                var prof = _this3.GoogleUser.getBasicProfile();
                var profile = {
                    id: prof.getId(),
                    name: prof.getName(),
                    given_name: prof.getGivenName(),
                    family_name: prof.getFamilyName(),
                    image_url: prof.getImageUrl(),
                    email: prof.getEmail()
                };
                var auth = _this3.GoogleUser.getAuthResponse();
                resolve({ profile: profile, auth: auth });
            }).then(undefined, function (error) {
                console.error(error);
                reject(error);
            });
        }

        /**
         * The logout method.
         * @param {function} resolve
         * @param {function} reject
         * @static
         * @method logout
         * @public
         */

    }, {
        key: "logout",
        value: function logout(resolve, reject) {
            this.GoogleUser.disconnect();
            this.GoogleUser = null;
            resolve();
        }
    }]);

    return GoogleApi;
}(AbstractApi);

GoogleApi_GoogleApi.apiName = "Google";
GoogleApi_GoogleApi.url = "https://apis.google.com/js/platform.js";
GoogleApi_GoogleApi.params = {
    "clientid": null,
    "callback": null,
    "scope": "https://www.googleapis.com/auth/plus.login",
    "cookiepolicy": "none"
};
GoogleApi_GoogleApi.GoogleAuth = null;
GoogleApi_GoogleApi.GoogleUser = null;
/* harmony default export */ var api_GoogleApi = (GoogleApi_GoogleApi);
// CONCATENATED MODULE: ./src/foo/net/api/XeerpaApi.js









/**
 * Xeerpa social login helper class.
 * @author Mendieta
 * @class Xeerpa
 * @namespace net.api
 */

var XeerpaApi_Xeerpa = function (_AbstractApi) {
    inherits_default()(Xeerpa, _AbstractApi);

    function Xeerpa() {
        classCallCheck_default()(this, Xeerpa);

        return possibleConstructorReturn_default()(this, (Xeerpa.__proto__ || get_prototype_of_default()(Xeerpa)).apply(this, arguments));
    }

    createClass_default()(Xeerpa, null, [{
        key: "_load",


        /**
         * @default "WL"
         * @property WL
         * @type {string}
         * @static
         */

        /**
         * Google static string ID
         * @default "IG"
         * @property GO
         * @static
         * @type {string}
         */

        /**
         * LinkedIn static string ID
         * @default "LI"
         * @property LI
         * @static
         * @type {string}
         */
        value: function _load() {
            this._init();
        }

        /**
         * Initiates a login to a social network with Xeerpa.
         * @param {string} sn The social network string ID.
         * @param {Object} [data=null] The extra data to be sent, optional.
         * @param {function} resolve
         * @param {function} reject
         * @method login
         */


        /**
         * Callback to be called after Xeerpa response.
         * @property cb
         * @default null
         * @type {function}
         */

        /**
         * Instagram static string ID
         * @default "IG"
         * @property IG
         * @static
         * @type {string}
         */

        /**
         * Twitter static string ID
         * @default "TW"
         * @property TW
         * @static
         * @type {string}
         */


        /**
         * Facebook static string ID
         * @default "FB"
         * @property FB
         * @static
         * @type {string}
         */

    }, {
        key: "login",
        value: function login(resolve, reject) {
            var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var sn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";

            this._login(resolve, reject, data, sn);
        }
    }, {
        key: "loginAsync",
        value: function loginAsync() {
            var _this2 = this;

            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var sn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.FB;

            return new promise_default.a(function (resolve, reject) {
                _this2._login(resolve, reject, data, sn);
            });
        }
    }, {
        key: "_login",
        value: function _login(resolve, reject) {
            var _this3 = this;

            var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var sn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";

            this.timeout = undefined;
            this.resolveCb = resolve;
            var url = config_environment.properties.xeerpa;
            var apiURL = url + "?socialNetwork=" + sn + "&data=" + data;
            window.addEventListener("message", this._messageHandler, false);
            window.open(apiURL, "Login", "width=" + 500 + ", height=" + 475 + ", scrollbars=yes");
            if (navigator.appName === "Microsoft Internet Explorer" || !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv 11/))) {
                this._cookieInterval = window.setInterval(function () {
                    var data = _this3._readCookie();
                    if (data) {
                        window.clearInterval(_this3._cookieInterval);
                        _this3._receiveData(data);
                    }
                }, 100);
            }
            this._loginTimeout = window.setTimeout(function () {
                if (typeof _this3._cookieInterval === "number") window.clearInterval(_this3._cookieInterval);
                reject(new Error("Xeerpa login timeout was reached."));
            }, 3e4);
        }

        /**
         * Event handler for window message events.
         * @param {Event} event The event to be handled.
         * @private
         * @method _messageHandler
         */

    }, {
        key: "_readCookie",


        /**
         * Reads the cookie stored, and returns the value when appropriate.
         * @returns {Object} The user object data
         * @private
         * @method _readCookie
         */
        value: function _readCookie() {
            if (!document.cookie) return;
            var cookies = document.cookie.split(";");
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].split("=");
                if (cookie[0].trim() === "user") {
                    var value = cookie[1];
                    value = JSON.parse(value);
                    document.cookie = "user=;path=/;expires=" + new Date(Date.now() - 1000).toGMTString();
                    return value;
                }
            }
        }

        /**
         * Process the data sent from Xeerpa and calls callback.
         * @param {Object} data The object to be processed.
         * @private
         * @method _receiveData
         */

    }, {
        key: "_receiveData",
        value: function _receiveData(data) {
            // TODO: Conditionally remove listener, IE doesn't use it.
            window.removeEventListener("message", this._messageHandler);
            this._loginTimeout && window.clearTimeout(this._loginTimeout);
            this.resolveCb(data);
        }
    }]);

    return Xeerpa;
}(AbstractApi);

XeerpaApi_Xeerpa.apiName = "Xeerpa";
XeerpaApi_Xeerpa.FB = "FB";
XeerpaApi_Xeerpa.LI = "LI";
XeerpaApi_Xeerpa.TW = "TW";
XeerpaApi_Xeerpa.GO = "GO";
XeerpaApi_Xeerpa.IG = "IG";
XeerpaApi_Xeerpa.WL = "WL";
XeerpaApi_Xeerpa.cb = null;

XeerpaApi_Xeerpa._messageHandler = function (event) {
    if (typeof event.data !== "string") return;
    var data = JSON.parse(event.data);
    if (data.socialNetwork) XeerpaApi_Xeerpa._receiveData(data);
};

/* harmony default export */ var XeerpaApi = (XeerpaApi_Xeerpa);
// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./src/app/utils/core/Api.js







var Api_Api = function () {
    function Api() {
        classCallCheck_default()(this, Api);

        this._endpoints = freeze_default()({});
    }

    createClass_default()(Api, [{
        key: 'endpoints',
        get: function get() {
            return this._endpoints;
        }

        /**
         * @param {string} endpoint
         * @param {{}=} data
         */

    }], [{
        key: 'post',
        value: function () {
            var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(endpoint, data) {
                var response;
                return regenerator_default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return client_default.a.post(endpoint).send(data);

                            case 2:
                                response = _context.sent;

                                if (!(response.status === 200)) {
                                    _context.next = 7;
                                    break;
                                }

                                return _context.abrupt('return', response);

                            case 7:
                                throw response;

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function post(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return post;
        }()

        /**
         * @param {string} endpoint
         */

    }, {
        key: 'get',
        value: function () {
            var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(endpoint) {
                var response;
                return regenerator_default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return client_default.a.get(endpoint);

                            case 2:
                                response = _context2.sent;

                                if (!(response.status === 200)) {
                                    _context2.next = 7;
                                    break;
                                }

                                return _context2.abrupt('return', response);

                            case 7:
                                throw response;

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function get(_x3) {
                return _ref2.apply(this, arguments);
            }

            return get;
        }()
    }]);

    return Api;
}();

/* harmony default export */ var core_Api = (Api_Api);
// CONCATENATED MODULE: ./src/foo/net/AuthManager.js








/**
 * Authentication manager class.
 * @class AuthManager
 * @namespace core
 * @author Mendieta
 */

var AuthManager_AuthManager = function () {
    function AuthManager() {
        classCallCheck_default()(this, AuthManager);
    }

    createClass_default()(AuthManager, null, [{
        key: "login",


        /**
         * Login into the requested service.
         * @param {string} service The service to use for login
         * @param {object} [data=null] The user login data
         * @param {string} [xs="FB"] The Xeerpa social network ID to login into.
         * @static
         * @method login
         * @return {Promise}
         */


        /**
         * Services struct.
         * @property services
         * @static
         * @default {XE:string,FB: string, GO: string, API: string}
         * @type {Object}
         */
        value: function login(service) {
            var _this = this;

            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var xs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "FB";

            return new promise_default.a(function (resolve, reject) {
                var staticApi = _this.apis[service];
                if (staticApi) {
                    staticApi.login(resolve, reject, data, xs);
                } else {
                    console.error("AuthManager:", "Supplied service: " + service + " is not defined!");
                    reject(new Error("Error"));
                }
            });
        }

        /**
         * Calls a register method on the APi endpoint.
         * @method register
         * @static
         * @param {string} service The service to be used for register action.
         * @param {Object} data The data to be sent to the register method.
         */


        /**
         * @property apis
         * @static
         * @private
         * @type {{xeerpa, facebook, google, api}}
         */

    }, {
        key: "register",
        value: function register(service, data) {
            var _this2 = this;

            return new promise_default.a(function (resolve, reject) {
                switch (service) {
                    case _this2.services.API:
                        core_Api.register(data);
                        break;
                    default:
                        console.error("AuthManager:", "Supplied service: " + service + " is not defined for the register action!");
                        reject(new Error("Error"));
                }
            });
        }

        /**
         * Logs out the user.
         * @method logout
         * @static
         * @return Promise
         */

    }, {
        key: "logout",
        value: function logout() {
            return core_Api.logout();
        }
    }]);

    return AuthManager;
}();

AuthManager_AuthManager.services = {
    XE: "xeerpa",
    FB: "facebook",
    GO: "google",
    API: "api"
};
AuthManager_AuthManager.apis = {
    "xeerpa": XeerpaApi,
    "facebook": FacebookApi,
    "google": api_GoogleApi,
    "api": core_Api
};
/* harmony default export */ var net_AuthManager = (AuthManager_AuthManager);
// CONCATENATED MODULE: ./src/app/store/modules/user.js



var user__actions, user__mutations;

/**
 * Created by mendieta on 11/7/16.
 */



var LOGIN = "user/login";
var REGISTER = "user/register";
var LOGOUT = "user/logout";
var LOGGING_IN = "user/logging_in";

var user_state = {
    logged: false,
    logging: false,
    facebook: null,
    google: null,
    xeerpa: null,
    api: null
};

var user_actions = (user__actions = {}, defineProperty_default()(user__actions, LOGIN, function (_ref, payload) {
    var commit = _ref.commit;

    return new promise_default.a(function (resolve, reject) {
        commit(LOGGING_IN, true);
        net_AuthManager.login(payload.service, payload.data, payload.xs).then(function (response) {
            commit(LOGIN, { network: payload.service, response: response });
            resolve(response);
            commit(LOGGING_IN, false);
        }).catch(function (error) {
            commit(LOGGING_IN, false);
            reject(error);
        });
    });
}), defineProperty_default()(user__actions, REGISTER, function (_ref2, payload) {
    var commit = _ref2.commit;

    commit(REGISTER, payload);
}), defineProperty_default()(user__actions, LOGOUT, function (_ref3, payload) {
    var commit = _ref3.commit;

    commit(LOGOUT, payload);
}), user__actions);

var user_mutations = (user__mutations = {}, defineProperty_default()(user__mutations, LOGIN, function (state, payload) {
    state.logged = true;
    state[payload.network] = payload.response;
}), defineProperty_default()(user__mutations, LOGGING_IN, function (state, payload) {
    state.logging = payload;
}), defineProperty_default()(user__mutations, REGISTER, function (state, data) {
    state.error = null;
    state.register_data = data;
}), defineProperty_default()(user__mutations, LOGOUT, function (state) {
    state.error = null;
    state.logged = false;
}), user__mutations);

var user_getters = {
    loggedIn: function loggedIn(state) {
        return state.logged;
    }
};

/* harmony default export */ var user = ({ state: user_state, actions: user_actions, mutations: user_mutations, getters: user_getters });
// CONCATENATED MODULE: ./src/app/store/modules/background.js


var background__mutations;

var MAIN_NAV_VISIBLE = 'mainNav/main-nav';
var BG_VISIBLE = 'mainNav/bg-visible';
var RIBBON_VISIBLE = 'mainNav/ribbon-visible';
var IS_DRAGGING = 'mainNav/is-dragging';
var IS_IN_HOME = 'mainNav/is-in-home';
var BG_ACTIVE_INDEX = 'mainNav/active-index';

var background_state = {
    mainNavVisible: false,
    backgroundVisible: false,
    ribbonVisible: false,
    isDragging: false,
    isInHome: false,
    activeIndex: 0
};

var background_actions = {};

var background_mutations = (background__mutations = {}, defineProperty_default()(background__mutations, MAIN_NAV_VISIBLE, function (state, payload) {
    state.mainNavVisible = payload;
}), defineProperty_default()(background__mutations, BG_VISIBLE, function (state, payload) {
    state.backgroundVisible = payload;
}), defineProperty_default()(background__mutations, RIBBON_VISIBLE, function (state, payload) {
    state.ribbonVisible = payload;
}), defineProperty_default()(background__mutations, IS_DRAGGING, function (state, payload) {
    state.isDragging = payload;
}), defineProperty_default()(background__mutations, IS_IN_HOME, function (state, payload) {
    state.isInHome = payload;
}), defineProperty_default()(background__mutations, BG_ACTIVE_INDEX, function (state, payload) {
    state.activeIndex = payload;
}), background__mutations);

var background_getters = {
    mainNavVisible: function mainNavVisible(state) {
        return state.mainNavVisible;
    },
    backgroundVisible: function backgroundVisible(state) {
        return state.backgroundVisible;
    },
    ribbonVisible: function ribbonVisible(state) {
        return state.ribbonVisible;
    },
    isDragging: function isDragging(state) {
        return state.isDragging;
    },
    isInHome: function isInHome(state) {
        return state.isInHome;
    },
    activeIndex: function activeIndex(state) {
        return state.activeIndex;
    }
};

/* harmony default export */ var background = ({ state: background_state, actions: background_actions, mutations: background_mutations, getters: background_getters });
// CONCATENATED MODULE: ./src/app/store/index.js
/**
 * Created by mendieta on 10/23/16.
 */








vue_runtime_esm["a" /* default */].use(vuex_esm["b" /* default */]);

var store_state = {};

/* harmony default export */ var store = (new vuex_esm["a" /* Store */]({
    state: store_state,
    modules: {
        app: app,
        loader: modules_loader,
        user: user,
        background: background
    },
    plugins: []
}));
// CONCATENATED MODULE: ./src/foo/core/locale/LocaleManager.js










var LocaleManager_LocaleManager = function () {
    function LocaleManager() {
        classCallCheck_default()(this, LocaleManager);
    }

    createClass_default()(LocaleManager, null, [{
        key: "setup",


        /**
         * @method setup
         * @static
         * @return {void}
         */

        /**
         * @property i18n
         * @type {VueI18n}
         * @static
         */
        value: function setup() {
            vue_runtime_esm["a" /* default */].use(vue_i18n_esm["a" /* default */]);
            this.i18n = new vue_i18n_esm["a" /* default */]({
                locale: config_config.locale
            });
        }

        /**
         * App locales loaded
         * @type {Array}
         * @default []
         * @property loadedLocales
         * @public
         * @static
         */

    }, {
        key: "loadLocale",


        /**
         * Method that loads the current locale and (re)renders the App
         * @public
         * @param {string=} localeId - locale to load
         * @returns {Promise}
         */
        value: function loadLocale(localeId) {
            var promise = void 0;
            if (!localeId) {
                var userLocale = LocaleManager.userLocale.get();
                localeId = userLocale || config_config.locale;
            }
            if (LocaleManager.loadedLocales.indexOf(localeId) !== -1) {
                promise = promise_default.a.resolve();
            } else {
                store.dispatch(LOCALE_LOADING);
                promise = client_default.a.get(store.getters.public + "/data/locale/" + localeId + ".json").catch(function (error) {
                    return console.error("Failed to load locale: " + error);
                }).then(function (response) {
                    LocaleManager.loadedLocales.push(localeId);
                    LocaleManager.i18n.setLocaleMessage(localeId, response.body);
                    LocaleManager.userLocale.set(localeId);
                });
            }
            return promise.then(function () {
                LocaleManager.updateLocale(localeId);
            });
        }

        /**
         * @method updateLocale
         * @private
         * @static
         * @param {string} localeId
         */

    }, {
        key: "updateLocale",
        value: function updateLocale(localeId) {
            LocaleManager.i18n.locale = localeId;
            store.dispatch(LOCALE_CHANGED, localeId);
        }

        /**
         * The current locale
         * @default "es-MX"
         * @property activeLocale
         * @type {string}
         * @static
         * @public
         */

    }, {
        key: "activeLocale",
        get: function get() {
            return LocaleManager.i18n.locale;
        }
    }]);

    return LocaleManager;
}();

LocaleManager_LocaleManager.loadedLocales = [];
LocaleManager_LocaleManager.userLocale = {
    /**
     * Save current session locale in local storage
     * @param {string} locale
     */
    set: function set(locale) {
        localStorage.setItem('user-locale', locale);
    },

    /**
     * Get user last session locale from local storage
     * @returns {string}
     */
    get: function get() {
        return localStorage.getItem('user-locale');
    }
};
/* harmony default export */ var locale_LocaleManager = (LocaleManager_LocaleManager);
// CONCATENATED MODULE: ./src/foo/core/AbstractApp.js









var AbstractApp_AbstractApp = function () {

  /**
   * @constructor
   */


  /**
   * @property config
   * @default null
   * @type {Object}
   */


  /**
   * The app window width
   * @property width
   * @type {Number}
   */


  /**
   * App initial load data
   * @default {}
   * @property data
   * @type {Object}
   */


  /**
   *
   * @type {Signal}
   */

  /**
   * Signal dispatching on app animationFrame
   * @property rendered
   * @type {signals.Signal}
   */
  function AbstractApp() {
    var _this = this;

    classCallCheck_default()(this, AbstractApp);

    this.render = new signals["Signal"]();
    this.resize = new signals["Signal"]();
    this.mouseMove = new signals["Signal"]();
    this.DEBUG = config_environment.vars.debug;
    this.started = false;
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.config = null;
    this.environment = null;
    this._onResize = throttle_default()(function () {
      _this.width = window.innerWidth;
      _this.height = window.innerHeight;
      _this.resize.dispatch({ width: _this.width, height: _this.height });
    }, 250);

    this.setup();
    promise_default.a.all([locale_LocaleManager.loadLocale()]).then(function () {
      _this.start();
    });
  }

  /**
   * @method setup
   * @private
   * @return {void}
   */


  /**
   * @property environment
   * @default null
   * @type {Object}
   */


  /**
   * The app window height
   * @property height
   * @type {Number}
   */


  /**
   *  Defines if the App has started
   *  @property started
   *  @default false
   *  @type {boolean}
   */


  /**
   * The app debug flag
   * @property DEBUG
   * @type {boolean}
   */


  /**
   * Signal dispatching on ap resize
   * @property resize
   * @type {signals.Signal}
   */


  createClass_default()(AbstractApp, [{
    key: "setup",
    value: function setup() {
      this.setupDebug();
      locale_LocaleManager.setup();
    }

    /**
     * @method setupDebug
     * @private
     * @returns {void}
     */

  }, {
    key: "setupDebug",
    value: function setupDebug() {
      this.DEBUG = config_environment.vars.config;
      this.data = data_default.a;
      if (this.DEBUG) {
        console.info("Foo: Start App");
        this.config = config_config;
        this.environment = config_environment;
      }
    }

    /**
     * Starts App, override if needed custom initialization.
     * @protected
     * @method start
     * @returns {void}
     */

  }, {
    key: "start",
    value: function start() {
      this.started = true;
      this._addListeners();
      this.renderApp();
      if (this.DEBUG) console.info("Foo: App Rendered");
    }

    /**
     * Method to be overridden, render logic
     * @abstract
     * @override
     * @method renderApp
     * @returns {void}
     */

  }, {
    key: "renderApp",
    value: function renderApp() {}

    /**
     * Method that init listeners depending on the App config
     * @private
     * @method _addListeners
     * @returns {void}
     */

  }, {
    key: "_addListeners",
    value: function _addListeners() {
      if (config_config.vars.resize) window.addEventListener("resize", this._onResize);
      if (config_config.vars.animate) this._animate();
    }

    /**
     * Window resize event handler
     * @param {Event} e The event object
     * @private
     * @method _onResize
     * @returns {void}
     */

  }, {
    key: "_animate",


    /**
     * Method that loops animation frameworks
     * @private
     * @method _animate
     * @returns {void}
     */
    value: function _animate() {
      var _this2 = this;

      requestAnimationFrame(function () {
        _this2.render.dispatch();
        _this2._animate();
      });
    }
  }]);

  return AbstractApp;
}();

/* harmony default export */ var core_AbstractApp = (AbstractApp_AbstractApp);
// CONCATENATED MODULE: ./src/foo/core/VueFoo.js



var VueFoo = {};

VueFoo.install = function (Vue) {
    // LOCALE
    Vue.prototype.$setLocale = locale_LocaleManager.loadLocale;
    Vue.setLocale = locale_LocaleManager.loadLocale;

    // SUPERAGENT || HTTP
    Vue.prototype.$get = client_default.a.get;
    Vue.prototype.$post = client_default.a.post;
    Vue.prototype.$delete = client_default.a.del;
    Vue.prototype.$head = client_default.a.head;
    Vue.prototype.$put = client_default.a.put;
    Vue.prototype.$patch = client_default.a.patch;
};

/* harmony default export */ var core_VueFoo = (VueFoo);
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: ./src/foo/tracking/adapters/AnalyticsAdapter.js



/**
 * Created by mendieta on 4/27/17.
 */

var AnalyticsAdapter_AnalyticsAdapter = function () {
  function AnalyticsAdapter() {
    classCallCheck_default()(this, AnalyticsAdapter);
  }

  createClass_default()(AnalyticsAdapter, null, [{
    key: "load",


    /**
     * Loads the analytics Adapter SDK
     * @method load
     * @public
     * @static
     * @param {string|null} ID[default=null]
     * @return {Promise}
     */
    value: function load() {
      var ID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    }

    /**
     * Tracks a page for the given route.
     * @public
     * @static
     * @method trackPage
     * @param {string} route The route to be tracked
     */

  }, {
    key: "trackPage",
    value: function trackPage(route) {}

    /**
     * Tracks an event for the given event descriptor.
     * @public
     * @static
     * @method trackEvent
     * @param {object} event The event descriptor
     */

  }, {
    key: "TrackEvent",
    value: function TrackEvent(event) {}
  }]);

  return AnalyticsAdapter;
}();

/* harmony default export */ var adapters_AnalyticsAdapter = (AnalyticsAdapter_AnalyticsAdapter);
// CONCATENATED MODULE: ./src/foo/tracking/adapters/GoogleAnalyticsAdapter.js







/**
 * Created by mendieta on 4/27/17.
 */


var GoogleAnalyticsAdapter_GoogleAnalyticsAdapter = function (_AnalyticsAdapter) {
    inherits_default()(GoogleAnalyticsAdapter, _AnalyticsAdapter);

    function GoogleAnalyticsAdapter() {
        classCallCheck_default()(this, GoogleAnalyticsAdapter);

        return possibleConstructorReturn_default()(this, (GoogleAnalyticsAdapter.__proto__ || get_prototype_of_default()(GoogleAnalyticsAdapter)).apply(this, arguments));
    }

    createClass_default()(GoogleAnalyticsAdapter, null, [{
        key: 'load',
        value: function load(ID) {
            return new promise_default.a(function (resolve) {
                (function (i, s, o, g, r, a, m) {
                    /* eslint-disable */
                    i['GoogleAnalyticsObject'] = r;
                    i[r] = i[r] || function () {
                        (i[r].q = i[r].q || []).push(arguments);
                    }, i[r].l = 1 * new Date();
                    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
                    a.async = 1;
                    a.src = g;
                    m.parentNode.insertBefore(a, m);
                })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
                ga('create', ID, 'auto');
                ga('send', 'pageview');
                resolve();
            });
        }
    }, {
        key: 'trackPage',
        value: function trackPage(route) {
            window.ga("set", "page", route);
            window.ga("send", "pageview");
        }
    }, {
        key: 'trackEvent',
        value: function trackEvent(event) {
            var args = ["send", "event"];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(event), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _window;

                    var arg = _step.value;

                    args.push(arg);
                    (_window = window).ga.apply(_window, args);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }]);

    return GoogleAnalyticsAdapter;
}(adapters_AnalyticsAdapter);

/* harmony default export */ var adapters_GoogleAnalyticsAdapter = (GoogleAnalyticsAdapter_GoogleAnalyticsAdapter);
// CONCATENATED MODULE: ./src/foo/tracking/adapters/AnalyticsAdapterManager.js




/**
 * Created by mendieta on 4/27/17.
 */


var AnalyticsAdapterManager_AnalyticsAdapterManager = function () {
    function AnalyticsAdapterManager() {
        classCallCheck_default()(this, AnalyticsAdapterManager);
    }

    createClass_default()(AnalyticsAdapterManager, null, [{
        key: "load",
        value: function load(adapters) {
            var _this = this;

            return new promise_default.a(function (resolve) {
                var promises = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = get_iterator_default()(adapters), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _ref = _step.value;
                        var adapter = _ref.adapter,
                            id = _ref.id;

                        var adapterLoader = _this.adapters[adapter];
                        if (adapterLoader) {
                            promises.push(adapterLoader.load(id));
                        } else {
                            console.warn("AnalyticsAdapterLoader: no adapter found for " + adapter);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                promise_default.a.all(promises).then(function () {
                    resolve();
                });
            });
        }
    }, {
        key: "trackPage",
        value: function trackPage(route, adapters) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = get_iterator_default()(adapters), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _ref2 = _step2.value;
                    var adapter = _ref2.adapter;

                    this.adapters[adapter].trackPage(route);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }, {
        key: "trackEvent",
        value: function trackEvent(event, adapters) {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = get_iterator_default()(adapters), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var _ref3 = _step3.value;
                    var adapter = _ref3.adapter;

                    this.adapters[adapter].trackEvent(event);
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    }]);

    return AnalyticsAdapterManager;
}();

AnalyticsAdapterManager_AnalyticsAdapterManager.adapters = {
    "google": adapters_GoogleAnalyticsAdapter
};
/* harmony default export */ var adapters_AnalyticsAdapterManager = (AnalyticsAdapterManager_AnalyticsAdapterManager);
// EXTERNAL MODULE: ./src/config/tracking.json
var tracking = __webpack_require__("jUnm");
var tracking_default = /*#__PURE__*/__webpack_require__.n(tracking);

// CONCATENATED MODULE: ./src/foo/tracking/VueAnalytics.js
/**
 * Created by mendieta on 4/27/17.
 */





/**
 * The analytics default route page.
 * @property currentRoute
 * @default ""
 * @type {string}
 */
var currentRoute = "";

/**
 * Defines if the analytics has loaded.
 * @property loaded
 * @default false
 * @type {boolean}
 */
var VueAnalytics_loaded = false;

/**
 * The analytics adapter keys array
 * @property adapters
 * @default null
 * @type {Array}
 */
var VueAnalytics_adapters = null;

/**
 * Vue installer
 * @param  {Vue} Vue
 * @param  {Object} [options={}]
 */
function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    VueAnalytics_adapters = options.adapters;
    adapters_AnalyticsAdapterManager.load(VueAnalytics_adapters).then(function () {
        VueAnalytics_loaded = true;
        store.subscribe(handleTracking);
    });

    Vue.prototype.$trackEvent = VueAnalytics_trackEvent;
    Vue.prototype.$trackPage = VueAnalytics_trackPage;
    Vue.trackPage = VueAnalytics_trackPage;
    Vue.trackEvent = VueAnalytics_trackEvent;
}

/**
 * Handles the router route mutations.
 * @param {Object} mutation The store mutation that dispatched the handler.
 * @private
 * @method handleTracking
 */
function handleTracking(mutation) {
    if (mutation.type === "router/ROUTE_CHANGED") {
        currentRoute = mutation.payload.to.path;
        VueAnalytics_trackPage(currentRoute);
    }
}

/**
 * Tracks a page view, with the specified route.
 * @param {string} route Route of the tracking tag to be pushed on analytics adapter(s).
 * @method trackPage
 */
function VueAnalytics_trackPage(route) {
    if (!VueAnalytics_loaded) return;
    if (route) {
        if (config_environment.vars.debug) console.info("Track Page View:", route);
        adapters_AnalyticsAdapterManager.trackPage(route, VueAnalytics_adapters);
    } else {
        console.warn("VueAnalytics: no route passed to trackPage");
    }
}

/**
 * Search for a match on the tracking data and pushes to analytics adapter(s).
 * @param {string} event Param of the tracking tag to be pushed on analytics.
 * @method trackEvent
 */
function VueAnalytics_trackEvent(event) {
    if (!VueAnalytics_loaded) return;
    if (event) {
        var data = tracking_default.a[event];
        if (data) {
            if (config_environment.vars.debug) console.info("Track Event:", data);
            adapters_AnalyticsAdapterManager.trackEvent(event, VueAnalytics_adapters);
        } else {
            console.warn("VueAnalytics: no data found for " + event + " event");
        }
    } else {
        console.warn("VueAnalytics: no event passed to trackEvent");
    }
}

/* harmony default export */ var VueAnalytics = ({ install: install });
// EXTERNAL MODULE: ./node_modules/vue-youtube/dist/vue-youtube.js
var vue_youtube = __webpack_require__("H5Ot");
var vue_youtube_default = /*#__PURE__*/__webpack_require__.n(vue_youtube);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/app/mixins/ChapterUtils.js




/* harmony default export */ var ChapterUtils = ({
    methods: {
        gotoNextChapter: function gotoNextChapter() {
            var _nextChapter = this.nextChapter,
                id = _nextChapter.id,
                number = _nextChapter.number;

            this.updateActiveChapterId(id, number);
        },
        gotoPreviousChapter: function gotoPreviousChapter() {
            var _previousChapter = this.previousChapter,
                id = _previousChapter.id,
                number = _previousChapter.number;

            this.updateActiveChapterId(id, number);
        },
        updateActiveChapterId: function updateActiveChapterId(id, number) {
            var $store = this.$store;

            $store.commit(ACTIVE_CHAPTER_ID, id);
            $store.commit(BG_ACTIVE_INDEX, number);
        },
        filterChapterById: function filterChapterById(id) {
            var chapters = this.chapters;

            return lodash["find"](chapters, function (chapter) {
                return chapter.id === id;
            });
        },
        getChapterById: function getChapterById(id) {
            var chapters = this.chapters;

            return lodash["find"](chapters, function (chapter) {
                return chapter.number === id;
            });
        },
        setBackgroundVisible: function setBackgroundVisible(payload) {
            var $store = this.$store;

            $store.commit(BG_VISIBLE, payload);
        }
    },
    computed: {
        data: function data() {
            var $store = this.$store;

            return $store.getters.data;
        },
        assets: function assets() {
            var $store = this.$store;

            return $store.getters.public;
        },
        chapters: function chapters() {
            var data = this.data;

            return data.chapters;
        },
        chapterNameList: function chapterNameList() {
            var chapters = this.chapters;

            return chapters.map(function (chapter) {
                return chapter.name;
            });
        },
        chapterVideoSrcList: function chapterVideoSrcList() {
            var chapters = this.chapters,
                assets = this.assets;

            var directory = assets + '/video/';
            return chapters.map(function (chapter) {
                if (chapter.hasVideo) return '' + directory + chapter.videoSrc;
                return null;
            });
        },
        chapterVideoCoverList: function chapterVideoCoverList() {
            var chapters = this.chapters,
                assets = this.assets;

            var directory = assets + '/img/';
            return chapters.map(function (chapter) {
                return '' + directory + chapter.videoCover;
            });
        },
        activeChapterIndex: function activeChapterIndex() {
            var chapters = this.chapters,
                activeChapterId = this.activeChapterId;

            return lodash["findIndex"](chapters, function (chapter) {
                return chapter.id === activeChapterId;
            });
        },
        activeChapterId: function activeChapterId() {
            var $store = this.$store;

            return $store.getters.activeChapterId;
        },
        activeChapter: function activeChapter() {
            var _this = this;

            var chapters = this.chapters,
                activeChapterId = this.activeChapterId;

            if (activeChapterId) {
                return lodash["find"](chapters, function (chapter) {
                    return chapter.id === _this.activeChapterId;
                });
            } else {
                throw Error('activeChapterId nas not been defined');
            }
        },
        activeChapterArtwork: function activeChapterArtwork() {
            var activeChapter = this.activeChapter,
                assets = this.assets;

            var directory = assets + '/img/';
            return activeChapter.artwork.map(function (url) {
                return '' + directory + url;
            });
        },
        firstChapter: function firstChapter() {
            var chapters = this.chapters;

            return chapters[0];
        },
        lastChapter: function lastChapter() {
            var chapters = this.chapters;

            return lodash["last"](chapters);
        },
        nextChapter: function nextChapter() {
            var activeChapterIndex = this.activeChapterIndex,
                chapters = this.chapters;

            if (activeChapterIndex === chapters.length - 1) {
                return this.firstChapter;
            } else {
                return chapters[activeChapterIndex + 1];
            }
        },
        previousChapter: function previousChapter() {
            var activeChapterIndex = this.activeChapterIndex,
                chapters = this.chapters;

            if (activeChapterIndex === 0) {
                return this.lastChapter;
            } else {
                return chapters[activeChapterIndex - 1];
            }
        }
    }
});
// CONCATENATED MODULE: ./src/foo/utils/MathUtils.js
/**
     * Calculates the angle of a vector.
     * @param {number} x the x component of the vector
     * @param {number} y the y component of the vector
     * @returns {number} The the angle of the passed vector in degrees.
     */
function getVectorAngle(x, y) {
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * Calculates the angle between two points.
 * @param {object} p1
 * @param {object} p2
 * @return {number}
 */
function getPointsAngle() {
    var p1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { x: 0, y: 0 };
    var p2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { x: 0, y: 0 };

    return Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180 / Math.PI;
}

/**
 *
 * @param probability specified probability (0 to 1) that the random "event" occurs
 * @return {boolean}
 */
function chance(probability) {
    return Math.random() <= probability;
}

/**
 * The <code>normalize</code> method
 * @param {number} value The value
 * @param {number} min The min value
 * @param {number} max The max value
 * @returns {number} the normalize result
 */
function normalize(value, min, max) {
    return (value - min) / (max - min);
}

/**
 * The <code>interpolate</code> method
 * @param {number} value The value
 * @param {number} min The min value
 * @param {number} max the max value
 * @returns {number} The interpolation result
 */
function interpolate(value, min, max) {
    return min + (max - min) * value;
}

/**
 * The <code>map</code> method
 * @param {number} value The value
 * @param {number} min1 The min 1 value
 * @param {number} max1 The max 1 value
 * @param {number} min2 The min 2 value
 * @param {number} max2 the max 2 value
 * @returns {number} The map result
 */
function map(value, min1, max1, min2, max2) {
    return interpolate(normalize(value, min1, max1), min2, max2);
}

/**
 * The <code>findPreferredRatio</code> is used to find the correct ratio to fit content in a container using a maximum area.
 * @param {number} width The width
 * @param {number} height The height
 * @param {number} maxWidth The max width
 * @param {number} maxHeight The max height
 * @returns {number} The preferred radio
 */
function findPreferredRatio(width, height, maxWidth, maxHeight) {
    var dw = maxWidth / width;
    var dh = maxHeight / height;
    return dw < dh ? dw : dh;
}

/**
 * The <code>limit()</code> method checks if a given value is within a specific range.
 *  It returns the value if it's within the range.
 *  It returns the min/max value if the value is lower/higher than the min/max.
 * @param {number} value The value
 * @param {number} min The min value
 * @param {number} max The max value
 * @returns {number} The number limited
 */
function MathUtils_limit(value, min, max) {
    return Math.min(Math.max(min, value), max);
}

/**
 * The <code>roundNumber()</code> method
 * @param {number} val Specifies the Number to round.
 * @param {number} [digits=0] Specifies the digits after the comma.
 * @returns {number} The number rounbded
 */
function roundNumber(val) {
    var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var factor = Math.pow(10, digits);
    return Math.round(val * factor) / factor;
}

/**
 * The <code>degreesToRadians()</code> method calculates degrees to radians
 * @param {number} degrees The degrees to be transformed
 * @returns {number} The angle in radians
 */
function degreesToRadians(degrees) {
    return degrees * (Math.PI / 180);
}

/**
 * The <code>degreesToRadians()</code> method calculates degrees to radians
 * @param {number} radians the radians to be transformed
 * @returns {number} The angle in degrees
 */
function radiansToDegrees(radians) {
    return radians * (180 / Math.PI);
}

/**
 * Return a random floating-point number.
 *
 * Takes either 0, 1 or 2 arguments.
 *
 * If no argument is given, returns a random number from 0
 * up to (but not including) 1.
 *
 * If one argument is given and it is a number, returns a random number from 0
 * up to (but not including) the number.
 *
 * If one argument is given and it is an array, returns a random element from
 * that array.
 *
 * If two arguments are given, returns a random number from the
 * first argument up to (but not including) the second argument.
 *
 * @see {@link https://bit.ly/2TUEddV} P5 Source
 * @param {Number|Array=} min
 * @param {Number=} max
 */
function random(min, max) {
    var rand = Math.random();
    if (typeof min === 'undefined') {
        return rand;
    } else if (typeof max === 'undefined') {
        if (min instanceof Array) {
            return min[Math.floor(rand * min.length)];
        } else {
            return rand * min;
        }
    } else {
        if (min > max) {
            var tmp = min;
            min = max;
            max = tmp;
        }
        return rand * (max - min) + min;
    }
};

/* harmony default export */ var MathUtils = ({
    getVectorAngle: getVectorAngle,
    getPointsAngle: getPointsAngle,
    chance: chance,
    normalize: normalize,
    interpolate: interpolate,
    map: map,
    findPreferredRatio: findPreferredRatio,
    limit: MathUtils_limit,
    roundNumber: roundNumber,
    degreesToRadians: degreesToRadians,
    radiansToDegrees: radiansToDegrees
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/IntroLogo.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var IntroLogo = ({
    name: 'IntroLogo',
    props: {
        introDelay: {
            type: Number,
            default: 0
        },
        charMinDuration: {
            type: Number,
            default: 1
        },
        charMaxDuration: {
            type: Number,
            default: 2
        },
        outroDelay: {
            type: Number,
            default: 0
        },
        outroDuration: {
            type: Number,
            default: 0.75
        }
    },
    methods: {
        intro: function intro($el, done) {
            var _this = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                var $refs, tweens;
                return regenerator_default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                $refs = _this.$refs;
                                // Reset container opacity

                                TweenLite.set($el, { alpha: 1 });
                                // Single char tween
                                tweens = $refs.chars.map(function (char) {
                                    return _this.getCharTween(char);
                                });
                                // Add background number anim to tweens

                                tweens.push(_this.getNumberTween());
                                // Wait until all tweens finish to call done
                                _context.next = 6;
                                return promise_default.a.all(tweens);

                            case 6:
                                done();

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        outro: function outro($el, done) {
            var outroDelay = this.outroDelay,
                outroDuration = this.outroDuration;

            TweenLite.to($el, outroDuration, {
                alpha: 0,
                ease: Cubic.easeOut,
                delay: outroDelay,
                onComplete: done
            });
        },
        getNumberTween: function getNumberTween() {
            var _this2 = this;

            return new promise_default.a(function (resolve, reject) {
                var $refs = _this2.$refs,
                    introDelay = _this2.introDelay,
                    charMaxDuration = _this2.charMaxDuration;

                TweenLite.fromTo($refs.number, charMaxDuration, { alpha: 0 }, {
                    alpha: 1,
                    delay: introDelay,
                    onComplete: resolve
                });
            });
        },
        getCharTween: function getCharTween(char) {
            var _this3 = this;

            return new promise_default.a(function (resolve) {
                var charMinDuration = _this3.charMinDuration,
                    charMaxDuration = _this3.charMaxDuration,
                    introDelay = _this3.introDelay;

                var duration = random(charMinDuration, charMaxDuration);
                var delay = introDelay + charMaxDuration - duration;
                TweenLite.fromTo(char, duration, { alpha: 0 }, {
                    alpha: 1,
                    delay: delay,
                    onComplete: resolve
                });
            });
        }
    },
    computed: {
        data: function data() {
            var $store = this.$store;

            return $store.getters.data.intro.logo;
        },
        stageStyle: function stageStyle() {
            var data = this.data;

            return {
                'width': data.width + 'px',
                'height': data.height + 'px'
            };
        },
        stageViewBox: function stageViewBox() {
            var data = this.data;

            return '0 0 ' + data.width + ' ' + data.height;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d1de7a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/IntroLogo.vue
var IntroLogo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.intro,"leave":_vm.outro}},[_c('div',{staticClass:"IntroLogo"},[_c('svg',{staticClass:"IntroLogo-stage",style:(_vm.stageStyle),attrs:{"viewBox":_vm.stageViewBox}},[_c('path',{ref:"number",staticClass:"IntroLogo-number",attrs:{"d":_vm.data.number}}),_vm._v(" "),_vm._l((_vm.data.chars),function(char,i){return _c('path',{key:i,ref:"chars",refInFor:true,staticClass:"IntroLogo-char",attrs:{"d":char}})})],2)])])}
var staticRenderFns = []
var esExports = { render: IntroLogo_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_IntroLogo = (esExports);
// CONCATENATED MODULE: ./src/app/components/IntroLogo.vue
function injectStyle (ssrContext) {
  __webpack_require__("KF8U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  IntroLogo,
  components_IntroLogo,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var app_components_IntroLogo = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__("2R8v");
var taggedTemplateLiteral_default = /*#__PURE__*/__webpack_require__.n(taggedTemplateLiteral);

// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 48 modules
var es = __webpack_require__("xu65");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/TextBarrel.vue


var _templateObject = taggedTemplateLiteral_default()(['', ' is not a valid number for faces\n                    prop, number must be odd and at least 3 faces are needed.'], ['', ' is not a valid number for faces\n                    prop, number must be odd and at least 3 faces are needed.']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var TextBarrel = ({
    name: 'TextBarrel',
    props: {
        introDelay: {
            type: Number,
            defautl: 0
        },
        introDuration: {
            type: Number,
            default: 3
        },
        outroDelay: {
            type: Number,
            default: 0
        },
        outroDuration: {
            type: Number,
            default: 0.75
        },
        text: {
            type: Array,
            required: true
        },
        /**
         * Relation between this `$el` height and perspective, being 1 the total
         * height set as the perspective.
         */
        perspectiveRatio: {
            type: Number,
            default: 1
        },
        /**
         * Relation between this `$el` height and depth, being 1 the total
         * height set as the depth.
         */
        depthRatio: {
            type: Number,
            default: -0.8
        },
        faces: {
            default: 7,
            validator: function validator(val) {
                if (val % 2 === 0 || val < 3) {
                    console.error(Object(es["a" /* oneLine */])(_templateObject, val));
                    return false;
                }
                return true;
            }
        },
        acceleration: {
            type: Number,
            default: 0.1
        },
        maxVelocity: {
            type: Number,
            default: 2
        },
        tiltMaxAngle: {
            type: Number,
            default: degreesToRadians(10)
        },
        tiltFriction: {
            type: Number,
            default: 0.05
        }
    },
    data: function data() {
        return {
            activeText: [],
            textIndex: 0,
            perspective: 0,
            depth: 0,
            angle: 0,
            maxAngle: 0,
            velocity: 0,
            isAnimating: false,
            faceSize: {
                width: 0,
                height: 0
            },
            animProgress: [],
            mouse: {
                x: 0,
                y: 0
            },
            tilt: {
                x: 0,
                y: 0,
                angleX: 0,
                angleY: 0
            }
        };
    },

    methods: {
        intro: function intro($el, done) {
            var _this = this;

            var introDuration = this.introDuration,
                introDelay = this.introDelay;
            // Init before animations starts

            this.init();
            TweenLite.to($el, introDuration, {
                alpha: 1,
                delay: introDelay,
                onStart: function onStart() {
                    // .. but animate until animation begins.
                    _this.isAnimating = true;
                },
                onComplete: done
            });
        },
        outro: function outro($el, done) {
            var _this2 = this;

            var outroDuration = this.outroDuration,
                outroDelay = this.outroDelay;

            TweenLite.to($el, outroDuration, {
                alpha: 0,
                ease: Cubic.easeOut,
                delay: outroDelay,
                onComplete: function onComplete() {
                    // Stop and unbind when animation ends
                    _this2.destroy();
                    done();
                }
            });
        },
        init: function init() {
            this.setActiveText();
            this.update();
            this.setAnimProgress();
            src_app.resize.add(this.update);
            src_app.render.add(this.animate);
            window.addEventListener('mousemove', this.onMouseMove);
        },
        destroy: function destroy() {
            this.isAnimating = false;
            src_app.resize.remove(this.update);
            src_app.render.remove(this.animate);
            window.removeEventListener('mousemove', this.onMouseMove);
        },
        getAnimProgressFromAngle: function getAnimProgressFromAngle(angle) {
            var maxAngle = this.maxAngle;

            return map(angle, maxAngle, -maxAngle, 0, 1);
        },
        getAngleFromAnimProgress: function getAngleFromAnimProgress(progress) {
            var maxAngle = this.maxAngle;

            return interpolate(progress, maxAngle, -maxAngle);
        },
        update: function update() {
            this.setPerspective();
            this.setDepth();
            this.setSize();
            this.setAngle();
            this.setMaxAngle();
        },
        setAnimProgress: function setAnimProgress(index) {
            var faces = this.faces,
                animProgress = this.animProgress,
                angle = this.angle,
                faceRange = this.faceRange;

            for (var i = 1; i <= faces; i++) {
                // End to center index
                var _index = map(i, 1, faces, faceRange, -faceRange);
                // Face initial angle
                var startAngle = angle * _index;
                // From that angle get its animation progress
                var animStart = this.getAnimProgressFromAngle(startAngle);
                animProgress.push(animStart);
            }
        },
        animate: function animate() {
            var _this3 = this;

            if (this.isAnimating) {
                var animProgress = this.animProgress,
                    velocity = this.velocity;

                this.animProgress = animProgress.map(function (progress, index) {
                    // Reset progress if it reaches 0, which means a loop is
                    // completed
                    if (progress <= 0) {
                        _this3.updateActiveText(index);
                        return 1;
                    }
                    return progress - velocity;
                });
                this.updateVelocity();
                this.updateTilt();
            }
        },
        updateActiveText: function updateActiveText(index) {
            var textIndex = this.textIndex,
                text = this.text,
                activeText = this.activeText;

            this.textIndex = textIndex < text.length - 1 ? textIndex + 1 : 0;
            // Only update the text of the face that completed its loop
            activeText[index] = text[this.textIndex];
        },
        updateVelocity: function updateVelocity() {
            var acceleration = this.acceleration,
                maxVelocity = this.maxVelocity;

            var max = maxVelocity * 0.001;
            if (this.velocity < max) {
                // Increase velocity with accelaration
                this.velocity += acceleration * 0.0001;
                // Ease accelaration
                this.velocity = interpolate(0.001, this.velocity, max);
                // Clamp velocity
                this.velocity = Math.min(this.velocity, max);
            }
        },
        updateTilt: function updateTilt() {
            var $el = this.$el,
                tilt = this.tilt,
                mouse = this.mouse,
                tiltMaxAngle = this.tiltMaxAngle,
                tiltFriction = this.tiltFriction;

            var maxX = $el.offsetWidth / 2;
            var maxY = $el.offsetHeight / 2;
            tilt.x = interpolate(tiltFriction, tilt.x, mouse.x);
            tilt.y = interpolate(tiltFriction, tilt.y, mouse.y);
            var x = maxX - tilt.x;
            var y = maxY - tilt.y;
            tilt.angleX = map(y, -maxY, maxY, -tiltMaxAngle, tiltMaxAngle);
            tilt.angleY = map(x, -maxX, maxX, tiltMaxAngle, -tiltMaxAngle);
        },
        setActiveText: function setActiveText() {
            var faces = this.faces,
                text = this.text;

            this.activeText = text.filter(function (line, index) {
                return index < faces;
            });
            this.textIndex = this.activeText.length - 1;
        },
        setPerspective: function setPerspective() {
            var $el = this.$el,
                perspectiveRatio = this.perspectiveRatio;

            this.perspective = Math.round($el.offsetHeight * perspectiveRatio);
        },
        setDepth: function setDepth() {
            var $el = this.$el,
                depthRatio = this.depthRatio;

            this.depth = Math.round($el.offsetHeight * depthRatio);
        },
        setSize: function setSize() {
            var $refs = this.$refs,
                faceSize = this.faceSize;

            var firstFace = $refs.face[0];
            faceSize.width = firstFace.offsetWidth;
            faceSize.height = firstFace.offsetHeight;
        },
        setAngle: function setAngle() {
            var depth = this.depth,
                faceSize = this.faceSize;

            this.angle = -Math.asin(faceSize.height / 2 / depth);
            this.angle *= 2;
        },
        setMaxAngle: function setMaxAngle() {
            var angle = this.angle,
                faceRange = this.faceRange;

            this.maxAngle = angle / 2;
            this.maxAngle += angle * faceRange;
        },
        faceStyle: function faceStyle(index) {
            var depth = this.depth,
                animProgress = this.animProgress;

            var progress = animProgress[index - 1];
            var angle = this.getAngleFromAnimProgress(progress);
            return {
                'transform': 'rotateX(' + angle + 'rad) translateZ(' + -depth + 'px)'
            };
        },
        onMouseMove: function onMouseMove(ev) {
            var mouse = this.mouse;

            mouse.x = ev.clientX;
            mouse.y = ev.clientY;
        }
    },
    computed: {
        containerStyle: function containerStyle() {
            var perspective = this.perspective;

            return {
                'perspective': perspective + 'px'
            };
        },
        originStyle: function originStyle() {
            var _tilt = this.tilt,
                angleX = _tilt.angleX,
                angleY = _tilt.angleY;

            return {
                'transform': 'rotateX(' + angleX + 'rad) rotateY(' + angleY + 'rad)'
            };
        },
        depthStyle: function depthStyle() {
            var depth = this.depth;

            return {
                transform: 'translateZ(' + depth + 'px)'
            };
        },
        faceRange: function faceRange() {
            var faces = this.faces;

            return ~~(faces / 2);
        },
        captionViewBox: function captionViewBox() {
            var _faceSize = this.faceSize,
                width = _faceSize.width,
                height = _faceSize.height;

            return '0 0 ' + width + ' ' + height;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-799c914d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/TextBarrel.vue
var TextBarrel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.intro,"leave":_vm.outro}},[_c('div',{staticClass:"TextBarrel"},[_c('div',{staticClass:"TextBarrel-container",style:(_vm.containerStyle)},[_c('div',{staticClass:"TextBarrel-origin",style:(_vm.originStyle)},[_c('div',{staticClass:"TextBarrel-depth",style:(_vm.depthStyle)},_vm._l((_vm.faces),function(index){return _c('div',{key:index,ref:"face",refInFor:true,staticClass:"TextBarrel-face",style:(_vm.faceStyle(index))},[_c('svg',{staticClass:"TextBarrel-caption",attrs:{"viewBox":_vm.captionViewBox}},[_c('text',{attrs:{"x":"50%","y":"50%"}},[_vm._v("\n                                "+_vm._s(_vm.activeText[index - 1])+"\n                            ")])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"TextBarrel-curtain"})])])}
var TextBarrel_staticRenderFns = []
var TextBarrel_esExports = { render: TextBarrel_render, staticRenderFns: TextBarrel_staticRenderFns }
/* harmony default export */ var components_TextBarrel = (TextBarrel_esExports);
// CONCATENATED MODULE: ./src/app/components/TextBarrel.vue
function TextBarrel_injectStyle (ssrContext) {
  __webpack_require__("+4L3")
}
var TextBarrel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TextBarrel___vue_template_functional__ = false
/* styles */
var TextBarrel___vue_styles__ = TextBarrel_injectStyle
/* scopeId */
var TextBarrel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TextBarrel___vue_module_identifier__ = null
var TextBarrel_Component = TextBarrel_normalizeComponent(
  TextBarrel,
  components_TextBarrel,
  TextBarrel___vue_template_functional__,
  TextBarrel___vue_styles__,
  TextBarrel___vue_scopeId__,
  TextBarrel___vue_module_identifier__
)

/* harmony default export */ var app_components_TextBarrel = (TextBarrel_Component.exports);

// EXTERNAL MODULE: ./node_modules/gsap/DrawSVGPlugin.js
var DrawSVGPlugin = __webpack_require__("bA8Z");
var DrawSVGPlugin_default = /*#__PURE__*/__webpack_require__.n(DrawSVGPlugin);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/LineIcon.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var LineIcon = ({
    name: 'LineIcon',
    props: {
        d: {
            type: String,
            required: true
        },
        width: {
            type: Number,
            default: 50
        },
        height: {
            type: Number,
            default: 50
        },
        introDuration: {
            type: Number,
            default: 0.8
        },
        outroDuration: {
            type: Number,
            default: 0.8
        },
        introDelay: {
            type: Number,
            default: 0
        },
        outroDelay: {
            type: Number,
            default: 0
        },
        loop: {
            type: Boolean,
            default: false
        },
        hovered: {
            type: Boolean,
            default: false
        },
        light: {
            type: Boolean,
            default: false
        },
        dark: {
            type: Boolean,
            default: false
        },
        opaque: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            timeline: null
        };
    },

    methods: {
        getTimeline: function getTimeline() {
            var $refs = this.$refs;

            if (this.timeline === null) {
                var tl = new TimelineMax({ paused: true });
                tl.fromTo($refs.path, this.introDuration, { drawSVG: '0' }, {
                    drawSVG: '100%',
                    delay: this.introDelay,
                    ease: Cubic.easeOut
                }).addLabel('intro-done', '+=0').to($refs.path, this.outroDuration, {
                    drawSVG: '100% 100%',
                    delay: this.outroDelay,
                    ease: Cubic.easeIn
                });
                this.timeline = tl;
            }
            return this.timeline;
        },
        intro: function intro($el, done) {
            var _this = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                var timeline;
                return regenerator_default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                timeline = _this.getTimeline();

                                timeline.seek(0);

                                if (!_this.loop) {
                                    _context.next = 8;
                                    break;
                                }

                                _context.next = 5;
                                return _this.initRepeat();

                            case 5:
                                // Call done after the first loop
                                done();
                                _context.next = 9;
                                break;

                            case 8:
                                timeline.addCallback(done, 'intro-done').tweenFromTo(0, 'intro-done');

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        outro: function outro($el, done) {
            var timeline = this.getTimeline();
            this.fill = 'blue';
            timeline.repeat(0).eventCallback('onComplete', done).resume(timeline.time());
        },
        initRepeat: function initRepeat() {
            var _this2 = this;

            return new promise_default.a(function (resolve, reject) {
                var timeline = _this2.timeline;

                timeline.eventCallback('onRepeat', function () {
                    resolve();
                    timeline.eventCallback('onRepeat', null);
                }).repeat(-1).play();
            });
        },
        onMouseEnter: function onMouseEnter() {
            var timeline = this.getTimeline();
            timeline.resume().eventCallback('onComplete', function () {
                timeline.tweenFromTo(0, 'intro-done');
            });
        }
    },
    computed: {
        modifiers: function modifiers() {
            var light = this.light,
                dark = this.dark,
                opaque = this.opaque;

            return {
                'LineIcon--light': light,
                'LineIcon--dark': dark,
                'LineIcon--opaque': opaque
            };
        },
        style: function style() {
            var width = this.width,
                height = this.height;

            return {
                'width': width + 'px',
                'height': height + 'px'
            };
        },
        stageViewBox: function stageViewBox() {
            var width = this.width,
                height = this.height;

            return '0 0 ' + width + ' ' + height;
        }
    },
    watch: {
        hovered: function hovered(val) {
            if (val) this.onMouseEnter();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abd4f56e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/LineIcon.vue
var LineIcon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.intro,"leave":_vm.outro}},[_c('div',{staticClass:"LineIcon",class:_vm.modifiers,style:(_vm.style)},[_c('svg',{attrs:{"viewBox":_vm.stageViewBox}},[_c('path',{ref:"path",staticClass:"LineIcon-path",attrs:{"d":_vm.d}})])])])}
var LineIcon_staticRenderFns = []
var LineIcon_esExports = { render: LineIcon_render, staticRenderFns: LineIcon_staticRenderFns }
/* harmony default export */ var components_LineIcon = (LineIcon_esExports);
// CONCATENATED MODULE: ./src/app/components/LineIcon.vue
function LineIcon_injectStyle (ssrContext) {
  __webpack_require__("tVLB")
}
var LineIcon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LineIcon___vue_template_functional__ = false
/* styles */
var LineIcon___vue_styles__ = LineIcon_injectStyle
/* scopeId */
var LineIcon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LineIcon___vue_module_identifier__ = null
var LineIcon_Component = LineIcon_normalizeComponent(
  LineIcon,
  components_LineIcon,
  LineIcon___vue_template_functional__,
  LineIcon___vue_styles__,
  LineIcon___vue_scopeId__,
  LineIcon___vue_module_identifier__
)

/* harmony default export */ var app_components_LineIcon = (LineIcon_Component.exports);

// EXTERNAL MODULE: ./node_modules/gsap/SplitText.js
var SplitText = __webpack_require__("NhNM");
var SplitText_default = /*#__PURE__*/__webpack_require__.n(SplitText);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/transitions/TextTransition.vue



//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var TextTransition = ({
    props: {
        introDelay: {
            type: Number,
            default: 0
        },
        charMinDuration: {
            type: Number,
            default: 0.5
        },
        charMaxDuration: {
            type: Number,
            default: 1
        },
        outroDelay: {
            type: Number,
            default: 0
        },
        outroDuration: {
            type: Number,
            default: 0.75
        }
    },
    data: function data() {
        return {
            splitText: null
        };
    },

    methods: {
        setSplitText: function setSplitText($el) {
            if (!this.splitText) {
                this.splitText = new SplitText_default.a($el);
            }
            // In case the browser was resized split again.
            if (!this.splitText.isSplit) {
                this.splitText.split();
            }
        },
        intro: function intro($el, done) {
            var _this = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                var chars, tweens;
                return regenerator_default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                chars = _this.splitText.chars;

                                src_app.resize.add(_this.onResize);
                                TweenLite.set($el, { alpha: 1 });
                                tweens = chars.map(function (char) {
                                    return _this.getIntroTween(char);
                                });
                                _context.next = 6;
                                return promise_default.a.all(tweens);

                            case 6:
                                done();

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        outro: function outro($el, done) {
            var outroDelay = this.outroDelay,
                outroDuration = this.outroDuration;

            src_app.resize.remove(this.onResize);
            TweenLite.to($el, outroDuration, {
                alpha: 0,
                ease: Sine.easeIn,
                delay: outroDelay,
                onComplete: done
            });
        },
        getIntroTween: function getIntroTween(char) {
            var _this2 = this;

            return new promise_default.a(function (resolve) {
                var charMinDuration = _this2.charMinDuration,
                    charMaxDuration = _this2.charMaxDuration,
                    introDelay = _this2.introDelay;

                var duration = random(charMinDuration, charMaxDuration);
                var delay = introDelay + charMaxDuration - duration;
                TweenLite.fromTo(char, duration, { alpha: 0 }, {
                    alpha: 1,
                    delay: delay,
                    ease: Sine.easeIn,
                    onComplete: resolve
                });
            });
        },
        onResize: function onResize() {
            var splitText = this.splitText;
            // The divs generated with SplitText will cause trouble if the
            // browser is resized.

            if (splitText && splitText.isSplit) {
                splitText.revert();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-666b9959","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/transitions/TextTransition.vue
var TextTransition_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"before-enter":_vm.setSplitText,"enter":_vm.intro,"leave":_vm.outro}},[_vm._t("default")],2)}
var TextTransition_staticRenderFns = []
var TextTransition_esExports = { render: TextTransition_render, staticRenderFns: TextTransition_staticRenderFns }
/* harmony default export */ var transitions_TextTransition = (TextTransition_esExports);
// CONCATENATED MODULE: ./src/app/transitions/TextTransition.vue
var TextTransition_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TextTransition___vue_template_functional__ = false
/* styles */
var TextTransition___vue_styles__ = null
/* scopeId */
var TextTransition___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TextTransition___vue_module_identifier__ = null
var TextTransition_Component = TextTransition_normalizeComponent(
  TextTransition,
  transitions_TextTransition,
  TextTransition___vue_template_functional__,
  TextTransition___vue_styles__,
  TextTransition___vue_scopeId__,
  TextTransition___vue_module_identifier__
)

/* harmony default export */ var app_transitions_TextTransition = (TextTransition_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/IconBttn.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var IconBttn = ({
    name: 'IconBttn',
    props: {
        to: {
            type: [Object, String],
            required: true
        },
        iconPath: {
            type: String,
            required: true
        },
        iconWidth: {
            type: Number
        },
        iconHeight: {
            type: Number
        },
        disabled: {
            type: Boolean,
            default: false
        },
        dark: {
            type: Boolean,
            default: false
        }
    },
    components: {
        LineIcon: app_components_LineIcon,
        TextTransition: app_transitions_TextTransition
    },
    data: function data() {
        return {
            visible: false,
            hovered: false
        };
    },

    methods: {
        intro: function intro($el, done) {
            this.visible = true;
            TweenLite.delayedCall(0.75, done);
        },
        outro: function outro($el, done) {
            this.visible = false;
            TweenLite.delayedCall(0.75, done);
        },
        onMouseEnter: function onMouseEnter() {
            this.hovered = true;
        },
        onMouseLeave: function onMouseLeave() {
            this.hovered = false;
        }
    },
    computed: {
        modifiers: function modifiers() {
            var dark = this.dark;

            return {
                'IconBttn--dark': dark
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-395fdac5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/IconBttn.vue
var IconBttn_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.intro,"leave":_vm.outro}},[_c('router-link',{staticClass:"IconBttn",attrs:{"to":_vm.to},nativeOn:{"mouseenter":function($event){return _vm.onMouseEnter($event)},"mouseleave":function($event){return _vm.onMouseLeave($event)},"click":function($event){_vm.$emit('click', $event)}}},[_c('line-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],attrs:{"d":_vm.iconPath,"width":_vm.iconWidth,"height":_vm.iconHeight,"dark":_vm.dark,"hovered":_vm.hovered}}),_vm._v(" "),_c('text-transition',[_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"IconBttn-text"},[_vm._t("default")],2)])],1)],1)}
var IconBttn_staticRenderFns = []
var IconBttn_esExports = { render: IconBttn_render, staticRenderFns: IconBttn_staticRenderFns }
/* harmony default export */ var components_IconBttn = (IconBttn_esExports);
// CONCATENATED MODULE: ./src/app/components/IconBttn.vue
function IconBttn_injectStyle (ssrContext) {
  __webpack_require__("fa/7")
}
var IconBttn_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var IconBttn___vue_template_functional__ = false
/* styles */
var IconBttn___vue_styles__ = IconBttn_injectStyle
/* scopeId */
var IconBttn___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var IconBttn___vue_module_identifier__ = null
var IconBttn_Component = IconBttn_normalizeComponent(
  IconBttn,
  components_IconBttn,
  IconBttn___vue_template_functional__,
  IconBttn___vue_styles__,
  IconBttn___vue_scopeId__,
  IconBttn___vue_module_identifier__
)

/* harmony default export */ var app_components_IconBttn = (IconBttn_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/views/Home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Home = ({
    name: 'Home',
    mixins: [ChapterUtils],
    components: {
        IntroLogo: app_components_IntroLogo,
        TextBarrel: app_components_TextBarrel,
        LineIcon: app_components_LineIcon,
        IconBttn: app_components_IconBttn,
        TextTransition: app_transitions_TextTransition
    },
    data: function data() {
        return {
            timeline: null,
            skipIntroVisible: false,
            introLogoVisible: false,
            textBarrelVisible: false,
            indicationVisible: false,
            descriptionVisible: false,
            continueVisible: false
        };
    },
    mounted: function mounted() {
        this.updateDescriptionIndex();
    },

    methods: {
        intro: function intro($el, done) {
            var _this = this;

            this.setBackgroundVisible(false);
            var tl = new TimelineLite();
            tl.delay(1);
            tl.call(function () {
                _this.skipIntroVisible = true;
                _this.indicationVisible = true;
            }, [], this, 0);
            tl.call(function () {
                _this.indicationVisible = false;
                _this.textBarrelVisible = true;
                _this.introLogoVisible = true;
            }, [], this, '+=4');
            tl.call(function () {
                _this.introLogoVisible = false;
            }, [], this, '+=4');
            tl.call(function () {
                _this.descriptionVisible = true;
                _this.continueVisible = true;
            }, [], this, '+=0.2');
            tl.call(function () {
                return done;
            }, [], this, '+=1');
            this.timeline = tl;
        },
        outro: function outro($el, done) {
            this.setBackgroundVisible(true);
            // Destroy timeline
            this.timeline.kill();
            this.timeline = null;
            // Hide all components
            this.introLogoVisible = false;
            this.textBarrelVisible = false;
            this.indicationVisible = false;
            this.descriptionVisible = false;
            this.skipIntroVisible = false;
            this.continueVisible = false;
            // Delay done callback so all components have time to anim-out
            TweenLite.delayedCall(0.75, done);
        },
        updateDescriptionIndex: function updateDescriptionIndex() {
            var data = this.data,
                introDescriptionIndex = this.introDescriptionIndex;

            var index = introDescriptionIndex + 1;
            if (index === data.intro.description.length) {
                index = 0;
            }
            localStorage.setItem('intro-desc-index', index);
        }
    },
    computed: {
        lineIcons: function lineIcons() {
            var $store = this.$store;

            return $store.getters.data.lineIcons;
        },
        introDescriptionIndex: function introDescriptionIndex() {
            if (localStorage.hasOwnProperty('intro-desc-index')) {
                var index = localStorage.getItem('intro-desc-index');
                return parseInt(index);
            }
            return 0;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f22686b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"appear":_vm.intro,"enter":_vm.intro,"leave":_vm.outro}},[_c('div',{staticClass:"Home"},[_c('text-barrel',{directives:[{name:"show",rawName:"v-show",value:(_vm.textBarrelVisible),expression:"textBarrelVisible"}],attrs:{"text":_vm.chapterNameList}}),_vm._v(" "),_c('div',{staticClass:"Home-container"},[_c('text-transition',{directives:[{name:"show",rawName:"v-show",value:(_vm.descriptionVisible),expression:"descriptionVisible"}]},[_c('p',{ref:"copy",staticClass:"Home-copy"},[_vm._v("\n                    "+_vm._s(_vm.data.intro.description[_vm.introDescriptionIndex])+"\n                ")])])],1),_vm._v(" "),_c('div',{staticClass:"Home-container"},[_c('div',{staticClass:"Home-indication"},[_c('line-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.indicationVisible),expression:"indicationVisible"}],staticClass:"Home-audioIcon",attrs:{"width":_vm.lineIcons.headphones.width,"height":_vm.lineIcons.headphones.height,"d":_vm.lineIcons.headphones.d}}),_vm._v(" "),_c('text-transition',{directives:[{name:"show",rawName:"v-show",value:(_vm.indicationVisible),expression:"indicationVisible"}]},[_c('div',{staticClass:"small"},[_vm._v("\n                        "+_vm._s(_vm.data.intro.indication)+"\n                    ")])])],1)]),_vm._v(" "),_c('intro-logo',{directives:[{name:"show",rawName:"v-show",value:(_vm.introLogoVisible),expression:"introLogoVisible"}]}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.skipIntroVisible),expression:"skipIntroVisible"}],staticClass:"Home-skip"},[_c('router-link',{attrs:{"to":{ name: 'chapter' }}},[_c('small',[_vm._v(_vm._s(_vm.data.intro.skip))])])],1)]),_vm._v(" "),_c('div',{staticClass:"Home-continue"},[_c('icon-bttn',{directives:[{name:"show",rawName:"v-show",value:(_vm.continueVisible),expression:"continueVisible"}],attrs:{"to":{ name: 'chapter' },"icon-width":_vm.lineIcons.continue.width,"icon-height":_vm.lineIcons.continue.height,"icon-path":_vm.lineIcons.continue.d}},[_vm._v("\n                "+_vm._s(_vm.data.intro.continue)+"\n            ")])],1)],1)])}
var Home_staticRenderFns = []
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var views_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/app/views/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("Wf2R")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  views_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var app_views_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/ChapterIndex.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ChapterIndex = ({
    name: 'ChapterIndex',
    props: {
        index: {
            type: Number,
            required: true
        },
        total: {
            type: Number,
            required: true
        }
    },
    data: function data() {
        return {
            indexWidth: 0
        };
    },
    methods: {
        intro: function intro(el, done) {
            var $refs = this.$refs;

            TweenMax.set(el, {
                alpha: 1
            });
            TweenMax.staggerFromTo([$refs.index, $refs.total], 0.75, {
                y: '100%'
            }, {
                y: '0%'
            }, 0.075, done);
        },
        outro: function outro(el, done) {
            TweenLite.to(el, 0.75, {
                alpha: 0,
                ease: Cubic.easeOut,
                onComplete: done
            });
        }
    },
    computed: {
        paddedIndex: function paddedIndex() {
            var index = this.index;

            return ('' + index).padStart(2, '0');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70108acd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/ChapterIndex.vue
var ChapterIndex_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.intro,"leave":_vm.outro}},[_c('div',{staticClass:"ChapterIndex"},[_c('p',{staticClass:"ChapterIndex-stage"},[_c('span',{ref:"index",staticClass:"ChapterIndex-index"},[_vm._v("\n                "+_vm._s(_vm.paddedIndex)+"\n            ")]),_vm._v(" "),_c('span',{ref:"total",staticClass:"ChapterIndex-total"},[_vm._v("\n                _ "+_vm._s(_vm.total)+"\n            ")])])])])}
var ChapterIndex_staticRenderFns = []
var ChapterIndex_esExports = { render: ChapterIndex_render, staticRenderFns: ChapterIndex_staticRenderFns }
/* harmony default export */ var components_ChapterIndex = (ChapterIndex_esExports);
// CONCATENATED MODULE: ./src/app/components/ChapterIndex.vue
function ChapterIndex_injectStyle (ssrContext) {
  __webpack_require__("iZyl")
}
var ChapterIndex_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChapterIndex___vue_template_functional__ = false
/* styles */
var ChapterIndex___vue_styles__ = ChapterIndex_injectStyle
/* scopeId */
var ChapterIndex___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ChapterIndex___vue_module_identifier__ = null
var ChapterIndex_Component = ChapterIndex_normalizeComponent(
  ChapterIndex,
  components_ChapterIndex,
  ChapterIndex___vue_template_functional__,
  ChapterIndex___vue_styles__,
  ChapterIndex___vue_scopeId__,
  ChapterIndex___vue_module_identifier__
)

/* harmony default export */ var app_components_ChapterIndex = (ChapterIndex_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/RoundBttn.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var RoundBttn = ({
    name: 'RoundBttn',
    props: {
        icon: {
            type: Object,
            required: true
        },
        to: {
            type: [String, Object],
            required: true
        }
    },
    components: {
        LineIcon: app_components_LineIcon
    },
    data: function data() {
        return {
            hovered: false,
            iconVisible: false
        };
    },
    methods: {
        intro: function intro(el, done) {
            var _this = this;

            var $refs = this.$refs;

            TweenLite.set(el, { x: 0, alpha: 1 });
            TweenLite.fromTo($refs.back, 1, {
                rotation: -45
            }, {
                rotation: 0,
                delay: 1.75
            });
            TweenLite.fromTo([$refs.back, $refs.text], 1, { alpha: 0 }, {
                alpha: 1,
                delay: 1.75,
                onStart: function onStart() {
                    // Start icon animation until this fade animation starts too
                    _this.iconVisible = true;
                },
                onComplete: done
            });
        },
        outro: function outro(el, done) {
            var _this2 = this;

            TweenLite.to(el, 1, {
                alpha: 0,
                x: 10,
                ease: Cubic.easeOut,
                onComplete: function onComplete() {
                    // Avoid line-icon outro
                    _this2.iconVisible = false;
                    done();
                }
            });
        },
        onMouseEnter: function onMouseEnter() {
            this.hovered = true;
        },
        onMouseLeave: function onMouseLeave() {
            this.hovered = false;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5605378b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/RoundBttn.vue
var RoundBttn_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.intro,"leave":_vm.outro}},[_c('router-link',{staticClass:"RoundBttn",attrs:{"to":_vm.to},nativeOn:{"mouseenter":function($event){return _vm.onMouseEnter($event)},"mouseleave":function($event){return _vm.onMouseLeave($event)}}},[_c('span',{staticClass:"RoundBttn-container"},[_c('svg',{ref:"back",staticClass:"RoundBttn-back",attrs:{"viewBox":"0 0 200 200"}},[_c('circle',{attrs:{"cx":"100","cy":"100","r":"99"}})]),_vm._v(" "),_c('span',{staticClass:"RoundBttn-main"},[_c('line-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.iconVisible),expression:"iconVisible"}],staticClass:"RoundBttn-icon",attrs:{"d":_vm.icon.d,"width":_vm.icon.width,"height":_vm.icon.height,"hovered":_vm.hovered,"dark":""}}),_vm._v(" "),_c('span',{ref:"text",staticClass:"RoundBttn-text"},[_vm._t("default")],2)],1)])])],1)}
var RoundBttn_staticRenderFns = []
var RoundBttn_esExports = { render: RoundBttn_render, staticRenderFns: RoundBttn_staticRenderFns }
/* harmony default export */ var components_RoundBttn = (RoundBttn_esExports);
// CONCATENATED MODULE: ./src/app/components/RoundBttn.vue
function RoundBttn_injectStyle (ssrContext) {
  __webpack_require__("fMN5")
}
var RoundBttn_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RoundBttn___vue_template_functional__ = false
/* styles */
var RoundBttn___vue_styles__ = RoundBttn_injectStyle
/* scopeId */
var RoundBttn___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var RoundBttn___vue_module_identifier__ = null
var RoundBttn_Component = RoundBttn_normalizeComponent(
  RoundBttn,
  components_RoundBttn,
  RoundBttn___vue_template_functional__,
  RoundBttn___vue_styles__,
  RoundBttn___vue_scopeId__,
  RoundBttn___vue_module_identifier__
)

/* harmony default export */ var app_components_RoundBttn = (RoundBttn_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/ChapterSlide.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var ChapterSlide = ({
    name: 'ChapterSlide',
    props: {
        index: {
            type: Number,
            required: true
        },
        total: {
            type: Number,
            required: true
        },
        chapter: {
            type: Object,
            required: true
        }
    },
    components: {
        TextTransition: app_transitions_TextTransition,
        ChapterIndex: app_components_ChapterIndex,
        RoundBttn: app_components_RoundBttn
    },
    data: function data() {
        return {
            visible: false
        };
    },

    methods: {
        intro: function intro(el, done) {
            var $refs = this.$refs;

            this.visible = true;
            TweenLite.set($refs.container, { x: 0 });
            TweenLite.set($refs.separator, { alpha: 1, width: 0 });
            TweenLite.to($refs.separator, 0.6, { width: 75, delay: 1.2 });
            done();
        },
        outro: function outro(el, done) {
            var $refs = this.$refs;

            this.visible = false;
            TweenLite.to($refs.container, 1, {
                x: -10,
                ease: Cubic.easeOut
            });
            TweenLite.to($refs.separator, 0.3, {
                alpha: 0,
                ease: Cubic.easeOut
            });
            done();
        }
    },
    computed: {
        lineIcons: function lineIcons() {
            var $store = this.$store;

            return $store.getters.data.lineIcons;
        },
        videoTo: function videoTo() {
            var chapter = this.chapter;

            return {
                name: CHAPTER_VIDEO,
                params: {
                    id: chapter.id
                }
            };
        },
        noteboookTo: function noteboookTo() {
            var chapter = this.chapter;

            return {
                name: CHAPTER_ART,
                params: {
                    id: chapter.id
                }
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d227a98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/ChapterSlide.vue
var ChapterSlide_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.intro,"leave":_vm.outro}},[_c('div',{staticClass:"ChapterSlide"},[_c('main',{staticClass:"ChapterSlide-main"},[_c('div',{ref:"container",staticClass:"ChapterSlide-container"},[_c('chapter-index',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],attrs:{"index":_vm.index,"total":_vm.total}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('h1',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"ChapterSlide-title"},[_vm._v("\n                        "+_vm._s(_vm.chapter.name)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"ChapterSlide-subtitle"},[_c('div',{ref:"separator",staticClass:"ChapterSlide-separator"}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"small"},[_vm._v("\n                            "+_vm._s(_vm.chapter.profession)+"\n                        ")])])],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"ChapterSlide-description",domProps:{"innerHTML":_vm._s(_vm.chapter.description)}})])],1)]),_vm._v(" "),_c('div',{staticClass:"ChapterSlide-nav"},[(_vm.chapter.hasVideo)?_c('round-bttn',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],attrs:{"icon":_vm.lineIcons.videoCamera,"to":_vm.videoTo}},[_c('small',[_vm._v("Ver capítulo")])]):_vm._e(),_vm._v(" "),_c('round-bttn',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],attrs:{"icon":_vm.lineIcons.notebook,"to":_vm.noteboookTo}},[_c('small',[_vm._v("Ver libreta")])])],1)])])}
var ChapterSlide_staticRenderFns = []
var ChapterSlide_esExports = { render: ChapterSlide_render, staticRenderFns: ChapterSlide_staticRenderFns }
/* harmony default export */ var components_ChapterSlide = (ChapterSlide_esExports);
// CONCATENATED MODULE: ./src/app/components/ChapterSlide.vue
function ChapterSlide_injectStyle (ssrContext) {
  __webpack_require__("HBZW")
}
var ChapterSlide_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChapterSlide___vue_template_functional__ = false
/* styles */
var ChapterSlide___vue_styles__ = ChapterSlide_injectStyle
/* scopeId */
var ChapterSlide___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ChapterSlide___vue_module_identifier__ = null
var ChapterSlide_Component = ChapterSlide_normalizeComponent(
  ChapterSlide,
  components_ChapterSlide,
  ChapterSlide___vue_template_functional__,
  ChapterSlide___vue_styles__,
  ChapterSlide___vue_scopeId__,
  ChapterSlide___vue_module_identifier__
)

/* harmony default export */ var app_components_ChapterSlide = (ChapterSlide_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/ArrowBttn.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ArrowBttn = ({
    name: 'ArrowBttn',
    data: function data() {
        return {
            isHovered: false
        };
    },

    components: {
        TextTransition: app_transitions_TextTransition
    },
    props: {
        up: {
            type: Boolean,
            default: false
        },
        light: {
            type: Boolean,
            default: false
        },
        bordered: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onClick: function onClick(ev) {
            var disabled = this.disabled;

            if (!disabled) {
                this.$emit('click', ev);
            }
        },
        toggleHovered: function toggleHovered() {
            this.isHovered = !this.isHovered;
        }
    },
    computed: {
        directionText: function directionText() {
            return this.up ? "artista anterior" : "artista siguiente";
        },
        modifiers: function modifiers() {
            var up = this.up,
                light = this.light,
                disabled = this.disabled,
                bordered = this.bordered;

            return {
                'ArrowBttn--up': up,
                'ArrowBttn--light': light,
                'ArrowBttn--bordered': bordered,
                'ArrowBttn--disabled': disabled
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cf789f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/ArrowBttn.vue
var ArrowBttn_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ArrowBttn",class:_vm.modifiers,on:{"click":_vm.onClick,"mouseenter":_vm.toggleHovered,"mouseleave":_vm.toggleHovered}},[_c('svg',{staticClass:"ArrowBttn-icon"},[_c('use',{attrs:{"xlink:href":"#icon-chevron-down"}})]),_vm._v(" "),_c('text-transition',{attrs:{"charMinDuration":0.3,"charMaxDuration":0.5,"outroDuration":0.5}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isHovered),expression:"isHovered"}],staticClass:"ArrowBttn-tooltip"},[_c('small',[_vm._v(_vm._s(_vm.directionText))])])])],1)}
var ArrowBttn_staticRenderFns = []
var ArrowBttn_esExports = { render: ArrowBttn_render, staticRenderFns: ArrowBttn_staticRenderFns }
/* harmony default export */ var components_ArrowBttn = (ArrowBttn_esExports);
// CONCATENATED MODULE: ./src/app/components/ArrowBttn.vue
function ArrowBttn_injectStyle (ssrContext) {
  __webpack_require__("G9b2")
}
var ArrowBttn_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ArrowBttn___vue_template_functional__ = false
/* styles */
var ArrowBttn___vue_styles__ = ArrowBttn_injectStyle
/* scopeId */
var ArrowBttn___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ArrowBttn___vue_module_identifier__ = null
var ArrowBttn_Component = ArrowBttn_normalizeComponent(
  ArrowBttn,
  components_ArrowBttn,
  ArrowBttn___vue_template_functional__,
  ArrowBttn___vue_styles__,
  ArrowBttn___vue_scopeId__,
  ArrowBttn___vue_module_identifier__
)

/* harmony default export */ var app_components_ArrowBttn = (ArrowBttn_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/SocialNav.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SocialNav = ({
    name: 'SocialNav',
    props: {
        light: {
            type: Boolean,
            default: false
        },
        items: {
            type: Array,
            required: true
        }
    },
    methods: {
        getElem: function getElem(item) {
            return item.url ? 'a' : 'div';
        }
    },
    computed: {
        modifiers: function modifiers() {
            var light = this.light;

            return {
                'SocialNav--light': light
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c482414","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/SocialNav.vue
var SocialNav_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SocialNav",class:_vm.modifiers},[_c('small',{staticClass:"SocialNav-label"},[_vm._t("default")],2),_vm._v(" "),_vm._l((_vm.items),function(item){return _c(_vm.getElem(item),{key:item.id,tag:"component",staticClass:"SocialNav-bttn",attrs:{"href":item.url,"target":item.target},on:{"click":function($event){$event.stopPropagation();_vm.$emit('item-click', item.id)}}},[_c('svg',{staticClass:"SocialNav-icon"},[_c('use',{attrs:{"xlink:href":("#" + (item.iconId))}})])])})],2)}
var SocialNav_staticRenderFns = []
var SocialNav_esExports = { render: SocialNav_render, staticRenderFns: SocialNav_staticRenderFns }
/* harmony default export */ var components_SocialNav = (SocialNav_esExports);
// CONCATENATED MODULE: ./src/app/components/SocialNav.vue
function SocialNav_injectStyle (ssrContext) {
  __webpack_require__("NFa9")
}
var SocialNav_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SocialNav___vue_template_functional__ = false
/* styles */
var SocialNav___vue_styles__ = SocialNav_injectStyle
/* scopeId */
var SocialNav___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SocialNav___vue_module_identifier__ = null
var SocialNav_Component = SocialNav_normalizeComponent(
  SocialNav,
  components_SocialNav,
  SocialNav___vue_template_functional__,
  SocialNav___vue_styles__,
  SocialNav___vue_scopeId__,
  SocialNav___vue_module_identifier__
)

/* harmony default export */ var app_components_SocialNav = (SocialNav_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/ChapterFooter.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ChapterFooter = ({
    name: 'ChapterFooter',
    components: {
        SocialNav: app_components_SocialNav
    },
    data: function data() {
        return {
            followItems: [{
                id: 'facebook',
                iconId: 'icon-facebook',
                url: 'https://www.facebook.com/Moleskine',
                target: '_blank'
            }, {
                id: 'twitter',
                iconId: 'icon-twitter',
                url: 'https://twitter.com/moleskine',
                target: '_blank'
            }]
        };
    },

    methods: {
        intro: function intro(el, done) {
            TweenLite.fromTo(el, 0.5, {
                alpha: 0
            }, {
                alpha: 1,
                onComplete: done,
                ease: Sine.easeOut
            });
        },
        outro: function outro(el, done) {
            TweenLite.to(el, 0.5, {
                alpha: 0,
                onComplete: done,
                ease: Sine.easeOut
            });
        }
    },
    computed: {
        data: function data() {
            var $store = this.$store;

            return $store.getters.data;
        },
        auctionRoute: function auctionRoute() {
            return {
                name: AUCTION
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-094811d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/ChapterFooter.vue
var ChapterFooter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.intro,"leave":_vm.outro}},[_c('footer',{staticClass:"ChapterFooter"},[_c('div',{staticClass:"ChapterFooter-container"},[_c('div',{staticClass:"ChapterFooter-socialNav"},[_c('social-nav',{attrs:{"items":_vm.followItems,"light":""}},[_vm._v("\n                    Síguenos\n                ")])],1),_vm._v(" "),_c('router-link',{staticClass:"ChapterFooter-bttn",attrs:{"to":_vm.auctionRoute}},[_c('small',[_vm._v("Subasta Moleskine")])])],1),_vm._v(" "),_c('div',{staticClass:"ChapterFooter-container"},[_c('p',{staticClass:"ChapterFooter-disclaimer"},[_vm._v("\n                "+_vm._s(_vm.data.legal.disclaimer)+"\n            ")])])])])}
var ChapterFooter_staticRenderFns = []
var ChapterFooter_esExports = { render: ChapterFooter_render, staticRenderFns: ChapterFooter_staticRenderFns }
/* harmony default export */ var components_ChapterFooter = (ChapterFooter_esExports);
// CONCATENATED MODULE: ./src/app/components/ChapterFooter.vue
function ChapterFooter_injectStyle (ssrContext) {
  __webpack_require__("rNb/")
}
var ChapterFooter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChapterFooter___vue_template_functional__ = false
/* styles */
var ChapterFooter___vue_styles__ = ChapterFooter_injectStyle
/* scopeId */
var ChapterFooter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ChapterFooter___vue_module_identifier__ = null
var ChapterFooter_Component = ChapterFooter_normalizeComponent(
  ChapterFooter,
  components_ChapterFooter,
  ChapterFooter___vue_template_functional__,
  ChapterFooter___vue_styles__,
  ChapterFooter___vue_scopeId__,
  ChapterFooter___vue_module_identifier__
)

/* harmony default export */ var app_components_ChapterFooter = (ChapterFooter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/Logo.vue
//
//
//
//
//
//
//
//


/* harmony default export */ var Logo = ({
    name: 'Logo',
    props: {
        light: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        homeRoute: function homeRoute() {
            return {
                name: HOME
            };
        },
        modifiers: function modifiers() {
            var light = this.light;

            return {
                'Logo--light': light
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62f4a247","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Logo.vue
var Logo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"Logo",class:_vm.modifiers,attrs:{"to":_vm.homeRoute}},[_c('svg',{staticClass:"Logo-link"},[_c('use',{attrs:{"xlink:href":"#logo"}})])])}
var Logo_staticRenderFns = []
var Logo_esExports = { render: Logo_render, staticRenderFns: Logo_staticRenderFns }
/* harmony default export */ var components_Logo = (Logo_esExports);
// CONCATENATED MODULE: ./src/app/components/Logo.vue
function Logo_injectStyle (ssrContext) {
  __webpack_require__("BXD5")
}
var Logo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Logo___vue_template_functional__ = false
/* styles */
var Logo___vue_styles__ = Logo_injectStyle
/* scopeId */
var Logo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Logo___vue_module_identifier__ = null
var Logo_Component = Logo_normalizeComponent(
  Logo,
  components_Logo,
  Logo___vue_template_functional__,
  Logo___vue_styles__,
  Logo___vue_scopeId__,
  Logo___vue_module_identifier__
)

/* harmony default export */ var app_components_Logo = (Logo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/views/Chapter.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Chapter = ({
    name: 'Chapter',
    mixins: [ChapterUtils],
    components: {
        ChapterSlide: app_components_ChapterSlide,
        ArrowBttn: app_components_ArrowBttn,
        ChapterFooter: app_components_ChapterFooter,
        Logo: app_components_Logo
    },
    data: function data() {
        return {
            carouselEase: Quart.easeIn
        };
    },
    mounted: function mounted() {
        var activeChapterId = this.activeChapterId;

        if (!activeChapterId) {
            var firstChapter = this.firstChapter;

            this.updateActiveChapterId(firstChapter.id, 0);
        }
    },

    methods: extends_default()({
        intro: function intro(el, done) {
            this.setRibbonVisible(true);
            this.setBgVisible(true);
            this.setIsInHome(true);
            done();
        },
        outro: function outro(el, done) {
            this.setIsInHome(false);
            this.setBgVisible(false);
            this.setRibbonVisible(false);
            done();
        },
        tweenUI: function tweenUI(isInHome) {
            var $refs = this.$refs;

            TweenLite.to([$refs.separator, $refs.chapterNav], 0.5, {
                alpha: isInHome ? 1 : 0,
                delay: isInHome ? 0.5 : 0
            });
        },
        chapterVisible: function chapterVisible(id) {
            var activeChapterId = this.activeChapterId;

            return activeChapterId === id;
        }
    }, Object(vuex_esm["e" /* mapMutations */])({
        setRibbonVisible: RIBBON_VISIBLE,
        setBgVisible: BG_VISIBLE,
        setIsInHome: IS_IN_HOME
    })),
    computed: extends_default()({}, Object(vuex_esm["d" /* mapGetters */])(["isInHome"])),
    watch: {
        isInHome: function isInHome(value) {
            this.tweenUI(value);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c098e60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/Chapter.vue
var Chapter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false,"appear":""},on:{"enter":_vm.intro,"leave":_vm.outro}},[_c('section',{staticClass:"Chapter"},[_c('div',{ref:"separator",staticClass:"Chapter-separator"}),_vm._v(" "),_vm._l((_vm.chapters),function(chapter,index){return _c('chapter-slide',{directives:[{name:"show",rawName:"v-show",value:(_vm.isInHome && _vm.chapterVisible(chapter.id)),expression:"isInHome && chapterVisible(chapter.id)"}],key:chapter.id,attrs:{"index":index + 1,"total":_vm.chapters.length,"chapter":chapter}})}),_vm._v(" "),_c('div',{ref:"chapterNav",staticClass:"Chapter-nav"},[_c('arrow-bttn',{staticClass:"Chapter-navBttn",attrs:{"up":"","light":"","bordered":""},on:{"click":function($event){_vm.gotoPreviousChapter()}}}),_vm._v(" "),_c('arrow-bttn',{staticClass:"Chapter-navBttn",attrs:{"light":"","bordered":""},on:{"click":function($event){_vm.gotoNextChapter()}}})],1),_vm._v(" "),_c('chapter-footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.isInHome),expression:"isInHome"}]}),_vm._v(" "),_c('logo',{staticClass:"Chapter-logo",attrs:{"light":_vm.isInHome}})],2)])}
var Chapter_staticRenderFns = []
var Chapter_esExports = { render: Chapter_render, staticRenderFns: Chapter_staticRenderFns }
/* harmony default export */ var views_Chapter = (Chapter_esExports);
// CONCATENATED MODULE: ./src/app/views/Chapter.vue
function Chapter_injectStyle (ssrContext) {
  __webpack_require__("VYjE")
}
var Chapter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Chapter___vue_template_functional__ = false
/* styles */
var Chapter___vue_styles__ = Chapter_injectStyle
/* scopeId */
var Chapter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Chapter___vue_module_identifier__ = null
var Chapter_Component = Chapter_normalizeComponent(
  Chapter,
  views_Chapter,
  Chapter___vue_template_functional__,
  Chapter___vue_styles__,
  Chapter___vue_scopeId__,
  Chapter___vue_module_identifier__
)

/* harmony default export */ var app_views_Chapter = (Chapter_Component.exports);

// EXTERNAL MODULE: ./node_modules/background-cover/index.js
var background_cover = __webpack_require__("K8iy");
var background_cover_default = /*#__PURE__*/__webpack_require__.n(background_cover);

// EXTERNAL MODULE: ./node_modules/iphone-inline-video/dist/iphone-inline-video.es-modules.js + 1 modules
var iphone_inline_video_es_modules = __webpack_require__("YvrV");

// EXTERNAL MODULE: ./node_modules/insert-rule/src/insertRule.js
var insertRule = __webpack_require__("6Jmu");
var insertRule_default = /*#__PURE__*/__webpack_require__.n(insertRule);

// CONCATENATED MODULE: ./src/foo/utils/Noise.js



/**
 * Created by Erick Bazán <https://github.com/amorino>
 * Retina rendering by Mendieta <https://github.com/mendieta>
 */

var Noise_Noise = function () {

  /**
   * @param {{container: HTMLElement, tile: number, globalAlpha:number}} data
   */


  /**
   * @type {HTMLCanvasElement}
   */


  /**
   * @type {HTMLElement}
   */


  /**
   * @default 256
   * @type {number}
   */


  /**
   * @default 0
   * @type {number}
   */
  function Noise(_ref) {
    var container = _ref.container,
        _ref$tile = _ref.tile,
        tile = _ref$tile === undefined ? 256 : _ref$tile,
        _ref$globalAlpha = _ref.globalAlpha,
        globalAlpha = _ref$globalAlpha === undefined ? 0.08 : _ref$globalAlpha;

    classCallCheck_default()(this, Noise);

    _initialiseProps.call(this);

    if (!container) throw new Error("You must pass a container DOM element");
    this.container = container;
    this.canvas = document.createElement("canvas");
    this.canvas.style.position = "absolute";
    this.canvas.style.width = "100%";
    this.canvas.style.height = "100%";
    this.canvas.style.top = 0;
    this.canvas.style.left = 0;
    this.container.appendChild(this.canvas);
    this.ref = document.createElement("canvas");
    this.tile = tile;
    this.globalAlpha = globalAlpha;
    this.init();
  }

  /**
   * @type {CanvasRenderingContext2D}
   */


  /**
   * @type {HTMLCanvasElement}
   */


  /**
   * @default false
   * @type {boolean}
   */


  /**
   * @type {number}
   */

  /**
   * @default 0
   * @type {number}
   */


  createClass_default()(Noise, [{
    key: "init",
    value: function init() {
      this._ready();
      this._setupRender();
      this._mount();
    }

    /**
     * @return {Noise}
     * @private
     */

  }, {
    key: "_ready",
    value: function _ready() {
      this.width = this.container.offsetWidth * window.devicePixelRatio;
      this.height = this.container.offsetHeight * window.devicePixelRatio;
      this.ref.width = this.ref.height = this.tile;
      return this;
    }

    /**
     * @return {Noise}
     * @private
     */

  }, {
    key: "_setupRender",
    value: function _setupRender() {
      this.ctx = this.canvas.getContext("2d");
      return this;
    }

    /**
     * @return {Noise}
     * @private
     */

  }, {
    key: "_mount",
    value: function _mount() {
      this._update();
      return this;
    }

    /**
     * @private
     */


    /**
     * @param {CanvasRenderingContext2D} ctx
     * @private
     */


    /**
     * @param {{container:HTMLElement }} data
     */

  }]);

  return Noise;
}();

var _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.width = 0;
  this.height = 0;
  this.globalAlpha = 0.08;
  this.tile = 256;
  this.destroyed = false;
  this.container = null;
  this.canvas = null;
  this.ref = null;
  this.ctx = null;

  this._update = function () {
    // https://hacks.mozilla.org/2011/08/animating-with-javascript-from-setinterval-to-requestanimationframe/
    if (!_this.destroyed) {
      _this._noise(_this.ref.getContext("2d"));
      var tileWidth = (_this.ctx, Math.ceil(_this.width / _this.tile));
      var tileHeight = Math.ceil(_this.height / _this.tile);
      var x = 0;
      var y = 0;
      _this.canvas.width = _this.width;
      _this.canvas.height = _this.height;
      _this.ctx.save();
      _this.ctx.globalAlpha = _this.globalAlpha;
      for (var i = 0; i < tileWidth; i++) {
        for (var j = 0; j < tileHeight; j++) {
          _this.ctx.drawImage(_this.ref, x, y);
          y += _this.tile;
        }
        x += _this.tile;
        y = 0;
      }
      //this.ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
      _this.ctx.restore();
      window.requestAnimationFrame(_this._update);
    }
  };

  this._noise = function (ctx) {
    var image = ctx.createImageData(_this.tile, _this.tile);
    for (var dataBuffer = new Uint32Array(image.data.buffer), bufferLength = dataBuffer.length, i = 0; i < bufferLength;) {
      dataBuffer[i++] = (255 * Math.random() | 0) << 24;
    }
    ctx.putImageData(image, 0, 0);
  };

  this.resize = function (_ref2) {
    var container = _ref2.container;

    _this.width = container.offsetWidth * window.devicePixelRatio;
    _this.height = container.offsetHeight * window.devicePixelRatio;
  };

  this.destroy = function () {
    _this.destroyed = true;
    _this.ctx = null;
    _this.ref = null;
    window.cancelAnimationFrame(_this._update());
  };
};

/* harmony default export */ var utils_Noise = (Noise_Noise);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/foo/components/BackgroundVideo.vue
//
//
//
//
//






var iOSNavigator = typeof navigator !== 'undefined' && navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
var iOSVersion = iOSNavigator ? iOSNavigator[1] : null;

/* harmony default export */ var BackgroundVideo = ({
    props: {
        playsinline: {
            type: Boolean,
            default: false
        },
        disableBackgroundCover: {
            type: Boolean,
            default: false
        },
        containerWidth: {
            type: Number,
            required: true
        },
        containerHeight: {
            type: Number,
            required: true
        },
        src: {
            type: [String, Array],
            required: true
        },
        poster: {
            type: String,
            default: ''
        },
        horizontalAlign: {
            type: Number,
            default: 0.5
        },
        verticalAlign: {
            type: Number,
            default: 0.5
        },
        preload: {
            type: String,
            default: 'auto'
        },
        muted: {
            type: Boolean,
            default: true
        },
        volume: {
            type: Number,
            default: 1
        },
        loop: {
            type: Boolean,
            default: true
        },
        autoPlay: {
            type: Boolean,
            default: true
        },
        extraVideoElementProps: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        startTime: {
            type: Number,
            default: 0
        },
        tabIndex: {
            type: Number,
            default: 0
        },
        useNoise: {
            type: Boolean,
            default: false
        },
        noiseTile: {
            type: Number,
            default: 256
        },
        noiseAlpha: {
            type: Number,
            default: 0.08
        }
    },
    data: function data() {
        return {
            visible: false,
            hasStarted: false,
            startTimeIsSet: false
        };
    },
    mounted: function mounted() {
        this.$nextTick(this.init);
    },

    methods: {
        init: function init() {
            if (this.playsinline && iOSVersion) {
                var hasAudio = !(iOSVersion && iOSVersion < 10 && this.props.autoPlay && this.props.muted); // allow auto play on iOS < 10 for silent videos
                var requireInteractionOnTablet = false;

                Object(iphone_inline_video_es_modules["a" /* default */])(this.$refs['video'], hasAudio, requireInteractionOnTablet);
                insertRule_default()(['video::-webkit-media-controls-start-playback-button', '.IIV::-webkit-media-controls-play-button'], {
                    display: 'none'
                });
            }
            if (this.$refs['video'].readyState !== 4) {
                this.$refs['video'].addEventListener('loadedmetadata', this.handleVideoReady);
            } else {
                this.handleVideoReady();
            }

            if (this.useNoise) {
                this.noise = new utils_Noise({
                    container: this.$refs["container"],
                    tile: this.noiseTile,
                    globalAlpha: this.noiseAlpha
                });
            }

            this.$refs['video'].addEventListener('play', this.onPlayHandler);
            this.$refs['video'].addEventListener('pause', this.onPauseHandler);
            this.$refs['video'].volume = this.volume;

            this.resize();
        },
        handleVideoReady: function handleVideoReady() {
            var duration = this.$refs['video'].duration;
            this.resize();
            this.setCurrentTime(this.startTime);
            this.autoPlay && this.play();
            this.$emit('ready', duration);
            if (!this.poster) this.visible = true;
        },
        handlePosterReady: function handlePosterReady() {
            this.resize();
            this.visible = true;
        },
        onPlayHandler: function onPlayHandler() {
            if (!this.hasStarted) this.hasStarted = true;
            this.$emit('play');
        },
        onPauseHandler: function onPauseHandler() {
            this.$emit('pause');
        },
        handleTimeUpdate: function handleTimeUpdate() {
            iOSVersion && this.handleIOSStartTime();
            var currentTime = this.$refs['video'].currentTime;
            var duration = this.$refs['video'].duration;
            var progress = currentTime / duration;
            this.$emit('time', { currentTime: currentTime, progress: progress, duration: duration });
        },
        handleVideoEnd: function handleVideoEnd() {
            this.$emit('end');
        },
        handleIOSStartTime: function handleIOSStartTime() {
            if (this.$refs['video'].currentTime < this.startTime) {
                if (!this.startTimeIsSet) {
                    this.setCurrentTime(this.startTime);
                    this.startTimeIsSet = true;
                }
            }
        },
        play: function play() {
            this.$refs['video'].play();
        },
        pause: function pause() {
            this.$refs['video'].pause();
        },
        togglePlay: function togglePlay() {
            this.$refs['video'].paused ? this.play() : this.pause();
        },
        isPaused: function isPaused() {
            return this.$refs['video'].paused;
        },
        mute: function mute() {
            this.$refs['video'].muted = true;
            this.$emit('mute');
        },
        unmute: function unmute() {
            this.$refs['video'].muted = false;
            this.$emit('unmute');
        },
        toggleMute: function toggleMute() {
            this.$refs['video'].muted ? this.unmute() : this.mute();
        },
        isMuted: function isMuted() {
            return this.$refs['video'].muted;
        },
        setCurrentTime: function setCurrentTime(value) {
            this.$refs['video'].currentTime = value;
        },
        onClickHandler: function onClickHandler(event) {
            this.$emit('click', event);
        },
        onKeyPressHandler: function onKeyPressHandler(event) {
            this.$emit('keypress', event);
        },
        resize: function resize() {
            if (!this.disableBackgroundCover) {
                Object(background_cover["BackgroundCover"])(this.$refs['video'], this.$refs['container'], this.horizontalAlign, this.verticalAlign);
                this.$refs['poster'] && Object(background_cover["BackgroundCover"])(this.$refs['poster'], this.$refs['container'], this.horizontalAlign, this.verticalAlign);
            }
            this.noise && this.noise.resize({ container: this.$refs["container"] });
        }
    },
    computed: {},
    watch: {
        containerWidth: function containerWidth() {
            this.resize();
        },
        containerHeight: function containerHeight() {
            this.resize();
        },
        volume: function volume(value) {
            this.$refs['video'].volume = value;
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.noise && this.noise.destroy();
        this.$refs['video'].removeEventListener('loadedmetadata', this.handleVideoReady);
        this.$refs['video'].removeEventListener('play', this.onPlayHandler);
        this.$refs['video'].removeEventListener('pause', this.onPauseHandler);
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f10eaef6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/foo/components/BackgroundVideo.vue
var BackgroundVideo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"BackgroundVideo",attrs:{"tabIndex":_vm.tabIndex},on:{"click":_vm.onClickHandler,"keypress":_vm.onKeyPressHandler}},[(typeof _vm.src === 'object' && _vm.src.length > 1)?_c('video',{ref:"video",attrs:{"preload":_vm.preload,"loop":_vm.loop,"playsinline":_vm.playsinline},domProps:{"muted":_vm.muted},on:{"ended":_vm.handleVideoEnd,"timeupdate":_vm.handleTimeUpdate}},_vm._l((_vm.src),function(source,index){return _c('source',{key:index,attrs:{"src":source.src}})}),0):_c('video',{ref:"video",attrs:{"src":_vm.src,"preload":_vm.preload,"loop":_vm.loop,"playsinline":_vm.playsinline},domProps:{"muted":_vm.muted},on:{"ended":_vm.handleVideoEnd,"timeupdate":_vm.handleTimeUpdate}}),_vm._v(" "),(_vm.poster && !_vm.hasStarted)?_c('img',{ref:"poster",attrs:{"src":_vm.poster,"draggable":"false"},on:{"load":_vm.handlePosterReady}}):_vm._e()])}
var BackgroundVideo_staticRenderFns = []
var BackgroundVideo_esExports = { render: BackgroundVideo_render, staticRenderFns: BackgroundVideo_staticRenderFns }
/* harmony default export */ var components_BackgroundVideo = (BackgroundVideo_esExports);
// CONCATENATED MODULE: ./src/foo/components/BackgroundVideo.vue
function BackgroundVideo_injectStyle (ssrContext) {
  __webpack_require__("12/8")
}
var BackgroundVideo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var BackgroundVideo___vue_template_functional__ = false
/* styles */
var BackgroundVideo___vue_styles__ = BackgroundVideo_injectStyle
/* scopeId */
var BackgroundVideo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var BackgroundVideo___vue_module_identifier__ = null
var BackgroundVideo_Component = BackgroundVideo_normalizeComponent(
  BackgroundVideo,
  components_BackgroundVideo,
  BackgroundVideo___vue_template_functional__,
  BackgroundVideo___vue_styles__,
  BackgroundVideo___vue_scopeId__,
  BackgroundVideo___vue_module_identifier__
)

/* harmony default export */ var foo_components_BackgroundVideo = (BackgroundVideo_Component.exports);

// EXTERNAL MODULE: ./src/assets/svg/play.svg
var svg_play = __webpack_require__("IHlG");
var play_default = /*#__PURE__*/__webpack_require__.n(svg_play);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/foo/components/VideoPoster.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoPoster = ({
    props: {
        className: {
            type: String,
            default: ""
        },
        hasPlayButton: {
            type: Boolean,
            default: false
        },
        poster: {
            type: String,
            required: true
        },
        fadeDuration: {
            type: Number,
            default: 0
        }
    },
    data: function data() {
        return {};
    },

    components: { PlayIcon: play_default.a },
    mounted: function mounted() {},

    methods: {
        onEnter: function onEnter(el, done) {
            gsap_TweenMax["TweenMax"].fromTo(el, this.fadeDuration / 1000, { autoAlpha: 0 }, { autoAlpha: 1, onComplete: done });
        },
        onLeave: function onLeave(el, done) {
            gsap_TweenMax["TweenMax"].to(el, this.fadeDuration / 1000, {
                autoAlpha: 0,
                onComplete: done
            });
        },
        onClickHandler: function onClickHandler() {
            this.$emit("click");
        }
    },
    computed: {
        styleObject: function styleObject() {
            return {
                backgroundImage: "url('" + this.poster + "')"
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b44b2a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/foo/components/VideoPoster.vue
var VideoPoster_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","css":false},on:{"enter":_vm.onEnter,"leave":_vm.onLeave}},[_c('div',{ref:"container",class:("VideoPoster " + _vm.className),style:(_vm.styleObject),on:{"click":_vm.onClickHandler}},[(_vm.hasPlayButton)?_c('button',{attrs:{"aria-label":"Play Video"}},[_c('play-icon')],1):_vm._e()])])}
var VideoPoster_staticRenderFns = []
var VideoPoster_esExports = { render: VideoPoster_render, staticRenderFns: VideoPoster_staticRenderFns }
/* harmony default export */ var components_VideoPoster = (VideoPoster_esExports);
// CONCATENATED MODULE: ./src/foo/components/VideoPoster.vue
function VideoPoster_injectStyle (ssrContext) {
  __webpack_require__("Weh9")
}
var VideoPoster_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var VideoPoster___vue_template_functional__ = false
/* styles */
var VideoPoster___vue_styles__ = VideoPoster_injectStyle
/* scopeId */
var VideoPoster___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoPoster___vue_module_identifier__ = null
var VideoPoster_Component = VideoPoster_normalizeComponent(
  VideoPoster,
  components_VideoPoster,
  VideoPoster___vue_template_functional__,
  VideoPoster___vue_styles__,
  VideoPoster___vue_scopeId__,
  VideoPoster___vue_module_identifier__
)

/* harmony default export */ var foo_components_VideoPoster = (VideoPoster_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/foo/components/VideoTimeline.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VideoTimeline = ({
    props: {
        className: {
            type: String,
            default: ""
        },
        duration: {
            type: Number,
            required: true
        },
        currentTime: {
            type: Number,
            required: true
        }
    },
    data: function data() {
        return {
            isMouseDown: false
        };
    },

    methods: {
        onChangeHandler: function onChangeHandler() {
            this.$emit("timechange", this.$refs["input"].value);
        },
        onUpdateHandler: function onUpdateHandler() {
            this.$emit("timechange", this.$refs["input"].value);
        },
        onMouseDownHandler: function onMouseDownHandler() {
            this.isMouseDown = true;
        },
        onMouseUpHandler: function onMouseUpHandler() {
            this.isMouseDown = false;
        }
    },
    computed: {
        progressStyle: function progressStyle() {
            return {
                width: this.currentTime / this.duration * 100 + "%"
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67f02c70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/foo/components/VideoTimeline.vue
var VideoTimeline_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("VideoTimeline " + _vm.className)},[_c('div',{staticClass:"progress",style:(_vm.progressStyle)}),_vm._v(" "),_c('input',{ref:"input",attrs:{"type":"range","min":0,"max":_vm.duration,"step":0.001},domProps:{"value":_vm.currentTime},on:{"change":_vm.onChangeHandler,"input":_vm.onUpdateHandler,"mousedown":_vm.onMouseDownHandler,"mouseup":_vm.onMouseUpHandler}})])}
var VideoTimeline_staticRenderFns = []
var VideoTimeline_esExports = { render: VideoTimeline_render, staticRenderFns: VideoTimeline_staticRenderFns }
/* harmony default export */ var components_VideoTimeline = (VideoTimeline_esExports);
// CONCATENATED MODULE: ./src/foo/components/VideoTimeline.vue
function VideoTimeline_injectStyle (ssrContext) {
  __webpack_require__("EwuT")
}
var VideoTimeline_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var VideoTimeline___vue_template_functional__ = false
/* styles */
var VideoTimeline___vue_styles__ = VideoTimeline_injectStyle
/* scopeId */
var VideoTimeline___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoTimeline___vue_module_identifier__ = null
var VideoTimeline_Component = VideoTimeline_normalizeComponent(
  VideoTimeline,
  components_VideoTimeline,
  VideoTimeline___vue_template_functional__,
  VideoTimeline___vue_styles__,
  VideoTimeline___vue_scopeId__,
  VideoTimeline___vue_module_identifier__
)

/* harmony default export */ var foo_components_VideoTimeline = (VideoTimeline_Component.exports);

// CONCATENATED MODULE: ./src/foo/utils/Share.js



/**
 * Helper class for social sharing dialogs.
 * @class Share
 * @namespace utils
 * @author Mendieta
 */
var Share_Share = function () {
  function Share() {
    classCallCheck_default()(this, Share);
  }

  createClass_default()(Share, null, [{
    key: "_openWindow",


    /**
     * Opens a new window with the specified url and size
     * @param {string} url The url to be shared
     * @param {number} w The width of the new window
     * @param {number} h the height of the new window
     * @return {void}
     * @static
     * @private
     * @method _openWindow
     */
    value: function _openWindow(url, w, h) {
      var left = window.screen.availWidth - w >> 1;
      var top = window.screen.availHeight - h >> 1;
      window.open(url, "", "top=" + top + ",left=" + left + ",width=" + w + ",height=" + h + ",location=no,menubar=no");
    }

    /**
     * Shares to Google+
     * @param {string} url The url to be shared
     * @return {void}
     * @static
     * @method plus
     */

  }, {
    key: "plus",
    value: function plus(url) {
      url = encodeURIComponent(url);
      this._openWindow("https://plus.google.com/share?url=" + url, 650, 385);
    }

    /**
     * Shares to Pinterest
     * @param {string} url The url to be shared
     * @param {string} media The url to the media to be shared
     * @param {string} descr The description
     * @return {void}
     * @method pinterest
     * @static
     */

  }, {
    key: "pinterset",
    value: function pinterset(url, media, descr) {
      url = encodeURIComponent(url);
      media = encodeURIComponent(media);
      descr = encodeURI(descr);
      this._openWindow("http://www.pinterest.com/pin/create/button/?url=#{url}&media=" + media + "&description=" + descr, 735, 310);
    }

    /**
     * Shares to Tumblr
     * @param {string} url The url be shared
     * @param {string} media The url of the media to be shared
     * @param {string} descr The description
     * @return {void}
     * @method tumblr
     * @static
     */

  }, {
    key: "tumblr",
    value: function tumblr(url, media, descr) {
      url = encodeURIComponent(url);
      media = encodeURIComponent(media);
      descr = encodeURIComponent(descr);
      this._openWindow("http://www.tumblr.com/share/photo?source=#{media}&caption=" + descr + "&click_thru=" + url, 450, 430);
    }

    /**
     * Shares to facebook
     * @param {string} url The url to be shared
     * @return {void}
     * @method facebook
     * @static
     */

  }, {
    key: "facebook",
    value: function facebook(url) {
      url = encodeURIComponent(url);
      this._openWindow("http://www.facebook.com/share.php?u=" + url, 600, 300);
    }

    /**
     * Shares to twitter
     * @param {string} url The url to be shared
     * @param {string} [descr=""] The description
     * @return {void}
     * @method twitter
     * @static
     */

  }, {
    key: "twitter",
    value: function twitter(url) {
      var descr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      url = encodeURI(url);
      descr = encodeURIComponent(descr);
      this._openWindow("http://twitter.com/intent/tweet/?text=" + descr + "&url=" + url, 600, 300);
    }

    /**
     * Shares to renren
     * @param {string} url The url to be shared
     * @return {void}
     * @method renren
     * @static
     */

  }, {
    key: "renren",
    value: function renren(url) {
      url = encodeURIComponent(url);
      this._openWindow("http://share.renren.com/share/buttonshare.do?link=" + url, 600, 300);
    }

    /**
     * Shares to weibo
     * @param {string} url the url to be shared
     * @return {void}
     * @method weibo
     * @static
     */

  }, {
    key: "weibo",
    value: function weibo(url) {
      url = encodeURIComponent(url);
      this._openWindow("http://service.weibo.com/share/share.php?url=" + url + "&language=zh_cn", 600, 300);
    }
  }]);

  return Share;
}();

/* harmony default export */ var utils_Share = (Share_Share);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/SocialShare.vue
//
//
//
//
//
//



/* harmony default export */ var SocialShare = ({
    name: 'SocialShare',
    props: {
        url: {
            type: String,
            required: true
        }
    },
    components: {
        SocialNav: app_components_SocialNav
    },
    data: function data() {
        return {
            items: [{
                id: 'facebook',
                iconId: 'icon-facebook'
            }, {
                id: 'twitter',
                iconId: 'icon-twitter'
            }]
        };
    },
    methods: {
        share: function share(id) {
            if (id === 'facebook') this.facebookShare();
            if (id === 'twitter') this.twitterShare();
        },
        facebookShare: function facebookShare() {
            var url = this.url;

            utils_Share.facebook(url);
        },
        twitterShare: function twitterShare() {
            var url = this.url,
                data = this.data;

            utils_Share.twitter(url, data.twitter);
        }
    },
    computed: {
        data: function data() {
            var $store = this.$store;

            return $store.getters.data.share;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d915fe9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/SocialShare.vue
var SocialShare_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('social-nav',{attrs:{"items":_vm.items},on:{"item-click":_vm.share}},[_vm._v("\n    "+_vm._s(_vm.data.label)+"\n")])}
var SocialShare_staticRenderFns = []
var SocialShare_esExports = { render: SocialShare_render, staticRenderFns: SocialShare_staticRenderFns }
/* harmony default export */ var components_SocialShare = (SocialShare_esExports);
// CONCATENATED MODULE: ./src/app/components/SocialShare.vue
function SocialShare_injectStyle (ssrContext) {
  __webpack_require__("F9vg")
}
var SocialShare_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SocialShare___vue_template_functional__ = false
/* styles */
var SocialShare___vue_styles__ = SocialShare_injectStyle
/* scopeId */
var SocialShare___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SocialShare___vue_module_identifier__ = null
var SocialShare_Component = SocialShare_normalizeComponent(
  SocialShare,
  components_SocialShare,
  SocialShare___vue_template_functional__,
  SocialShare___vue_styles__,
  SocialShare___vue_scopeId__,
  SocialShare___vue_module_identifier__
)

/* harmony default export */ var app_components_SocialShare = (SocialShare_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/VideoModal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var VideoModal = ({
    name: 'VideoModal',
    components: {
        TextTransition: app_transitions_TextTransition,
        BackgroundVideo: foo_components_BackgroundVideo,
        VideoPoster: foo_components_VideoPoster,
        VideoTimeline: foo_components_VideoTimeline,
        SocialShare: app_components_SocialShare
    },
    data: function data() {
        return {
            containerHeight: 0,
            containerWidth: 0,
            currentTime: 0,
            duration: 0,
            hideControlsTimeout: undefined,
            progress: 0,
            videoEnded: false,
            videoPlayed: false,
            videoPlaying: false,
            showControls: true,
            showOverlay: true,
            showPoster: true,
            timeLineTexts: {
                "pause": "pausar",
                "continue": "continuar viendo",
                "replay": "volver a ver",
                "play": "reproducir"
            }
        };
    },

    props: {
        artistName: {
            type: String,
            default: undefined
        },
        artistNumber: {
            type: [Number, String],
            default: undefined
        },
        hideControlsTime: {
            type: Number,
            default: 2500
        },
        poster: {
            type: String
        },
        src: {
            type: [String, Array],
            default: undefined
        }
    },
    computed: {
        controlsVisible: function controlsVisible() {
            return this.showOverlay || this.showControls;
        },
        formattedArtistNumber: function formattedArtistNumber() {
            if (this.artistNumber && typeof this.artistNumber === "number") {
                return this.artistNumber.toString().padStart(2, 0);
            } else if (this.artistNumber && this.artistNumber === "string") {
                return this.artistNumber;
            }
            return "00";
        },
        posterIsVisible: function posterIsVisible() {
            return this.poster && this.showPoster;
        },
        timeLineTextAction: function timeLineTextAction() {
            if (this.videoPlaying) {
                return this.timeLineTexts.pause;
            } else if (this.videoEnded) {
                return this.timeLineTexts.replay;
            } else if (!this.videoPlayed) {
                return this.timeLineTexts.play;
            } else {
                return this.timeLineTexts.continue;
            }
        },
        shareURL: function shareURL() {
            return location.href;
        }
    },
    methods: {
        fadeIn: function fadeIn($el, done) {
            console.log("enter anim");
            TweenMax.to($el, 1, {
                delay: 0.2,
                alpha: 1,
                onComplete: done
            });
        },
        fadeOut: function fadeOut($el, done) {
            TweenMax.to($el, 1, {
                delay: 0.2,
                alpha: 0,
                onComplete: done
            });
        },
        blendFadeIn: function blendFadeIn() {
            var _$refs = this.$refs,
                blend0 = _$refs.blend0,
                blend1 = _$refs.blend1;

            var fadeTime = 0.35;
            TweenMax.to(blend0, fadeTime, {
                autoAlpha: 1,
                ease: Cubic.easeOut
            });
            TweenMax.to(blend1, fadeTime, {
                autoAlpha: 0.77,
                ease: Cubic.easeOut
            });
        },
        bladeFadeOut: function bladeFadeOut() {
            var _$refs2 = this.$refs,
                blend0 = _$refs2.blend0,
                blend1 = _$refs2.blend1;

            var fadeTime = 0.35;
            TweenMax.to([blend0, blend1], fadeTime, {
                autoAlpha: 0,
                delay: this.$refs.poster ? 0.5 : 0,
                ease: Cubic.easeOut
            });
        },
        controlsHide: function controlsHide() {
            var timeline = this.$refs.timeline;

            TweenMax.to(timeline, 0.4, {
                autoAlpha: 0,
                yPercent: 100,
                ease: Power3.easeInOut
            });
        },
        controlsShow: function controlsShow() {
            var timeline = this.$refs.timeline;

            TweenMax.to(timeline, 0.4, {
                autoAlpha: 1,
                yPercent: 0,
                ease: Power3.easeInOut
            });
        },
        eventsAdd: function eventsAdd() {
            window.addEventListener("resize", this.onResize);
            window.addEventListener("mousemove", this.onMouseMove);
        },
        eventsRemove: function eventsRemove() {
            window.removeEventListener("resize", this.onResize);
            window.removeEventListener("mousemove", this.onMouseMove);
        },
        hideControlsClearTimeOut: function hideControlsClearTimeOut() {
            if (this.hideControlsTimeout) {
                clearTimeout(this.hideControlsTimeout);
                this.hideControlsTimeout = undefined;
            }
        },
        hideControlsSetTimeout: function hideControlsSetTimeout() {
            var _this = this;

            this.hideControlsClearTimeOut();
            this.hideControlsTimeout = setTimeout(function () {
                _this.showControls = false;
                _this.hideControlsClearTimeOut();
            }, this.hideControlsTime);
        },
        onEnd: function onEnd() {
            this.showPoster = true;
            this.videoEnded = true;
        },
        onMouseMove: function onMouseMove() {
            if (this.videoPlaying) {
                this.showControls = true;
                this.hideControlsSetTimeout();
            }
        },
        onPause: function onPause() {
            this.showControls = true;
            this.videoPlaying = false;
            this.showOverlay = true;
        },
        onPlay: function onPlay() {
            this.hideControlsSetTimeout();
            this.videoEnded = false;
            this.videoPlaying = true;
            this.videoPlayed = true;
            this.showPoster = false;
            this.showOverlay = false;
        },
        onResize: function onResize() {
            this.resize(window.innerHeight, window.innerWidth);
            this.posisionateControls();
        },
        posisionateControls: function posisionateControls() {
            var controls = this.$refs.controls,
                showOverlay = this.showOverlay;

            if (showOverlay) {
                TweenMax.to(controls, 0.5, {
                    y: -window.innerHeight / 2 + 184,
                    ease: Power2.easeOut
                });
            } else {
                TweenMax.to(controls, 0.5, {
                    y: 0,
                    ease: Power2.easeOut
                });
            }
        },
        resize: function resize(height, width) {
            this.containerHeight = height;
            this.containerWidth = width;
        },
        togglePlay: function togglePlay() {
            var backgroundVideo = this.$refs.backgroundVideo;

            backgroundVideo.togglePlay();
        },
        updateTimeVars: function updateTimeVars(_ref) {
            var currentTime = _ref.currentTime,
                duration = _ref.duration,
                progress = _ref.progress;

            this.duration = duration;
            this.currentTime = currentTime;
            this.progress = progress;
        },
        videoPause: function videoPause() {
            this.$refs.backgroundVideo.pause();
        },
        videoPlay: function videoPlay() {
            this.$refs.backgroundVideo.play();
        },
        videoToggle: function videoToggle() {
            this.$refs.backgroundVideo.togglePlay();
        }
    },
    watch: {
        showOverlay: function showOverlay(newValue) {
            this.posisionateControls();
            if (!this.videoPlaying && newValue) {
                this.blendFadeIn();
            } else {
                this.bladeFadeOut();
            }
        },
        controlsVisible: function controlsVisible(value) {
            if (value) {
                this.controlsShow();
            } else {
                this.controlsHide();
            }
        }
    },
    mounted: function mounted() {
        this.eventsAdd();
        this.posisionateControls();
    },
    beforeDestroy: function beforeDestroy() {
        this.eventsRemove();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd336ab2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/VideoModal.vue
var VideoModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"VideoModal"},[_c('div',{staticClass:"VideoModal-video"},[(_vm.src && _vm.src.length > 0)?_c('background-video',{ref:"backgroundVideo",staticClass:"VideoModal-BackgroundVideo",attrs:{"auto-play":false,"loop":false,"muted":false,"containerHeight":_vm.containerHeight,"containerWidth":_vm.containerWidth,"src":_vm.src},on:{"click":_vm.videoToggle,"end":_vm.onEnd,"pause":_vm.onPause,"play":_vm.onPlay,"time":_vm.updateTimeVars}}):_vm._e(),_vm._v(" "),(_vm.posterIsVisible)?_c('video-poster',{ref:"poster",staticClass:"VideoModal-poster",attrs:{"poster":_vm.poster,"fadeDuration":500},on:{"click":_vm.videoPlay}}):_vm._e()],1),_vm._v(" "),_c('div',{ref:"blend0",staticClass:"VideoModal-blend blend-0"}),_vm._v(" "),_c('div',{ref:"blend1",staticClass:"VideoModal-blend blend-1"}),_vm._v(" "),(!_vm.videoPlaying && _vm.showOverlay)?_c('div',{staticClass:"VideoModal-overlay"},[_c('div',{staticClass:"VideoModal-overlay-content",on:{"click":function($event){$event.stopPropagation();return _vm.videoPlay($event)}}},[_c('div',{staticClass:"VideoModal-overlay-content-wrapper"},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"VideoModal-logo"},[_c('img',{attrs:{"src":__webpack_require__("dLd/"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"VideoModal-artist"},[_c('svg',{staticClass:"VideoModal-artist-number",attrs:{"viewBox":"0 0 50 35"}},[_c('text',{attrs:{"x":"0","y":"15"}},[_vm._v(_vm._s(_vm.formattedArtistNumber))])]),_vm._v(" "),_c('text-transition',{attrs:{"charMinDuration":0.7,"charMaxDuration":1.2,"introDelay":0.1,"outroDuration":0.5}},[_c('p',{staticClass:"VideoModal-artist-name",domProps:{"innerHTML":_vm._s(_vm.artistName)}})])],1)],1)])]):_vm._e(),_vm._v(" "),_c('div',{ref:"controls",staticClass:"VideoModal-controls",on:{"click":function($event){$event.stopPropagation();return _vm.videoToggle($event)}}},[_c('div',{ref:"timeline",staticClass:"VideoModal-timeLine"},[_c('div',{staticClass:"VideoModal-timeLine-legend"},[_vm._v("Haz click para "+_vm._s(_vm.timeLineTextAction)+" el video")]),_vm._v(" "),_c('div',{staticClass:"VideoModal-timeLine-time"},[_c('video-timeline',{attrs:{"currentTime":_vm.currentTime,"duration":_vm.duration}})],1)]),_vm._v(" "),(!_vm.videoPlaying && _vm.showOverlay)?_c('social-share',{staticClass:"VideoModal-share",attrs:{"url":_vm.shareURL}}):_vm._e()],1)])}
var VideoModal_staticRenderFns = []
var VideoModal_esExports = { render: VideoModal_render, staticRenderFns: VideoModal_staticRenderFns }
/* harmony default export */ var components_VideoModal = (VideoModal_esExports);
// CONCATENATED MODULE: ./src/app/components/VideoModal.vue
function VideoModal_injectStyle (ssrContext) {
  __webpack_require__("hhQz")
}
var VideoModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var VideoModal___vue_template_functional__ = false
/* styles */
var VideoModal___vue_styles__ = VideoModal_injectStyle
/* scopeId */
var VideoModal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoModal___vue_module_identifier__ = null
var VideoModal_Component = VideoModal_normalizeComponent(
  VideoModal,
  components_VideoModal,
  VideoModal___vue_template_functional__,
  VideoModal___vue_styles__,
  VideoModal___vue_scopeId__,
  VideoModal___vue_module_identifier__
)

/* harmony default export */ var app_components_VideoModal = (VideoModal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/CloseLink.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CloseLink = ({
    name: 'CloseLink',
    props: {
        el: {
            type: String,
            default: 'router-link'
        },
        to: {
            type: Object
        }
    },
    methods: {
        onClick: function onClick() {
            this.$emit('close');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ad9b92e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/CloseLink.vue
var CloseLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.el === 'router-link')?_c('router-link',{staticClass:"CloseLink",attrs:{"to":_vm.to},nativeOn:{"click":function($event){return _vm.onClick($event)}}},[_c('span',{staticClass:"CloseLink-bar"}),_vm._v(" "),_c('span',{staticClass:"CloseLink-bar"})]):_c(_vm.el,{tag:"component",staticClass:"CloseLink",on:{"click":_vm.onClick}},[_c('span',{staticClass:"CloseLink-bar"}),_vm._v(" "),_c('span',{staticClass:"CloseLink-bar"})])}
var CloseLink_staticRenderFns = []
var CloseLink_esExports = { render: CloseLink_render, staticRenderFns: CloseLink_staticRenderFns }
/* harmony default export */ var components_CloseLink = (CloseLink_esExports);
// CONCATENATED MODULE: ./src/app/components/CloseLink.vue
function CloseLink_injectStyle (ssrContext) {
  __webpack_require__("LVez")
}
var CloseLink_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CloseLink___vue_template_functional__ = false
/* styles */
var CloseLink___vue_styles__ = CloseLink_injectStyle
/* scopeId */
var CloseLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CloseLink___vue_module_identifier__ = null
var CloseLink_Component = CloseLink_normalizeComponent(
  CloseLink,
  components_CloseLink,
  CloseLink___vue_template_functional__,
  CloseLink___vue_styles__,
  CloseLink___vue_scopeId__,
  CloseLink___vue_module_identifier__
)

/* harmony default export */ var app_components_CloseLink = (CloseLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/views/ChapterVideo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var ChapterVideo = ({
    name: 'ChapterVideo',
    mixins: [ChapterUtils],
    components: {
        VideoModal: app_components_VideoModal,
        CloseLink: app_components_CloseLink
    },
    data: function data() {
        return {
            visible: false
        };
    },
    methods: {
        pauseVideo: function pauseVideo() {
            this.$refs.videoModal.videoPause();
        },
        intro: function intro(el, done) {
            var _this = this;

            TweenLite.fromTo(el, 2, {
                alpha: 0
            }, {
                alpha: 1,
                onComplete: function onComplete() {
                    _this.visible = true;
                    done();
                }
            });
        },
        outro: function outro(el, done) {
            var _this2 = this;

            TweenLite.to(el, 1, {
                alpha: 0,
                onComplete: function onComplete() {
                    _this2.visible = false;
                    done();
                },
                ease: Cubic.easeOut
            });
        }
    },
    computed: {
        index: function index() {
            var activeChapterIndex = this.activeChapterIndex;

            return activeChapterIndex + 1;
        },
        poster: function poster() {
            var chapterVideoCoverList = this.chapterVideoCoverList,
                activeChapterIndex = this.activeChapterIndex;

            return chapterVideoCoverList[activeChapterIndex];
        },
        src: function src() {
            var chapterVideoSrcList = this.chapterVideoSrcList,
                activeChapterIndex = this.activeChapterIndex;

            return chapterVideoSrcList[activeChapterIndex];
        },
        closeTo: function closeTo() {
            return {
                name: CHAPTER
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-019e4069","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/ChapterVideo.vue
var ChapterVideo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false,"appear":""},on:{"enter":_vm.intro,"leave":_vm.outro}},[_c('section',{staticClass:"ChapterVideo"},[(_vm.visible)?_c('video-modal',{ref:"videoModal",attrs:{"artist-name":_vm.activeChapter.name,"artist-number":_vm.index,"hide-controls-time":2500,"poster":_vm.poster,"src":_vm.src}}):_vm._e(),_vm._v(" "),_c('close-link',{attrs:{"to":_vm.closeTo},on:{"close":_vm.pauseVideo}})],1)])}
var ChapterVideo_staticRenderFns = []
var ChapterVideo_esExports = { render: ChapterVideo_render, staticRenderFns: ChapterVideo_staticRenderFns }
/* harmony default export */ var views_ChapterVideo = (ChapterVideo_esExports);
// CONCATENATED MODULE: ./src/app/views/ChapterVideo.vue
function ChapterVideo_injectStyle (ssrContext) {
  __webpack_require__("aqVO")
}
var ChapterVideo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChapterVideo___vue_template_functional__ = false
/* styles */
var ChapterVideo___vue_styles__ = ChapterVideo_injectStyle
/* scopeId */
var ChapterVideo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ChapterVideo___vue_module_identifier__ = null
var ChapterVideo_Component = ChapterVideo_normalizeComponent(
  ChapterVideo,
  views_ChapterVideo,
  ChapterVideo___vue_template_functional__,
  ChapterVideo___vue_styles__,
  ChapterVideo___vue_scopeId__,
  ChapterVideo___vue_module_identifier__
)

/* harmony default export */ var app_views_ChapterVideo = (ChapterVideo_Component.exports);

// CONCATENATED MODULE: ./src/app/utils/backgroundUtils.js
/**
 * @typedef Rect
 * @prop {Number} width
 * @prop {Number} height
 * @prop {Number} top
 * @prop {Number} right
 * @prop {Number} bottom
 * @prop {Number} left
 */

/**
 * @private
 * @param {Number} tw - targetWidth
 * @param {Number} th - targetHeight
 * @param {Number} cw - containerWidth
 * @param {Number} ch - containerHeight
 * @returns {Rect}
 */
function _getRect(tw, th, cw, ch, ratio) {
  var rect = {};
  rect.width = Math.round(tw * ratio);
  rect.height = Math.round(th * ratio);
  rect.top = (ch - rect.height) / 2;
  rect.left = (cw - rect.width) / 2;
  return rect;
}

/**
 * @param {Number} tw - targetWidth
 * @param {Number} th - targetHeight
 * @param {Number} cw - containerWidth
 * @param {Number} ch - containerHeight
 * @returns {Rect}
 */
function getCoverRect(tw, th, cw, ch) {
  var ratio = Math.max(cw / tw, ch / th);
  return _getRect(tw, th, cw, ch, ratio);
}

/**
 * @param {Number} tw - targetWidth
 * @param {Number} th - targetHeight
 * @param {Number} cw - containerWidth
 * @param {Number} ch - containerHeight
 * @returns {Rect}
 */
function getContainRect(tw, th, cw, ch) {
  var ratio = Math.min(cw / tw, ch / th);
  return _getRect(tw, th, cw, ch, ratio);
}
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/pixi.js/lib/index.js
var pixi_js_lib = __webpack_require__("50uv");
var pixi_js_lib_default = /*#__PURE__*/__webpack_require__.n(pixi_js_lib);

// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__("Ba3q");
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);

// CONCATENATED MODULE: ./src/app/utils/pixi/Loader.js










/**
 * @typedef {Object} Config
 * @prop {[String]} assets - Assets URLs array
 *
 * @typedef {Object<string, PIXI.loaders.Resource>} ResourcesCache
 */

var Loader_Loader = function () {

    /**
     * PIXI Loader wrapper. This Loader is meant to be more Vue friendly, it can
     * load several times the same assets without the PIXI TextureCache and
     * BaseTextureCache warnings. Note that it uses its own cache.
     * @param {Config} config
     */


    /**
     * @type {PIXI.loaders.Loader}
     */
    function Loader(config) {
        classCallCheck_default()(this, Loader);

        this._pixiLoader = new pixi_js_lib["loaders"].Loader();
        this._assets = [];

        this._assets = config && config.assets ? [].concat(toConsumableArray_default()(config.assets)) : [];
    }

    /**
     * @type {[String]}
     */


    createClass_default()(Loader, [{
        key: "_filterAssets",


        /**
         * Filters assets that aren't loaded. In other words, the assets missing in
         * `Loader._ResourcesCache`.
         * @returns {[String]}
         * @private
         */
        value: function _filterAssets() {
            var _assets = this._assets;

            return _assets.filter(function (asset) {
                return !Loader._urls[asset];
            });
        }

        /**
         * Adds the resources of this instance `_pixiLoader` to
         * `Loader._ResourcesCache` if they aren't already there.
         * @private
         */

    }, {
        key: "_updateResources",
        value: function _updateResources() {
            var _pixiLoader = this._pixiLoader;

            for (var key in _pixiLoader.resources) {
                var resource = Loader._ResourcesCache[key];
                if (!resource) {
                    Loader._ResourcesCache[key] = _pixiLoader.resources[key];
                }
            }
        }
    }, {
        key: "_updateUrls",
        value: function _updateUrls(assets) {
            assets.forEach(function (asset) {
                Loader._urls.push(asset);
            });
        }

        /**
         * Loads assets passed in config.
         * @return {Promise<Loader>}
         */

    }, {
        key: "load",
        value: function load() {
            var _this = this;

            var loading = this.loading,
                loaded = this.loaded,
                _pixiLoader = this._pixiLoader;

            if (loading || loaded) {
                return promise_default.a.resolve(this);
            }
            return new promise_default.a(function (resolve, reject) {
                var assets = _this._filterAssets();
                assets.forEach(function (asset) {
                    _pixiLoader.add(asset);
                });
                _this._updateUrls(assets);
                _pixiLoader.onLoad.add(function (l, resource) {
                    if (resource.spritesheet) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = get_iterator_default()(entries_default()(resource.spritesheet.animations)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var _ref = _step.value;

                                var _ref2 = slicedToArray_default()(_ref, 2);

                                var key = _ref2[0];
                                var animation = _ref2[1];

                                _this._addAnimation(key, animation);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                });
                _pixiLoader.onComplete.add(function () {
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = get_iterator_default()(entries_default()(Loader._Animations)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var _ref3 = _step2.value;

                            var _ref4 = slicedToArray_default()(_ref3, 2);

                            var key = _ref4[0];
                            var animations = _ref4[1];

                            Loader._Animations[key] = orderBy_default()(animations, ["textureCacheIds"]);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    _this._updateResources();
                    resolve(_this);
                });
                _pixiLoader.onError.add(reject);
                _pixiLoader.load();
            });
        }

        /**
         * Loads assets passed in config.
         * @return {Promise<Loader>}
         */

    }, {
        key: "loadAsset",
        value: function loadAsset(assetIndex) {
            var _this2 = this;

            var loading = this.loading,
                loaded = this.loaded,
                _pixiLoader = this._pixiLoader;

            if (loading || loaded) {
                return promise_default.a.resolve(this);
            }
            return new promise_default.a(function (resolve, reject) {
                var assets = _this2._filterAssets();
                var asset = assets[assetIndex];
                if (!_pixiLoader.resources[asset]) {
                    _pixiLoader.add(asset);
                }

                _this2._updateUrls(assets);

                _pixiLoader.onLoad.add(function (l, resource) {
                    if (resource.spritesheet) {
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = get_iterator_default()(entries_default()(resource.spritesheet.animations)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var _ref5 = _step3.value;

                                var _ref6 = slicedToArray_default()(_ref5, 2);

                                var key = _ref6[0];
                                var animation = _ref6[1];

                                _this2._addAnimation(key, animation);
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    }
                });

                _pixiLoader.onComplete.add(function () {
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = get_iterator_default()(entries_default()(Loader._Animations)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var _ref7 = _step4.value;

                            var _ref8 = slicedToArray_default()(_ref7, 2);

                            var key = _ref8[0];
                            var animations = _ref8[1];

                            Loader._Animations[key] = orderBy_default()(animations, ["textureCacheIds"]);
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }

                    _this2._updateResources();
                    resolve(_this2);
                });

                _pixiLoader.onError.add(reject);
                _pixiLoader.load();
            });
        }
    }, {
        key: "reset",
        value: function reset() {
            this._pixiLoader.reset();
        }
    }, {
        key: "addImage",
        value: function addImage(url) {
            this._assets.push(url);
        }
    }, {
        key: "_addAnimation",
        value: function _addAnimation(key, anim) {
            if (!Loader._Animations.hasOwnProperty(key)) {
                Loader._Animations[key] = [];
            }
            Loader._Animations[key] = Loader._Animations[key].concat(anim);
        }

        /**
         * All resources loaded with instances of this Loader are saved in this
         * object.
         * @type {ResourcesCache}
         * @private
         */

    }, {
        key: "progress",
        get: function get() {
            return this._pixiLoader.progress;
        }
    }, {
        key: "loading",
        get: function get() {
            return this._pixiLoader.loading;
        }
    }, {
        key: "loaded",
        get: function get() {
            return this.progress === 100;
        }
    }, {
        key: "pixiLoader",
        get: function get() {
            return this._pixiLoader;
        }

        /**
         * Resources loaded. Sometimes `loaderInstance.pixiLoader.resources` might
         * be empty, so, always use `loaderInstance.resources`.
         * @type {ResourcesCache}
         */

    }, {
        key: "resources",
        get: function get() {
            var _assets = this._assets;

            return _assets.filter(function (asset) {
                return !!Loader._ResourcesCache[asset];
            }).reduce(function (prev, current) {
                prev[current] = Loader._ResourcesCache[current];
                return prev;
            }, {});
        }

        /**
         * Resources loaded. Sometimes `loaderInstance.pixiLoader.resources` might
         * be empty, so, always use `loaderInstance.resources`.
         * @type {ResourcesCache}
         */

    }, {
        key: "animations",
        get: function get() {
            return Loader._Animations;
        }
    }]);

    return Loader;
}();

Loader_Loader._ResourcesCache = {};
Loader_Loader._urls = [];
Loader_Loader._Animations = {};
/* harmony default export */ var pixi_Loader = (Loader_Loader);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/AnimatedSprite.vue

//
//
//
//
//
//
//
//

// Controlling FPS with requestAnimationFrame:
// https://stackoverflow.com/a/19772220/3841699
/* harmony default export */ var AnimatedSprite = ({
    name: 'AnimatedSprite',
    props: {
        start: {
            type: Number,
            required: true
        },
        end: {
            type: Number,
            required: true
        },
        frames: {
            type: Array,
            required: true
        },
        backwards: {
            type: Boolean,
            default: false
        },
        fps: {
            type: Number,
            default: 30
        }
    },
    data: function data() {
        return {
            then: null,
            frame: null,
            paused: false
        };
    },

    methods: {
        intro: function intro(el, done) {
            this.play();
            done();
        },
        outro: function outro(el, done) {
            this.paused = true;
            done();
        },
        play: function play() {
            var _this = this;

            var startFrame = this.startFrame,
                endFrame = this.endFrame,
                backwards = this.backwards;

            this.paused = false;
            this.frame = backwards ? endFrame : startFrame;
            this.then = Date.now();
            return new promise_default.a(function (resolve, reject) {
                try {
                    _this.update(resolve);
                } catch (err) {
                    reject(err);
                }
            });
        },
        update: function update() {
            var _this2 = this;

            var updateLoop = function updateLoop() {
                if (_this2.paused) {
                    _this2.$emit('complete');
                } else {
                    _this2.updateFrame();
                    requestAnimationFrame(updateLoop);
                }
            };
            updateLoop();
        },
        updateFrame: function updateFrame() {
            var then = this.then,
                fpsInterval = this.fpsInterval;

            var now = Date.now();
            var elapsed = now - then;
            if (elapsed > fpsInterval) {
                var backwards = this.backwards,
                    startFrame = this.startFrame,
                    endFrame = this.endFrame;

                this.then = now - elapsed % fpsInterval;
                if (backwards) {
                    if (this.frame === startFrame) {
                        this.paused = true;
                    } else {
                        this.frame--;
                    }
                } else {
                    if (this.frame === endFrame) {
                        this.paused = true;
                    } else {
                        this.frame++;
                    }
                }
            }
        }
    },
    computed: {
        fpsInterval: function fpsInterval() {
            var fps = this.fps;

            return 1000 / fps;
        },
        startFrame: function startFrame() {
            var start = this.start;

            return start || 0;
        },
        endFrame: function endFrame() {
            var end = this.end,
                frames = this.frames;

            return end || frames.length - 1;
        },
        source: function source() {
            var backwards = this.backwards,
                frame = this.frame,
                startFrame = this.startFrame,
                endFrame = this.endFrame,
                frames = this.frames;

            var _frame = void 0;
            if (backwards) {
                _frame = typeof frame === 'number' ? frame : endFrame;
            } else {
                _frame = typeof frame === 'number' ? frame : startFrame;
            }
            return frames[_frame];
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47348b9b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/AnimatedSprite.vue
var AnimatedSprite_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.intro,"leave":_vm.outro}},[_c('div',{staticClass:"AnimatedSprite"},[(_vm.source)?_c('img',{staticClass:"AnimatedSprite-image",attrs:{"src":_vm.source}}):_vm._e()])])}
var AnimatedSprite_staticRenderFns = []
var AnimatedSprite_esExports = { render: AnimatedSprite_render, staticRenderFns: AnimatedSprite_staticRenderFns }
/* harmony default export */ var components_AnimatedSprite = (AnimatedSprite_esExports);
// CONCATENATED MODULE: ./src/app/components/AnimatedSprite.vue
function AnimatedSprite_injectStyle (ssrContext) {
  __webpack_require__("xvzA")
}
var AnimatedSprite_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AnimatedSprite___vue_template_functional__ = false
/* styles */
var AnimatedSprite___vue_styles__ = AnimatedSprite_injectStyle
/* scopeId */
var AnimatedSprite___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AnimatedSprite___vue_module_identifier__ = null
var AnimatedSprite_Component = AnimatedSprite_normalizeComponent(
  AnimatedSprite,
  components_AnimatedSprite,
  AnimatedSprite___vue_template_functional__,
  AnimatedSprite___vue_styles__,
  AnimatedSprite___vue_scopeId__,
  AnimatedSprite___vue_module_identifier__
)

/* harmony default export */ var app_components_AnimatedSprite = (AnimatedSprite_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/Carousel.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Carousel = ({
    name: 'Carousel',
    props: {
        imagesSrc: {
            type: Array,
            required: true
        },
        activeItem: {
            type: Number,
            default: 0
        },
        introDisabled: {
            type: Boolean,
            default: false
        },
        introDuration: {
            type: Number,
            default: 1
        },
        introDelay: {
            type: Number,
            default: 0
        },
        introEase: {
            type: Object,
            default: function _default() {
                return Quart.easeIn;
            }
        },
        outroDisabled: {
            type: Boolean,
            default: false
        },
        outroDuration: {
            type: Number,
            default: 1
        },
        outroDelay: {
            type: Number,
            default: 0
        },
        outroEase: {
            type: Object,
            default: function _default() {
                return Quart.easeOut;
            }
        },
        slideFadeDuration: {
            type: Number,
            default: 1
        },
        slideFadeDelay: {
            type: Number,
            default: 0
        },
        slideFadeEase: {
            type: Object,
            default: function _default() {
                return Quart.easeOut;
            }
        }
    },
    data: function data() {
        return {
            backIndex: null,
            frontIndex: null
        };
    },
    methods: {
        intro: function intro(el, done) {
            this.backIndex = this.activeItem;
            this.frontIndex = this.activeItem;
            if (this.introDisabled) {
                done();
            } else {
                TweenLite.fromTo(el, this.introDuration, {
                    alpha: 0
                }, {
                    alpha: 1,
                    delay: this.introDelay,
                    ease: this.introEase,
                    onComplete: done
                });
            }
        },
        outro: function outro(el, done) {
            if (this.outroDisabled) {
                done();
            } else {
                TweenLite.to(el, this.outroDuration, {
                    alpha: 0,
                    delay: this.outroDelay,
                    ease: this.outroEase,
                    onComplete: done,
                    overwrite: 'all'
                });
            }
        },
        changeSlide: function changeSlide() {
            var _this = this;

            var $refs = this.$refs;

            TweenLite.fromTo($refs.slideFront, this.slideFadeDuration, {
                alpha: 0
            }, {
                alpha: 1,
                ease: this.slideFadeEase,
                delay: this.slideFadeDelay,
                onComplete: function onComplete() {
                    _this.backIndex = _this.frontIndex;
                }
            });
        }
    },
    computed: {
        backSlideStyle: function backSlideStyle() {
            var backIndex = this.backIndex,
                imagesSrc = this.imagesSrc;

            return {
                'background-image': 'url(' + imagesSrc[backIndex] + ')'
            };
        },
        frontSlideStyle: function frontSlideStyle() {
            var frontIndex = this.frontIndex,
                imagesSrc = this.imagesSrc;

            return {
                'background-image': 'url(' + imagesSrc[frontIndex] + ')'
            };
        }
    },
    watch: {
        activeItem: function activeItem(val) {
            this.backIndex = this.frontIndex;
            this.frontIndex = val;
            this.$nextTick(this.changeSlide);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b77e32ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Carousel.vue
var Carousel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.intro,"leave":_vm.outro}},[_c('div',{staticClass:"Carousel"},[(_vm.backIndex !== null)?_c('div',{ref:"slideBack",staticClass:"Carousel-slide",style:(_vm.backSlideStyle)}):_vm._e(),_vm._v(" "),(_vm.frontIndex !== null)?_c('div',{ref:"slideFront",staticClass:"Carousel-slide",style:(_vm.frontSlideStyle)}):_vm._e()])])}
var Carousel_staticRenderFns = []
var Carousel_esExports = { render: Carousel_render, staticRenderFns: Carousel_staticRenderFns }
/* harmony default export */ var components_Carousel = (Carousel_esExports);
// CONCATENATED MODULE: ./src/app/components/Carousel.vue
function Carousel_injectStyle (ssrContext) {
  __webpack_require__("gLCN")
}
var Carousel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Carousel___vue_template_functional__ = false
/* styles */
var Carousel___vue_styles__ = Carousel_injectStyle
/* scopeId */
var Carousel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Carousel___vue_module_identifier__ = null
var Carousel_Component = Carousel_normalizeComponent(
  Carousel,
  components_Carousel,
  Carousel___vue_template_functional__,
  Carousel___vue_styles__,
  Carousel___vue_scopeId__,
  Carousel___vue_module_identifier__
)

/* harmony default export */ var app_components_Carousel = (Carousel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/NavCtrls.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var NavCtrls = ({
    name: 'NavCtrls',
    props: {
        disableBack: {
            type: Boolean,
            default: false
        },
        disableNext: {
            type: Boolean,
            default: false
        },
        light: {
            type: Boolean,
            default: false
        }
    },
    components: {
        ArrowBttn: app_components_ArrowBttn
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6516f394","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/NavCtrls.vue
var NavCtrls_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NavCtrls"},[_c('arrow-bttn',{staticClass:"NavCtrls-back",attrs:{"light":_vm.light,"disabled":_vm.disableBack,"up":""},on:{"click":function($event){_vm.$emit('back')}}}),_vm._v(" "),_c('arrow-bttn',{staticClass:"NavCtrls-next",attrs:{"light":_vm.light,"disabled":_vm.disableNext},on:{"click":function($event){_vm.$emit('next')}}})],1)}
var NavCtrls_staticRenderFns = []
var NavCtrls_esExports = { render: NavCtrls_render, staticRenderFns: NavCtrls_staticRenderFns }
/* harmony default export */ var components_NavCtrls = (NavCtrls_esExports);
// CONCATENATED MODULE: ./src/app/components/NavCtrls.vue
function NavCtrls_injectStyle (ssrContext) {
  __webpack_require__("lrTa")
}
var NavCtrls_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NavCtrls___vue_template_functional__ = false
/* styles */
var NavCtrls___vue_styles__ = NavCtrls_injectStyle
/* scopeId */
var NavCtrls___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavCtrls___vue_module_identifier__ = null
var NavCtrls_Component = NavCtrls_normalizeComponent(
  NavCtrls,
  components_NavCtrls,
  NavCtrls___vue_template_functional__,
  NavCtrls___vue_styles__,
  NavCtrls___vue_scopeId__,
  NavCtrls___vue_module_identifier__
)

/* harmony default export */ var app_components_NavCtrls = (NavCtrls_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/NavIndicators.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var NavIndicators = ({
    name: 'NavIndicators',
    props: {
        total: {
            type: Number,
            required: true
        },
        activeItem: {
            type: Number,
            required: true
        }
    },
    methods: {
        itemModifiers: function itemModifiers(index) {
            var activeItem = this.activeItem;

            return {
                'NavIndicators-item--active': activeItem === index - 1
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa345e9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/NavIndicators.vue
var NavIndicators_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NavIndicators"},_vm._l((_vm.total),function(index){return _c('div',{key:index,staticClass:"NavIndicators-item",class:_vm.itemModifiers(index)})}),0)}
var NavIndicators_staticRenderFns = []
var NavIndicators_esExports = { render: NavIndicators_render, staticRenderFns: NavIndicators_staticRenderFns }
/* harmony default export */ var components_NavIndicators = (NavIndicators_esExports);
// CONCATENATED MODULE: ./src/app/components/NavIndicators.vue
function NavIndicators_injectStyle (ssrContext) {
  __webpack_require__("nTYG")
}
var NavIndicators_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NavIndicators___vue_template_functional__ = false
/* styles */
var NavIndicators___vue_styles__ = NavIndicators_injectStyle
/* scopeId */
var NavIndicators___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavIndicators___vue_module_identifier__ = null
var NavIndicators_Component = NavIndicators_normalizeComponent(
  NavIndicators,
  components_NavIndicators,
  NavIndicators___vue_template_functional__,
  NavIndicators___vue_styles__,
  NavIndicators___vue_scopeId__,
  NavIndicators___vue_module_identifier__
)

/* harmony default export */ var app_components_NavIndicators = (NavIndicators_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/views/ChapterArt.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ var ChapterArt = ({
    name: 'ChapterArt',
    mixins: [ChapterUtils],
    components: {
        AnimatedSprite: app_components_AnimatedSprite,
        CloseLink: app_components_CloseLink,
        SocialShare: app_components_SocialShare,
        Carousel: app_components_Carousel,
        NavCtrls: app_components_NavCtrls,
        NavIndicators: app_components_NavIndicators,
        TextTransition: app_transitions_TextTransition
    },
    data: function data() {
        return {
            loader: null,
            loaded: false,
            visible: false,
            carouselVisible: false,
            activeItem: 0,
            playerRect: {
                width: 0,
                height: 0,
                top: 0,
                left: 0
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this.setLoader();
                            _context.next = 3;
                            return _this.load();

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },

    methods: {
        intro: function intro(el, done) {
            var _this2 = this;

            this.setBackgroundVisible(false);
            // Reset visible colaboration
            this.activeItem = 0;
            // Set player size as "contain"
            this.setPlayerRect();
            src_app.resize.add(this.setPlayerRect);
            // Delay notebook sequence start
            TweenLite.delayedCall(1, function () {
                _this2.visible = true;
            });
            // Anim this view intro
            TweenLite.fromTo(el, 2, {
                alpha: 0
            }, {
                alpha: 1,
                onComplete: done
            });
        },
        outro: function outro(el, done) {
            var _this3 = this;

            this.setBackgroundVisible(true);
            src_app.resize.remove(this.setPlayerRect);
            TweenLite.to(el, 1, {
                alpha: 0,
                onComplete: function onComplete() {
                    _this3.visible = false;
                    _this3.carouselVisible = false;
                    done();
                },
                ease: Cubic.easeOut
            });
        },
        setLoader: function setLoader() {
            var images = this.images;

            this.loader = new pixi_Loader({
                assets: images
            });
        },
        setPlayerRect: function setPlayerRect() {
            var $refs = this.$refs;

            var rect = getContainRect(1440, 1209, $refs.container.offsetWidth, $refs.container.offsetHeight);
            this.$set(this, 'playerRect', rect);
        },
        load: function load() {
            var _this4 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                var loader;
                return regenerator_default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                loader = _this4.loader;
                                _context2.next = 3;
                                return loader.load();

                            case 3:
                                _this4.loaded = true;

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this4);
            }))();
        },
        onPlayerComplete: function onPlayerComplete() {
            // Show collaborations
            this.carouselVisible = true;
        },
        back: function back() {
            this.activeItem -= 1;
        },
        next: function next() {
            this.activeItem += 1;
        }
    },
    computed: {
        images: function images() {
            var $store = this.$store;

            var directory = $store.getters.public + '/img/notebook-sequence/';
            return Object(lodash["fill"])(Array(24), '').map(function (str, i) {
                var index = ('' + (i + 1)).padStart(2, '0');
                return '' + directory + index + '.png';
            });
        },
        stageStyle: function stageStyle() {
            var playerRect = this.playerRect;

            return {
                width: playerRect.width + 'px',
                height: playerRect.height + 'px',
                top: playerRect.top + 'px',
                left: playerRect.left + 'px'
            };
        },
        closeTo: function closeTo() {
            return {
                name: CHAPTER
            };
        },
        title: function title() {
            var activeChapter = this.activeChapter,
                activeChapterIndex = this.activeChapterIndex;

            var index = ('' + (activeChapterIndex + 1)).padStart(2, '0');
            return index + ' - ' + activeChapter.name;
        },
        shareUrl: function shareUrl() {
            return location.href;
        },
        disableBack: function disableBack() {
            var activeItem = this.activeItem;

            return activeItem === 0;
        },
        disableNext: function disableNext() {
            var activeItem = this.activeItem,
                activeChapterArtwork = this.activeChapterArtwork;

            return activeItem === activeChapterArtwork.length - 1;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-189232ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/ChapterArt.vue
var ChapterArt_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"appear":_vm.intro,"enter":_vm.intro,"leave":_vm.outro}},[_c('section',{staticClass:"ChapterArt"},[_c('div',{ref:"container",staticClass:"ChapterArt-container"},[_c('div',{staticClass:"ChapterArt-stage",style:(_vm.stageStyle)},[_c('animated-sprite',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible && _vm.loaded),expression:"visible && loaded"}],attrs:{"frames":_vm.images,"start":0,"end":_vm.images.length - 1,"fps":15},on:{"complete":_vm.onPlayerComplete}}),_vm._v(" "),_c('carousel',{directives:[{name:"show",rawName:"v-show",value:(_vm.carouselVisible),expression:"carouselVisible"}],staticClass:"ChapterArt-carousel",attrs:{"images-src":_vm.activeChapterArtwork,"active-item":_vm.activeItem,"outro-disabled":true}})],1)]),_vm._v(" "),_c('nav-ctrls',{staticClass:"ChapterArt-ctrls",attrs:{"disable-back":_vm.disableBack,"disable-next":_vm.disableNext},on:{"back":_vm.back,"next":_vm.next}}),_vm._v(" "),_c('nav-indicators',{attrs:{"total":_vm.activeChapterArtwork.length,"active-item":_vm.activeItem}}),_vm._v(" "),_c('close-link',{attrs:{"to":_vm.closeTo}}),_vm._v(" "),_c('div',{staticClass:"ChapterArt-heading"},[_c('img',{staticClass:"ChapterArt-logo",attrs:{"src":__webpack_require__("dLd/"),"alt":"Moleskine"}}),_vm._v(" "),_c('h1',{staticClass:"ChapterArt-title"},[_vm._v("\n                "+_vm._s(_vm.title)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"ChapterArt-share"},[_c('social-share',{attrs:{"url":_vm.shareUrl}})],1)],1)])}
var ChapterArt_staticRenderFns = []
var ChapterArt_esExports = { render: ChapterArt_render, staticRenderFns: ChapterArt_staticRenderFns }
/* harmony default export */ var views_ChapterArt = (ChapterArt_esExports);
// CONCATENATED MODULE: ./src/app/views/ChapterArt.vue
function ChapterArt_injectStyle (ssrContext) {
  __webpack_require__("AMuy")
}
var ChapterArt_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChapterArt___vue_template_functional__ = false
/* styles */
var ChapterArt___vue_styles__ = ChapterArt_injectStyle
/* scopeId */
var ChapterArt___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ChapterArt___vue_module_identifier__ = null
var ChapterArt_Component = ChapterArt_normalizeComponent(
  ChapterArt,
  views_ChapterArt,
  ChapterArt___vue_template_functional__,
  ChapterArt___vue_styles__,
  ChapterArt___vue_scopeId__,
  ChapterArt___vue_module_identifier__
)

/* harmony default export */ var app_views_ChapterArt = (ChapterArt_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/BasicModal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var BasicModal = ({
    name: 'BasicModal',
    methods: {
        closeClickEmit: function closeClickEmit() {
            this.$emit("closeClick");
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6628159f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/BasicModal.vue
var BasicModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BasicModal"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"BasicModal-close",on:{"click":_vm.closeClickEmit}},[_c('div',{staticClass:"BasicModal-close-bar"}),_vm._v(" "),_c('div',{staticClass:"BasicModal-close-bar"})])],2)}
var BasicModal_staticRenderFns = []
var BasicModal_esExports = { render: BasicModal_render, staticRenderFns: BasicModal_staticRenderFns }
/* harmony default export */ var components_BasicModal = (BasicModal_esExports);
// CONCATENATED MODULE: ./src/app/components/BasicModal.vue
function BasicModal_injectStyle (ssrContext) {
  __webpack_require__("YfPi")
}
var BasicModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var BasicModal___vue_template_functional__ = false
/* styles */
var BasicModal___vue_styles__ = BasicModal_injectStyle
/* scopeId */
var BasicModal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var BasicModal___vue_module_identifier__ = null
var BasicModal_Component = BasicModal_normalizeComponent(
  BasicModal,
  components_BasicModal,
  BasicModal___vue_template_functional__,
  BasicModal___vue_styles__,
  BasicModal___vue_scopeId__,
  BasicModal___vue_module_identifier__
)

/* harmony default export */ var app_components_BasicModal = (BasicModal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/AuctionModal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AuctionModal = ({
    name: 'AuctionModal',
    components: {
        BasicModal: app_components_BasicModal
    },
    data: function data() {
        return {
            visible: false,
            playerWidth: 0,
            playerHeight: 0
        };
    },
    methods: {
        intro: function intro(el, done) {
            this.visible = true;
            this.updatePlayerSize();
            src_app.resize.add(this.updatePlayerSize);
            done();
        },
        outro: function outro(el, done) {
            this.visible = false;
            src_app.resize.remove(this.updatePlayerSize);
            done();
        },
        closeClickEmit: function closeClickEmit() {
            this.$emit("closeClick");
        },
        updatePlayerSize: function updatePlayerSize() {
            var $refs = this.$refs;

            this.playerWidth = $refs.display.offsetWidth;
            this.playerHeight = $refs.display.offsetHeight;
        }
    },
    computed: {
        data: function data() {
            var $store = this.$store;

            return $store.getters.data.auction;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbc70776","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/AuctionModal.vue
var AuctionModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.intro,"leave":_vm.outro}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"AuctionModal"},[_c('div',{staticClass:"AuctionModal-content"},[_c('div',{staticClass:"AuctionModal-content-group"},[_c('div',{staticClass:"AuctionModal-header"},[_c('div',{staticClass:"AuctionModal-logo"},[_c('img',{attrs:{"src":__webpack_require__("dLd/"),"alt":"Epic Moleskine"}})]),_vm._v(" "),_c('h1',{staticClass:"AuctionModal-title"},[_vm._v("\n                        "+_vm._s(_vm.data.title)+"\n                    ")])]),_vm._v(" "),_c('div',{ref:"display",staticClass:"AuctionModal-display"},[_c('youtube',{attrs:{"video-id":"nYa4g68UxlQ","width":_vm.playerWidth,"height":_vm.playerHeight}})],1)]),_vm._v(" "),_c('p',{staticClass:"AuctionModal-description"},[_vm._v("\n                "+_vm._s(_vm.data.description)+"\n            ")]),_vm._v(" "),_c('a',{ref:"nofollow noreferrer",staticClass:"AuctionModal-channel",attrs:{"href":"http://youtube.com","target":"_blank"}},[_c('span',{staticClass:"AuctionModal-channel-text"},[_vm._v("Visita nuestro canal de Youtube "),_c('svg',{staticClass:"AuctionModal-channel-icon"},[_c('use',{attrs:{"xlink:href":"#icon-youtube"}})])])])])])])}
var AuctionModal_staticRenderFns = []
var AuctionModal_esExports = { render: AuctionModal_render, staticRenderFns: AuctionModal_staticRenderFns }
/* harmony default export */ var components_AuctionModal = (AuctionModal_esExports);
// CONCATENATED MODULE: ./src/app/components/AuctionModal.vue
function AuctionModal_injectStyle (ssrContext) {
  __webpack_require__("8mfa")
}
var AuctionModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AuctionModal___vue_template_functional__ = false
/* styles */
var AuctionModal___vue_styles__ = AuctionModal_injectStyle
/* scopeId */
var AuctionModal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AuctionModal___vue_module_identifier__ = null
var AuctionModal_Component = AuctionModal_normalizeComponent(
  AuctionModal,
  components_AuctionModal,
  AuctionModal___vue_template_functional__,
  AuctionModal___vue_styles__,
  AuctionModal___vue_scopeId__,
  AuctionModal___vue_module_identifier__
)

/* harmony default export */ var app_components_AuctionModal = (AuctionModal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/views/Auction.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Auction = ({
    name: 'Auction',
    components: {
        AuctionModal: app_components_AuctionModal,
        CloseLink: app_components_CloseLink
    },
    data: function data() {
        return {
            visible: false
        };
    },
    computed: {
        closeTo: function closeTo() {
            return {
                name: CHAPTER
            };
        }
    },
    methods: {
        intro: function intro(el, done) {
            this.visible = true;
            TweenMax.fromTo(el, 2, {
                alpha: 0
            }, {
                alpha: 1,
                onComplete: done
            });
        },
        outro: function outro(el, done) {
            this.visible = false;
            TweenMax.to(el, 1, {
                alpha: 0,
                ease: Cubic.easeOut,
                onComplete: done
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d1819d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/Auction.vue
var Auction_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false,"appear":""},on:{"appear":_vm.intro,"enter":_vm.intro,"leave":_vm.outro}},[_c('div',{staticClass:"Auction"},[_c('auction-modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}]}),_vm._v(" "),_c('close-link',{attrs:{"to":_vm.closeTo}})],1)])}
var Auction_staticRenderFns = []
var Auction_esExports = { render: Auction_render, staticRenderFns: Auction_staticRenderFns }
/* harmony default export */ var views_Auction = (Auction_esExports);
// CONCATENATED MODULE: ./src/app/views/Auction.vue
function Auction_injectStyle (ssrContext) {
  __webpack_require__("bRbH")
}
var Auction_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Auction___vue_template_functional__ = false
/* styles */
var Auction___vue_styles__ = Auction_injectStyle
/* scopeId */
var Auction___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Auction___vue_module_identifier__ = null
var Auction_Component = Auction_normalizeComponent(
  Auction,
  views_Auction,
  Auction___vue_template_functional__,
  Auction___vue_styles__,
  Auction___vue_scopeId__,
  Auction___vue_module_identifier__
)

/* harmony default export */ var app_views_Auction = (Auction_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/views/NotFound.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var NotFound = ({
    name: 'NotFound'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75539890","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/NotFound.vue
var NotFound_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"NotFound"},[_c('p',{staticClass:"NotFound-copy"},[_vm._v("\n        404\n        "),_c('br'),_vm._v("\n        Página no encontrada\n        "),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("\n            Inicio\n        ")])],1)])}
var NotFound_staticRenderFns = []
var NotFound_esExports = { render: NotFound_render, staticRenderFns: NotFound_staticRenderFns }
/* harmony default export */ var views_NotFound = (NotFound_esExports);
// CONCATENATED MODULE: ./src/app/views/NotFound.vue
function NotFound_injectStyle (ssrContext) {
  __webpack_require__("8mw6")
}
var NotFound_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NotFound___vue_template_functional__ = false
/* styles */
var NotFound___vue_styles__ = NotFound_injectStyle
/* scopeId */
var NotFound___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NotFound___vue_module_identifier__ = null
var NotFound_Component = NotFound_normalizeComponent(
  NotFound,
  views_NotFound,
  NotFound___vue_template_functional__,
  NotFound___vue_styles__,
  NotFound___vue_scopeId__,
  NotFound___vue_module_identifier__
)

/* harmony default export */ var app_views_NotFound = (NotFound_Component.exports);

// CONCATENATED MODULE: ./src/app/routes.js










var HOME = 'home';
var CHAPTER = 'chapter';
var CHAPTER_VIDEO = 'chapter-video';
var CHAPTER_ART = 'chapter-art';
var AUCTION = 'auction';
var NOT_FOUND = '404';

var routes_commitActiveChapterId = function commitActiveChapterId(to, from, next) {
    var id = to.params.id;
    // [TODO]: validate if chapter exists and if it has video.

    store.commit(ACTIVE_CHAPTER_ID, id);
    next();
};

var routes = {
    mode: 'hash',
    base: config_environment.url.subdirectory,
    routes: [{
        path: '/',
        name: HOME,
        component: app_views_Home
    }, {
        path: '/capitulo',
        name: CHAPTER,
        component: app_views_Chapter
    }, {
        path: '/entrevista/:id',
        name: CHAPTER_VIDEO,
        component: app_views_ChapterVideo,
        beforeEnter: routes_commitActiveChapterId
    }, {
        path: '/libreta/:id',
        name: CHAPTER_ART,
        component: app_views_ChapterArt,
        beforeEnter: routes_commitActiveChapterId
    }, {
        path: '/subasta',
        name: AUCTION,
        component: app_views_Auction
    }, {
        path: '*',
        name: NOT_FOUND,
        component: app_views_NotFound
    }]
};

/* harmony default export */ var app_routes = (routes);
// CONCATENATED MODULE: ./src/app/utils/preloader.js
// To load from root static folder:
// import { environment } from '@/config'
// preloader.add(`${environment.url.public}/img/image-name.jpg`)



var preloader_preloader = new preloader_default.a({});
preloader_preloader.add(__webpack_require__("Cuwq"));

/* harmony default export */ var utils_preloader = (preloader_preloader);
// CONCATENATED MODULE: ./src/foo/net/api/TwitterApi.js




/**
 * Helper class for working with Twitter API
 *
 *      TODO: IMPLEMENT ALL
 * @class Twitter
 * @namespace net.api
 */



var TwitterApi_Twitter = function (_AbstractApi) {
  inherits_default()(Twitter, _AbstractApi);

  function Twitter() {
    classCallCheck_default()(this, Twitter);

    return possibleConstructorReturn_default()(this, (Twitter.__proto__ || get_prototype_of_default()(Twitter)).apply(this, arguments));
  }

  return Twitter;
}(AbstractApi);

TwitterApi_Twitter.sdkName = "Twitter";
/* harmony default export */ var TwitterApi = (TwitterApi_Twitter);
// CONCATENATED MODULE: ./src/foo/net/ApiLoader.js










var ApiLoader_ApiLoader = function () {
    function ApiLoader() {
        classCallCheck_default()(this, ApiLoader);
    }

    createClass_default()(ApiLoader, null, [{
        key: "load",


        /**
         * @static
         * @return {Promise}
         */
        value: function load() {
            var _this = this;

            var promises = [];

            var _loop = function _loop(sdk) {
                var sdkManager = _this.sdks[sdk];
                if (sdkManager) {
                    promises.push(sdkManager.setup().catch(function (error) {
                        return console.error("Failed to setup " + sdk + ":", error);
                    }));
                } else {
                    console.warn("SDKLoader: no sdk set for " + sdk + " adapter.");
                }
            };

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(config_config.sdks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var sdk = _step.value;

                    _loop(sdk);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            promise_default.a.all(promises).then(function () {
                return promise_default.a.resolve();
            });
        }

        /**
         * @static
         * @type {{facebook, google, xeerpa, twitter}}
         */

    }]);

    return ApiLoader;
}();

ApiLoader_ApiLoader.sdks = {
    "facebook": FacebookApi,
    "google": api_GoogleApi,
    "xeerpa": XeerpaApi,
    "twitter": TwitterApi
};
/* harmony default export */ var net_ApiLoader = (ApiLoader_ApiLoader);
// CONCATENATED MODULE: ./src/app/transitions/PreloaderTransition.js


/* harmony default export */ var PreloaderTransition = (vue_runtime_esm["a" /* default */].component("PreloaderTransition", {
    functional: true,
    render: function render(h, ctx) {
        var vm = ctx.parent;
        var data = {
            props: {
                name: "PreloaderTransition",
                css: false,
                appear: true
            },
            on: {
                enter: function enter(el, done) {
                    TweenMax.fromTo(vm.$el, 0.45, { alpha: 0 }, { alpha: 1, ease: Sine.easeOut, onComplete: done });
                },
                leave: function leave(el, done) {
                    TweenMax.to(vm.$el, 0.45, { alpha: 0, ease: Sine.easeOut, onComplete: done });
                },
                afterLeave: function afterLeave(el) {
                    vm.setDone();
                }
            }
        };
        return h("transition", data, ctx.children);
    }
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/base/Preloader.vue




//
//








/* harmony default export */ var Preloader = ({
    name: "Preloader",
    data: function data() {
        return {
            progress: 0,
            loading: true,
            iconVisible: false
        };
    },

    props: {
        minDisplayTime: {
            type: Number,
            default: 1500
        },
        transitionMode: {
            type: String,
            default: "simultaneous"
        },
        options: {
            type: Object,
            default: function _default() {
                return {
                    xhrImages: false,
                    loadFullAudio: false,
                    loadFullVideo: false
                };
            }
        }
    },
    components: {
        PreloaderTransition: PreloaderTransition,
        LineIcon: app_components_LineIcon
    },
    mounted: function mounted() {
        var _this = this;

        return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this.iconVisible = true;
                            _context.next = 3;
                            return promise_default.a.all([net_ApiLoader.load(), _this.setTimer(), _this.setLoader()]);

                        case 3:
                            _this.loadingComplete();

                        case 4:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },

    methods: extends_default()({
        setTimer: function setTimer() {
            var _this2 = this;

            return new promise_default.a(function (resolve) {
                setTimeout(function () {
                    resolve();
                }, _this2.minDisplayTime);
            });
        },
        setLoader: function setLoader() {
            var _this3 = this;

            return new promise_default.a(function (resolve) {
                _this3.loader = utils_preloader;
                _this3.loader.on("progress", _this3.onProgress);
                _this3.loader.on('complete', function () {
                    return _this3.onComplete(resolve);
                });
                _this3.load();
            });
        },
        add: function add(url) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            this.loader.add(url, options);
        },
        load: function load() {
            this.loader.load();
        },
        onProgress: function onProgress(val) {
            this.progress = val;
        },
        onComplete: function onComplete(done) {
            this.progress = 1;
            var data = utils_preloader.get(__webpack_require__("Cuwq"));
            this.$store.commit(DATA, data);
            done();
        },
        loadingComplete: function loadingComplete() {
            this.transitionMode === "out-in" ? this.transitionOut() : this.setDone();
        },
        transitionOut: function transitionOut() {
            var _this4 = this;

            this.iconVisible = false;
            // Give the icon sometime to do its outro
            TweenLite.delayedCall(0.3, function () {
                _this4.loading = false;
            });
        },
        setDone: function setDone() {
            this.loadingState(false);
        }
    }, Object(vuex_esm["c" /* mapActions */])({
        loadingState: ASSET_LOADING
    })),
    computed: {
        icon: function icon() {
            var $store = this.$store;

            return $store.getters.data.loaderIcon;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d5636c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/base/Preloader.vue
var Preloader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('preloader-transition',[(_vm.loading)?_c('div',{staticClass:"Preloader"},[_c('line-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.iconVisible),expression:"iconVisible"}],staticClass:"Preloader-icon",attrs:{"width":70,"height":30,"loop":true,"light":"","opaque":"","d":"M0.9,24c13.6,0,26.4-7.7,33.7-16c0.6-0.7,1.3-1.5,\n            1.5-2.4c0.1-0.4-0.3-0.8-0.7-0.7c-5.1,1.3-11.7,14.3-6.7,\n            14.6c5.7,0.3,19.5-6.2,24.2-12.7c0.6-0.9-0.1-2.1-1.2-1.8C46.4,\n            6.4,36.6,18,38.6,23.4c2.1,5.7,19.6-5.2,30.4-5.2"}})],1):_vm._e()])}
var Preloader_staticRenderFns = []
var Preloader_esExports = { render: Preloader_render, staticRenderFns: Preloader_staticRenderFns }
/* harmony default export */ var base_Preloader = (Preloader_esExports);
// CONCATENATED MODULE: ./src/app/components/base/Preloader.vue
function Preloader_injectStyle (ssrContext) {
  __webpack_require__("uSRS")
}
var Preloader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Preloader___vue_template_functional__ = false
/* styles */
var Preloader___vue_styles__ = Preloader_injectStyle
/* scopeId */
var Preloader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Preloader___vue_module_identifier__ = null
var Preloader_Component = Preloader_normalizeComponent(
  Preloader,
  base_Preloader,
  Preloader___vue_template_functional__,
  Preloader___vue_styles__,
  Preloader___vue_scopeId__,
  Preloader___vue_module_identifier__
)

/* harmony default export */ var components_base_Preloader = (Preloader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/MenuRibbon.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MenuRibbon = ({
    name: 'MenuRibbon',
    methods: extends_default()({
        backToHome: function backToHome() {
            this.setIsInHome(true);
            this.setMainNavVisible(false);
        },
        openNav: function openNav() {
            this.setIsInHome(false);
            this.setMainNavVisible(true);
        },
        tweenRibbon: function tweenRibbon() {
            var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            TweenLite.to(this.$refs.back, 0.5, {
                scaleY: isOpen ? 1 : 0,
                delay: isOpen ? 0.5 : 0,
                ease: Sine.easeOut
            });
        },
        tweenButton: function tweenButton() {
            var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            TweenMax.to(this.$refs.bttn, 0.2, {
                alpha: isOpen ? 1 : 0,
                delay: isOpen ? 1.0 : 0,
                ease: Sine.easeOut
            });
        },
        tweenCloseButton: function tweenCloseButton() {
            var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            TweenMax.to(this.$refs.closeBttn, 0.2, {
                y: isOpen ? 0 : -50,
                delay: isOpen ? 0.6 : 0,
                ease: Sine.easeOut
            });
        },
        tweenLink: function tweenLink() {
            var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            TweenMax.to(this.$refs.link, 0.2, {
                y: isOpen ? 10 : -10,
                alpha: isOpen ? 1 : 0,
                delay: isOpen ? 1.0 : 0,
                ease: Sine.easeOut
            });
        },
        intro: function intro(el, done) {
            TweenLite.set(el, { alpha: 1 });
            this.tweenRibbon();
            this.tweenButton();
            this.tweenLink();
            done();
        },
        outro: function outro(el, done) {
            TweenLite.to(el, 1, {
                alpha: 0,
                onComplete: done,
                ease: Cubic.easeOut
            });
        }
    }, Object(vuex_esm["e" /* mapMutations */])({
        setMainNavVisible: MAIN_NAV_VISIBLE,
        setIsInHome: IS_IN_HOME
    }), {
        hideUi: function hideUi(value) {
            this.tweenLink(value);
            this.tweenRibbon(value);
            this.tweenButton(value);
            this.tweenCloseButton(!value);
        }
    }),
    computed: extends_default()({}, Object(vuex_esm["d" /* mapGetters */])(["mainNavVisible", "ribbonVisible", "isInHome"])),
    watch: {
        isInHome: function isInHome(value) {
            this.hideUi(value);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38b428ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/MenuRibbon.vue
var MenuRibbon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.intro,"leave":_vm.outro}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ribbonVisible),expression:"ribbonVisible"}],staticClass:"MenuRibbon"},[_c('div',{ref:"closeBttn",staticClass:"MenuRibbon-bttn--close",on:{"click":_vm.backToHome}},[_c('span',{staticClass:"MenuBttn-line top"}),_vm._v(" "),_c('span',{staticClass:"MenuBttn-line bottom"})]),_vm._v(" "),_c('div',{ref:"back",staticClass:"MenuRibbon-back"}),_vm._v(" "),_c('div',{ref:"bttn",staticClass:"MenuRibbon-bttn",class:{open: !_vm.isInHome},on:{"click":_vm.openNav}},_vm._l((3),function(i){return _c('span',{key:i,staticClass:"MenuRibbon-bar"})}),0),_vm._v(" "),_c('a',{ref:"link",staticClass:"MenuRibbon-link",attrs:{"href":"http://epicmoleskine.com/2018"}},[_c('small',[_vm._v("Ver la primera edición")])])])])}
var MenuRibbon_staticRenderFns = []
var MenuRibbon_esExports = { render: MenuRibbon_render, staticRenderFns: MenuRibbon_staticRenderFns }
/* harmony default export */ var components_MenuRibbon = (MenuRibbon_esExports);
// CONCATENATED MODULE: ./src/app/components/MenuRibbon.vue
function MenuRibbon_injectStyle (ssrContext) {
  __webpack_require__("Ea38")
}
var MenuRibbon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MenuRibbon___vue_template_functional__ = false
/* styles */
var MenuRibbon___vue_styles__ = MenuRibbon_injectStyle
/* scopeId */
var MenuRibbon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MenuRibbon___vue_module_identifier__ = null
var MenuRibbon_Component = MenuRibbon_normalizeComponent(
  MenuRibbon,
  components_MenuRibbon,
  MenuRibbon___vue_template_functional__,
  MenuRibbon___vue_styles__,
  MenuRibbon___vue_scopeId__,
  MenuRibbon___vue_module_identifier__
)

/* harmony default export */ var app_components_MenuRibbon = (MenuRibbon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/layout/LayoutMain.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var LayoutMain = ({
    name: 'LayoutMain',
    computed: {
        viewId: function viewId() {
            return this.$route.path;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e45982d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/layout/LayoutMain.vue
var LayoutMain_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"LayoutMain"},[_c('keep-alive',[_c('router-view',{key:_vm.viewId})],1)],1)}
var LayoutMain_staticRenderFns = []
var LayoutMain_esExports = { render: LayoutMain_render, staticRenderFns: LayoutMain_staticRenderFns }
/* harmony default export */ var layout_LayoutMain = (LayoutMain_esExports);
// CONCATENATED MODULE: ./src/app/components/layout/LayoutMain.vue
function LayoutMain_injectStyle (ssrContext) {
  __webpack_require__("1Ktb")
}
var LayoutMain_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LayoutMain___vue_template_functional__ = false
/* styles */
var LayoutMain___vue_styles__ = LayoutMain_injectStyle
/* scopeId */
var LayoutMain___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LayoutMain___vue_module_identifier__ = null
var LayoutMain_Component = LayoutMain_normalizeComponent(
  LayoutMain,
  layout_LayoutMain,
  LayoutMain___vue_template_functional__,
  LayoutMain___vue_styles__,
  LayoutMain___vue_scopeId__,
  LayoutMain___vue_module_identifier__
)

/* harmony default export */ var components_layout_LayoutMain = (LayoutMain_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/get.js
var helpers_get = __webpack_require__("yEsh");
var get_default = /*#__PURE__*/__webpack_require__.n(helpers_get);

// CONCATENATED MODULE: ./src/app/pixi/views/AbstractView.js









var AbstractView_AbstractView = function (_Container) {
    inherits_default()(AbstractView, _Container);

    /**
     *
     * @param name {String}
     */
    function AbstractView(_ref) {
        var _ref$name = _ref.name,
            name = _ref$name === undefined ? "Default" : _ref$name;

        classCallCheck_default()(this, AbstractView);

        var _this = possibleConstructorReturn_default()(this, (AbstractView.__proto__ || get_prototype_of_default()(AbstractView)).call(this));

        _this.name = name;
        _this.build();
        _this.initListeners();
        return _this;
    }

    createClass_default()(AbstractView, [{
        key: "build",
        value: function build() {
            // Build your Container stuff
        }
    }, {
        key: "initListeners",
        value: function initListeners() {
            // Attach listeners like resize below
            src_app.resize.add(this.resized, this);
        }
    }, {
        key: "resized",
        value: function resized(size) {}
    }, {
        key: "show",
        value: function show() {
            TweenMax.to(this, 0.8, { alpha: 1, ease: Expo.easeOut });
        }
    }, {
        key: "hide",
        value: function hide() {
            TweenMax.to(this, 0.8, { alpha: 0, ease: Expo.easeOut });
        }
    }, {
        key: "destroy",
        value: function destroy() {
            get_default()(AbstractView.prototype.__proto__ || get_prototype_of_default()(AbstractView.prototype), "destroy", this).call(this);
            src_app.resize.remove(this.resized, this);
        }
    }]);

    return AbstractView;
}(pixi_js_lib["Container"]);

/* harmony default export */ var views_AbstractView = (AbstractView_AbstractView);
// CONCATENATED MODULE: ./src/assets/data/chapters.js
/* harmony default export */ var data_chapters = ([{
    id: "alberto-montt",
    videoCover: __webpack_require__("VhkR"),
    hasVideo: true,
    videoSrc: "interviews/ALBERTO_MONTT.mp4"
}, {
    id: "francisco-toledo",
    hasVideo: false,
    videoCover: __webpack_require__("mXYG")
}, {
    id: "jose-santiago",
    videoCover: __webpack_require__("CCLV"),
    hasVideo: true,
    videoSrc: "interviews/JOSE_SANTIAGO.mp4"
}, {
    id: "power-paola",
    videoCover: __webpack_require__("4/gc"),
    hasVideo: true,
    videoSrc: "interviews/POWERPAOLA.mp4"
}, {
    id: "paulina-jaimes",
    videoCover: __webpack_require__("QUV6"),
    hasVideo: true,
    videoSrc: "interviews/PAULINA_JAIMES.mp4"
}, {
    id: "javier-sierra",
    videoCover: __webpack_require__("XzHR"),
    hasVideo: true,
    videoSrc: "interviews/JAVIER_SIERRA.mp4"
}, {
    id: "kraken",
    videoCover: __webpack_require__("EsQN"),
    hasVideo: true,
    videoSrc: "interviews/KRAKEN.mp4"
}, {
    id: "maria-duenas",
    videoCover: __webpack_require__("mKng"),
    hasVideo: true,
    videoSrc: "interviews/MARIA_DUENAS.mp4"
}, {
    id: "luis-urrea",
    videoCover: __webpack_require__("Vbty"),
    hasVideo: true,
    videoSrc: "interviews/LUIS_URREA.mp4"
}, {
    id: "marcos-castro",
    videoCover: __webpack_require__("AG5z"),
    hasVideo: true,
    videoSrc: "interviews/MARCOS_CASTRO.mp4"
}, {
    id: "manuel-monroy",
    videoCover: __webpack_require__("8sw3"),
    hasVideo: true,
    videoSrc: "interviews/MANUEL_MONROY.mp4"
}, {
    id: "mike-sandoval",
    videoCover: __webpack_require__("KZWA"),
    hasVideo: true,
    videoSrc: "interviews/MIKE_SANDOVAL.mp4"
}, {
    id: "ciler",
    videoCover: __webpack_require__("SJ7A"),
    hasVideo: true,
    videoSrc: "interviews/CILER.mp4"
}, {
    id: "trine-ellitsgaard",
    videoCover: __webpack_require__("DSe6"),
    hasVideo: false
}, {
    id: "cesar-cordova",
    videoCover: __webpack_require__("TGEO"),
    hasVideo: true,
    videoSrc: "interviews/CESAR_CORDOVA.mp4"
}, {
    id: "taquito",
    videoCover: __webpack_require__("gSHU"),
    hasVideo: true,
    videoSrc: "interviews/TAQUITO.mp4"
}, {
    id: "elena-poniatowska",
    videoCover: __webpack_require__("t4ke"),
    hasVideo: true,
    videoSrc: "interviews/ELENA_PONIATOWSKA.mp4"
}, {
    id: "gabriel-meave",
    videoCover: __webpack_require__("+7at"),
    hasVideo: true,
    videoSrc: "interviews/GABRIEL_MARTINEZ.mp4"
}, {
    id: "malafacha",
    videoCover: __webpack_require__("VHsx"),
    hasVideo: true,
    videoSrc: "interviews/MALAFACHA.mp4"
}, {
    id: "horacio-quiroz",
    videoCover: __webpack_require__("XCQw"),
    hasVideo: true,
    videoSrc: "interviews/HORACIO_QUIROZ.mp4"
}, {
    id: "sabino-guisu",
    videoCover: __webpack_require__("mabu"),
    hasVideo: true,
    videoSrc: "interviews/SABINO_GUISU.mp4"
}, {
    id: "jorge-tellaeche",
    videoCover: __webpack_require__("iaWA"),
    hasVideo: true,
    videoSrc: "interviews/TALLAECHE.mp4"
}, {
    id: "dr-lakra",
    videoCover: __webpack_require__("9I0h"),
    hasVideo: false
}, {
    id: "oliver-jeffers",
    videoCover: __webpack_require__("X1wz"),
    hasVideo: false
}, {
    id: "emmanuel-garcia",
    videoCover: __webpack_require__("3npI"),
    hasVideo: true,
    videoSrc: "interviews/EMMANUEL_GARCIA.mp4"
}, {
    id: "mariana-magdaleno",
    videoCover: __webpack_require__("6gDJ"),
    hasVideo: true,
    videoSrc: "interviews/MARIANA_MAGDALENO.mp4"
}, {
    id: "matias-prado",
    videoCover: __webpack_require__("aa5y"),
    hasVideo: true,
    videoSrc: "interviews/MATIAS_PRADO.mp4"
}]);
// CONCATENATED MODULE: ./src/app/pixi/views/BackgroundView.js












var BackgroundView_BackgroundView = function (_AbstractView) {
    inherits_default()(BackgroundView, _AbstractView);

    function BackgroundView() {
        classCallCheck_default()(this, BackgroundView);

        var _this = possibleConstructorReturn_default()(this, (BackgroundView.__proto__ || get_prototype_of_default()(BackgroundView)).call(this, {
            name: "Background"
        }));

        _this._originalWidth = 0;
        _this._originalHeight = 0;
        return _this;
    }

    createClass_default()(BackgroundView, [{
        key: "build",
        value: function () {
            var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                return regenerator_default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this._currentArtistId = 0;
                                this._buildMask();
                                _context.next = 4;
                                return this._buildImage();

                            case 4:
                                this.resized({
                                    width: window.innerWidth,
                                    height: window.innerHeight
                                });

                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function build() {
                return _ref.apply(this, arguments);
            }

            return build;
        }()
    }, {
        key: "_buildMask",
        value: function _buildMask() {
            this.maskContainer = new pixi_js_lib["Container"]();
            this.maskContainer.name = "MaskContainer";
            this.maskGraph = new pixi_js_lib["Graphics"]();
            this.maskContainer.addChild(this.maskGraph);
            this.addChild(this.maskContainer);
        }
    }, {
        key: "_buildImage",
        value: function () {
            var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                var loader, resource;
                return regenerator_default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                loader = pixi_PixiApp.loader;
                                _context2.next = 3;
                                return loader.load();

                            case 3:
                                resource = loader.resources[this._currentResource];

                                this.image = new pixi_js_lib["Sprite"](resource.texture);
                                this.image.mask = this.maskGraph;
                                this.image.anchor.set(0.5, 0.5);
                                this.addChild(this.image);

                            case 8:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function _buildImage() {
                return _ref2.apply(this, arguments);
            }

            return _buildImage;
        }()
    }, {
        key: "resized",
        value: function resized(_ref3) {
            var width = _ref3.width,
                height = _ref3.height;

            this._resizeMask(width, height);
            this._resizeImage(width, height);
        }
    }, {
        key: "_resizeMask",
        value: function _resizeMask(w, h) {
            this.maskContainer.position.set(w / 2, h / 2);
            this.maskContainer.pivot.set(0.5, 0.5);
            this.maskGraph.clear();
            this.maskGraph.drawRect(-(w / 2), -(h / 2), w, h);
        }
    }, {
        key: "_resizeImage",
        value: function _resizeImage(w, h) {
            if (h > w) return;

            this.image.position.set(w / 2, h / 2);
            var containerWidth = w;
            var containerHeight = h;
            var image = this.image;


            var imageRatio = this.image.width / this.image.height;
            var containerRatio = containerWidth / containerHeight;

            if (containerRatio > imageRatio) {
                image.height = image.height / (image.width / containerWidth);
                image.width = containerWidth;
            } else {
                image.width = image.width / (image.height / containerHeight);
                image.height = containerHeight;
            }

            this._originalWidth = image.width;
            this._originalHeight = image.height;
        }
    }, {
        key: "setCurrentResource",
        value: function setCurrentResource(id) {
            this._currentArtistId = id;
            var loader = pixi_PixiApp.loader;

            var resource = loader.resources[this._currentResource];

            this.image.texture = resource.texture;
        }
    }, {
        key: "openMask",
        value: function openMask() {
            var _this2 = this;

            TweenMax.to(this.maskGraph.scale, 0.2, {
                x: 0.45,
                y: 0.45,
                ease: Sine.easeOut,
                onComplete: function onComplete() {
                    var time = 0.5;
                    TweenMax.to(_this2, time, { alpha: 1.0, ease: Expo.easeOut });
                    TweenMax.to(_this2.maskGraph.scale, time, { x: 1.0, y: 1.0, ease: Expo.easeOut });

                    var _originalWidth = _this2._originalWidth,
                        _originalHeight = _this2._originalHeight;

                    TweenMax.to(_this2.image, time - 0.2, {
                        width: _originalWidth,
                        height: _originalHeight,
                        ease: Expo.easeOut
                    });
                }
            });
        }
    }, {
        key: "closeMask",
        value: function closeMask() {
            var delay = 1;
            var time = 0.5;
            var maskScale = 0.6;

            // Container
            TweenMax.to(this, time, { delay: delay, alpha: 0.5, ease: Power3.easeOut });

            // Mask
            TweenMax.to(this.maskGraph.scale, time, {
                delay: delay,
                x: maskScale,
                y: maskScale,
                ease: Expo.easeOut
            });

            // Image
            var imageScale = 0.8;
            var _image = this.image,
                width = _image.width,
                height = _image.height;

            var scaledWidth = width * imageScale;
            var scaledHeight = height * imageScale;
            TweenMax.to(this.image, time, { delay: delay, width: scaledWidth, height: scaledHeight, ease: Expo.easeOut });
        }
    }, {
        key: "onHold",
        value: function onHold() {
            var time = 0.4;

            // Mask
            TweenMax.to(this.maskGraph.scale, time, { x: 0.6, y: 0, delay: 0.1, ease: Cubic.easeInOut });

            // Image
            var _originalWidth = this._originalWidth,
                _originalHeight = this._originalHeight;

            TweenMax.to(this.image, time, {
                width: _originalWidth * 1.2,
                height: _originalHeight * 1.2,
                ease: Cubic.easeInOut
            });
        }
    }, {
        key: "onRelease",
        value: function onRelease() {
            var time = 0.6;

            // Mask
            TweenMax.to(this.maskGraph.scale, time, { x: 0.6, y: 0.6, ease: Cubic.easeInOut });

            // Image
            var _originalWidth = this._originalWidth,
                _originalHeight = this._originalHeight;

            TweenMax.to(this.image, time, {
                width: _originalWidth * 0.8,
                height: _originalHeight * 0.8,
                ease: Cubic.easeInOut
            });
        }
    }, {
        key: "_currentResource",
        get: function get() {
            return data_chapters[this._currentArtistId].videoCover;
        }
    }]);

    return BackgroundView;
}(views_AbstractView);

/* harmony default export */ var views_BackgroundView = (BackgroundView_BackgroundView);
// EXTERNAL MODULE: ./node_modules/gsap/PixiPlugin.js
var PixiPlugin = __webpack_require__("W06x");
var PixiPlugin_default = /*#__PURE__*/__webpack_require__.n(PixiPlugin);

// CONCATENATED MODULE: ./src/app/pixi/PixiApp.js












var PixiApp_PixiApp = function () {
    function PixiApp() {
        classCallCheck_default()(this, PixiApp);

        /**
         *
         * @type {Application}
         */
        this.pixiApp = null;

        /**
         *
         * @type {Container}
         */
        this.mainContainer = null;
        this.addAssetsToLoader();
    }

    /**
     *
     * @type {Loader}
     */


    createClass_default()(PixiApp, [{
        key: "setup",
        value: function () {
            var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                var pixiApp;
                return regenerator_default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                pixiApp = new pixi_js_lib["Application"]({
                                    autoResize: true,
                                    width: window.innerWidth,
                                    height: window.innerHeight,
                                    resolution: 1,
                                    transparent: true,
                                    antialias: true,
                                    roundPixels: true
                                });


                                this.pixiApp = pixiApp;
                                this.mainContainer = new pixi_js_lib["Container"]();
                                this.mainContainer.name = "mainContainer";

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function setup() {
                return _ref.apply(this, arguments);
            }

            return setup;
        }()
    }, {
        key: "addAssetsToLoader",
        value: function addAssetsToLoader() {
            data_chapters.forEach(function (chapter) {
                PixiApp.loader.addImage(chapter.videoCover);
            });
        }
    }, {
        key: "init",
        value: function init($el) {
            this.backgroundView = new views_BackgroundView();
            this.mainContainer.addChild(this.backgroundView);
            this.pixiApp.stage.addChild(this.mainContainer);
            $el.appendChild(this.pixiApp.view);
            this.initListeners();
        }
    }, {
        key: "initListeners",
        value: function initListeners() {
            src_app.resize.add(this.resized, this);
        }
    }, {
        key: "resized",
        value: function resized(_ref2) {
            var width = _ref2.width,
                height = _ref2.height;
            var renderer = this.pixiApp.renderer;

            renderer.view.style.width = width + "px";
            renderer.view.style.height = height + "px";
            renderer.autoResize = true;
            renderer.resize(width, height);
        }
    }, {
        key: "destroy",
        value: function destroy() {
            src_app.resize.remove(this.resized, this);
            this.pixiApp.destroy(true, { children: true });
        }
    }]);

    return PixiApp;
}();

PixiApp_PixiApp.loader = new pixi_Loader();
/* harmony default export */ var pixi_PixiApp = (PixiApp_PixiApp);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/MainNavList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MainNavList = ({
    name: 'MainNavList',
    components: {
        LineIcon: app_components_LineIcon
    },
    props: {
        itemHeight: {
            type: Number,
            required: true
        },
        chapters: {
            type: Array,
            required: true
        },
        isDragging: {
            type: Boolean,
            required: true
        }
    },
    data: function data() {
        return {
            active: 0,
            showButton: false,
            bttnIconVisible: false
        };
    },
    methods: {
        toggle: function toggle() {
            this.setMainNavVisible(!this.mainNavVisible);
        },
        intro: function intro(el, done) {
            TweenLite.fromTo(el, 0.3, {
                alpha: 0,
                scale: 1.2
            }, {
                alpha: 1,
                scale: 1,
                delay: 1,
                overwrite: "all",
                ease: Sine.easeOut,
                onComplete: done
            });
        },
        outro: function outro(el, done) {
            TweenLite.to(el, 0.3, {
                alpha: 0,
                overwrite: "all",
                onComplete: done,
                ease: Sine.easeOut
            });
        },
        itemModifiers: function itemModifiers(index) {
            return {
                'MainNavList-item--active': this.isActive(index)
            };
        },
        isActive: function isActive(index) {
            return this.activeIndex === index;
        }
    },
    computed: extends_default()({}, Object(vuex_esm["d" /* mapGetters */])(["mainNavVisible", "activeIndex"]), {
        style: function style() {
            return {
                height: this.itemHeight + 'px'
            };
        },
        eyeIcon: function eyeIcon() {
            var $store = this.$store;

            return $store.getters.data.lineIcons.eye;
        },
        bttnIconStyle: function bttnIconStyle() {
            var eyeIcon = this.eyeIcon;

            return {
                width: eyeIcon.width + 'px',
                height: eyeIcon.height + 'px'
            };
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-021772e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/MainNavList.vue
var MainNavList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.intro,"leave":_vm.outro}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mainNavVisible),expression:"mainNavVisible"}],staticClass:"MainNavList-wrapper"},[_c('div',{staticClass:"MainNavList-overlay",style:(_vm.style)},[_c('ul',{ref:"MainNavListFill",staticClass:"MainNavList"},_vm._l((_vm.chapters),function(chapter,i){return _c('li',{key:("MainNavListFill-" + (chapter.id)),ref:"item",refInFor:true,staticClass:"MainNavList-item",class:_vm.itemModifiers(i),style:(_vm.style)},[_c('div',[_c('div',{staticClass:"MainNavList-title-container"},[_c('h2',{staticClass:"MainNavList-title"},[_vm._v(_vm._s(chapter.name))])])])])}),0)]),_vm._v(" "),_c('ul',{ref:"MainNavListOutlines",staticClass:"MainNavList"},_vm._l((_vm.chapters),function(chapter,i){return _c('li',{key:("MainNavListOutlines-" + (chapter.id)),ref:"item",refInFor:true,staticClass:"MainNavList-item",class:_vm.itemModifiers(i),style:(_vm.style)},[_c('div',[_c('div',{staticClass:"MainNavList-title-container"},[_c('h2',{staticClass:"MainNavList-title",on:{"click":function($event){_vm.$emit('bttn-click', chapter.id)}}},[_vm._v("\n                            "+_vm._s(chapter.name)+"\n                        ")])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive(i) && !_vm.isDragging),expression:"isActive(i) && !isDragging"}],staticClass:"MainNavList-bttn",on:{"click":function($event){_vm.$emit('bttn-click', chapter.id)}}},[_c('small',[_vm._v("Ver capítulo")]),_vm._v(" "),_c('div',{staticClass:"MainNavList-bttnIcon",style:(_vm.bttnIconStyle)},[_c('line-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive(i) && !_vm.isDragging),expression:"isActive(i) && !isDragging"}],attrs:{"width":_vm.eyeIcon.width,"height":_vm.eyeIcon.height,"d":_vm.eyeIcon.d}})],1)])])],1)])}),0)])])}
var MainNavList_staticRenderFns = []
var MainNavList_esExports = { render: MainNavList_render, staticRenderFns: MainNavList_staticRenderFns }
/* harmony default export */ var components_MainNavList = (MainNavList_esExports);
// CONCATENATED MODULE: ./src/app/components/MainNavList.vue
function MainNavList_injectStyle (ssrContext) {
  __webpack_require__("gtvh")
}
var MainNavList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MainNavList___vue_template_functional__ = false
/* styles */
var MainNavList___vue_styles__ = MainNavList_injectStyle
/* scopeId */
var MainNavList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MainNavList___vue_module_identifier__ = null
var MainNavList_Component = MainNavList_normalizeComponent(
  MainNavList,
  components_MainNavList,
  MainNavList___vue_template_functional__,
  MainNavList___vue_styles__,
  MainNavList___vue_scopeId__,
  MainNavList___vue_module_identifier__
)

/* harmony default export */ var app_components_MainNavList = (MainNavList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/MainNav.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var STRONG_FRICTION = 0.01;
var WEAK_FRICTION = 5.0;

/* harmony default export */ var MainNav = ({
    name: 'MainNav',

    mixins: [ChapterUtils],

    components: {
        MainNavList: app_components_MainNavList,
        CloseLink: app_components_CloseLink
    },

    data: function data() {
        return {
            delta: 0,
            startMouseY: 0,
            itemHeight: 0,
            isOnTop: false,
            isHovered: false,
            isOnBottom: false
        };
    },

    mounted: function mounted() {
        var _this = this;

        this.position = 0;
        this.friction = WEAK_FRICTION;
        this.$nextTick(function () {
            _this.measureLayout();
        });
    },

    methods: extends_default()({
        intro: function intro(el, done) {
            this.toggleIndex(done);
            this.setInitialPosition(done);
            src_app.render.add(this.animate);
            src_app.resize.add(this.measureLayout);
        },
        outro: function outro(el, done) {
            this.toggleIndex(done);
            src_app.render.remove(this.animate);
            src_app.resize.remove(this.measureLayout);
        },
        setInitialPosition: function setInitialPosition() {
            this.position = -(this.itemHeight * this.activeIndex);
        },
        measureLayout: function measureLayout() {
            this.setItemHeight();
            this.topBound = 10;
            this.bottomBound = ~~(-(this.chapters.length - 1) * this.itemHeight);
        },
        onMouseEnter: function onMouseEnter() {
            this.isHovered = true;
        },
        onMouseLeave: function onMouseLeave() {
            this.isHovered = false;
            this.setDragging(false);
        },
        onMouseDown: function onMouseDown(e) {
            // Set hovered if mobile
            this.startDragTimer(e.touches && e.touches[0]);
            if (e.touches && e.touches[0]) {
                this.startMouseY = ~~e.touches[0].clientY;
            } else {
                this.startMouseY = ~~e.clientY;
            }
        },
        onMouseMove: function onMouseMove(e) {
            e.preventDefault();
            // Stop if its not dragging or in window
            if (!this.isDragging || !this.isHovered) {
                this.delta = 0;
                return;
            }
            // Handle drag
            if (e.touches && e.touches[0]) {
                this.delta = ~~e.touches[0].clientY - this.startMouseY;
                this.startMouseY = ~~e.touches[0].clientY;
            } else {
                this.delta = ~~e.clientY - this.startMouseY;
                this.startMouseY = ~~e.clientY;
            }
        },
        onMouseUp: function onMouseUp(e) {
            var _this2 = this;

            this.clearDragTimer(e.touches && e.touches[0]);
            setTimeout(function () {
                _this2.centerActiveItem();
            }, 500);
        },
        startDragTimer: function startDragTimer(isHovered) {
            var _this3 = this;

            this.timer = setTimeout(function () {
                _this3.setDragging(true);
                _this3.isHovered = isHovered;
            }, 300);
        },
        clearDragTimer: function clearDragTimer(isHovered) {
            clearTimeout(this.timer);
            this.timer = null;
            this.isHovered = isHovered;
            this.delta = 0;
            this.setDragging(false);
        },
        animate: function animate() {
            this.update();
            this.render();
        },
        update: function update() {
            this.updateBounds();
            this.updateFriction();
        },
        updateBounds: function updateBounds() {
            var position = this.position,
                topBound = this.topBound,
                bottomBound = this.bottomBound;

            this.passedTop = position > topBound;
            this.passedBottom = position < bottomBound;
        },
        updateActiveIndex: function updateActiveIndex() {
            var _newActiveIndex = Math.abs(~~((this.position - this.itemHeight / 2) / this.itemHeight));
            if (_newActiveIndex !== this.activeIndex) {
                var _newChapter = this.getChapterById(_newActiveIndex);
                this.updateActiveChapterId(_newChapter.id, _newChapter.number);
            }
        },
        centerActiveItem: function centerActiveItem() {
            var distance = window.innerHeight / 2 - this.itemHeight / 2;
            var _activeItemY = ~~(this.itemHeight * (this.activeIndex + 2) + this.position);
            var toValue = ~~(_activeItemY - distance);
            this.position -= toValue;
        },
        render: function render() {
            var _$refs$mainNavList$$r = this.$refs.mainNavList.$refs,
                MainNavListOutlines = _$refs$mainNavList$$r.MainNavListOutlines,
                MainNavListFill = _$refs$mainNavList$$r.MainNavListFill;

            gsap_TweenMax["TweenMax"].set([MainNavListOutlines, MainNavListFill], {
                y: this.position += ~~(this.delta * this.friction),
                force3D: true
            });
        },
        updateFriction: function updateFriction() {
            var passedTop = this.passedTop,
                passedBottom = this.passedBottom;
            // console.log(this.delta === 0 ? "still" : this.delta > 0 ? "down" : "up", passedTop, passedBottom)

            if (this.delta === 0) {
                return;
            }
            if (this.delta > 0) {
                // Going Down
                if (passedTop) {
                    this.friction = STRONG_FRICTION;
                } else {
                    this.friction = WEAK_FRICTION;
                    this.updateActiveIndex();
                }
            } else {
                // Going Up
                if (passedBottom) {
                    this.friction = STRONG_FRICTION;
                } else {
                    this.friction = WEAK_FRICTION;
                    this.updateActiveIndex();
                }
            }
        },
        toggle: function toggle() {
            this.setMainNavVisible(!this.mainNavVisible);
            this.setIsInHome(!this.isInHome);
        },
        toggleIndex: function toggleIndex(done) {
            var isInHome = this.isInHome;

            gsap_TweenMax["TweenMax"].to(this.$refs.indexIndicator, 0.3, {
                x: isInHome ? "-100%" : "-10%",
                delay: isInHome ? 0 : 0.8,
                ease: isInHome ? Back.easeIn : Sine.easeOut,
                onComplete: done
            });
        },
        setItemHeight: function setItemHeight() {
            this.itemHeight = ~~window.innerHeight * 0.20;
        }
    }, Object(vuex_esm["e" /* mapMutations */])({
        setIsInHome: IS_IN_HOME,
        setDragging: IS_DRAGGING,
        setActiveIndex: BG_ACTIVE_INDEX,
        setMainNavVisible: MAIN_NAV_VISIBLE
    })),
    computed: extends_default()({}, Object(vuex_esm["d" /* mapGetters */])(["mainNavVisible", "isInHome", "activeIndex", "isDragging"]), {
        mainNavList: function mainNavList() {
            return this.$refs.mainNavList.$refs.MainNavListOutlines;
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37362c42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/MainNav.vue
var MainNav_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.intro,"leave":_vm.outro}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mainNavVisible),expression:"mainNavVisible"}],staticClass:"MainNav",class:{'active' : !_vm.isInHome},on:{"mouseover":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave,"mousedown":_vm.onMouseDown,"touchstart":_vm.onMouseDown,"mousemove":_vm.onMouseMove,"touchmove":_vm.onMouseMove,"mouseup":_vm.onMouseUp,"touchend":_vm.onMouseUp}},[_c('main-nav-list',{ref:"mainNavList",attrs:{"chapters":_vm.chapters,"is-dragging":_vm.isDragging,"item-height":_vm.itemHeight},on:{"bttn-click":_vm.toggle}}),_vm._v(" "),_c('div',{ref:"indexIndicator",staticClass:"MainNav-index"},[_c('small',[_vm._v(_vm._s(_vm.activeIndex + 1))]),_vm._v(" "),_c('small',{staticClass:"MainNav-indexTotal"},[_c('span',{staticClass:"MainNav-indexDash"}),_vm._v("\n                "+_vm._s(_vm.chapters.length)+"\n            ")])])],1)])}
var MainNav_staticRenderFns = []
var MainNav_esExports = { render: MainNav_render, staticRenderFns: MainNav_staticRenderFns }
/* harmony default export */ var components_MainNav = (MainNav_esExports);
// CONCATENATED MODULE: ./src/app/components/MainNav.vue
function MainNav_injectStyle (ssrContext) {
  __webpack_require__("Dt7p")
}
var MainNav_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MainNav___vue_template_functional__ = false
/* styles */
var MainNav___vue_styles__ = MainNav_injectStyle
/* scopeId */
var MainNav___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MainNav___vue_module_identifier__ = null
var MainNav_Component = MainNav_normalizeComponent(
  MainNav,
  components_MainNav,
  MainNav___vue_template_functional__,
  MainNav___vue_styles__,
  MainNav___vue_scopeId__,
  MainNav___vue_module_identifier__
)

/* harmony default export */ var app_components_MainNav = (MainNav_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/PixiBackground.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var PixiBackground = ({
    name: "PixiBackground",
    components: {
        MainNav: app_components_MainNav
    },
    mounted: function mounted() {
        var _this = this;

        this.app = new pixi_PixiApp();
        this.app.setup();
        this.$nextTick(function () {
            _this.app.init(_this.$refs.pixiAppContainer);
        });
    },
    beforeDestroy: function beforeDestroy() {
        this.app.destroy();
    },

    computed: extends_default()({}, Object(vuex_esm["d" /* mapGetters */])(["mainNavVisible", "backgroundVisible", "isDragging", "activeIndex"])),
    watch: {
        mainNavVisible: function mainNavVisible(isOpen, wasOpen) {
            if (wasOpen) {
                this.app.backgroundView.openMask();
            } else {
                this.app.backgroundView.closeMask();
            }
        },
        isDragging: function isDragging(value, prevValue) {
            if (value) {
                this.app.backgroundView.onHold();
            } else {
                this.app.backgroundView.onRelease();
            }
        },
        activeIndex: function activeIndex(value, prevValue) {
            this.app.backgroundView.setCurrentResource(value);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-928fe908","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/PixiBackground.vue
var PixiBackground_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"PixiBackground"}},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.backgroundVisible),expression:"backgroundVisible"}],ref:"pixiAppContainer"})]),_vm._v(" "),_c('main-nav')],1)}
var PixiBackground_staticRenderFns = []
var PixiBackground_esExports = { render: PixiBackground_render, staticRenderFns: PixiBackground_staticRenderFns }
/* harmony default export */ var components_PixiBackground = (PixiBackground_esExports);
// CONCATENATED MODULE: ./src/app/components/PixiBackground.vue
function PixiBackground_injectStyle (ssrContext) {
  __webpack_require__("0L3U")
}
var PixiBackground_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PixiBackground___vue_template_functional__ = false
/* styles */
var PixiBackground___vue_styles__ = PixiBackground_injectStyle
/* scopeId */
var PixiBackground___vue_scopeId__ = "data-v-928fe908"
/* moduleIdentifier (server only) */
var PixiBackground___vue_module_identifier__ = null
var PixiBackground_Component = PixiBackground_normalizeComponent(
  PixiBackground,
  components_PixiBackground,
  PixiBackground___vue_template_functional__,
  PixiBackground___vue_styles__,
  PixiBackground___vue_scopeId__,
  PixiBackground___vue_module_identifier__
)

/* harmony default export */ var app_components_PixiBackground = (PixiBackground_Component.exports);

// EXTERNAL MODULE: ./node_modules/ismobilejs/isMobile.js
var isMobile = __webpack_require__("Sst2");
var isMobile_default = /*#__PURE__*/__webpack_require__.n(isMobile);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/components/base/RotateDevice.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var RotateDevice = ({
    name: 'RotateDevice',
    components: {
        LineIcon: app_components_LineIcon
    },
    data: function data() {
        return {
            isMobile: isMobile_default.a.any,
            width: window.innerWidth,
            height: window.innerHeight,
            count: 0,
            iconVisible: false
        };
    },
    mounted: function mounted() {
        this.updateSize();
        src_app.resize.add(this.updateSize);
    },
    beforeDestroy: function beforeDestroy() {
        src_app.resize.remove(this.updateSize);
    },

    methods: {
        intro: function intro(el, done) {
            var $refs = this.$refs;
            // Force LineIcon intro-transition

            this.iconVisible = true;
            TweenMax.fromTo($refs.copy, 0.2, { y: 15, alpha: 0 }, { y: 0, alpha: 1, delay: 0.5, onComplete: done });
        },
        outro: function outro(el, done) {
            this.iconVisible = false;
            done();
        },
        updateSize: function updateSize() {
            var _this = this;

            // Timeout needed because IOS Chrome
            var to = setTimeout(function () {
                _this.width = window.innerWidth;
                _this.height = window.innerHeight;
                clearTimeout(to);
                to = null;
            }, 100);
        }
    },
    computed: {
        ratio: function ratio() {
            var width = this.width,
                height = this.height;

            return width / height;
        },
        show: function show() {
            var ratio = this.ratio;

            return ratio < 1.3;
        },
        icon: function icon() {
            var isMobile = this.isMobile,
                $store = this.$store;

            if (isMobile) {
                return $store.getters.data.lineIcons.rotate;
            }
            return $store.getters.data.lineIcons.expand;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d0a1a0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/base/RotateDevice.vue
var RotateDevice_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false,"appear":true},on:{"enter":_vm.intro,"appear":_vm.intro,"leave":_vm.outro}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"RotateDevice"},[_c('div',{staticClass:"RotateDevice-inner"},[_c('line-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.iconVisible),expression:"iconVisible"}],key:"icon-up",staticClass:"RotateDevice-icon",attrs:{"width":_vm.icon.width,"height":_vm.icon.height,"d":_vm.icon.d,"intro-delay":0.75}}),_vm._v(" "),_c('p',{ref:"copy",staticClass:"RotateDevice-copy"},[(_vm.isMobile)?_c('small',[_vm._v("\n                    Mantén tu dispositivo en horizontal para poder vivir\n                    esta experiencia.\n                ")]):_c('small',[_vm._v("\n                    Extiende tu navegador para poder vivir esta experiencia.\n                ")])]),_vm._v(" "),_c('line-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.iconVisible),expression:"iconVisible"}],key:"icon-down",staticClass:"RotateDevice-icon RotateDevice-icon--polar",attrs:{"width":_vm.icon.width,"height":_vm.icon.height,"d":_vm.icon.d,"intro-delay":1}})],1)])])}
var RotateDevice_staticRenderFns = []
var RotateDevice_esExports = { render: RotateDevice_render, staticRenderFns: RotateDevice_staticRenderFns }
/* harmony default export */ var base_RotateDevice = (RotateDevice_esExports);
// CONCATENATED MODULE: ./src/app/components/base/RotateDevice.vue
function RotateDevice_injectStyle (ssrContext) {
  __webpack_require__("Trvm")
}
var RotateDevice_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RotateDevice___vue_template_functional__ = false
/* styles */
var RotateDevice___vue_styles__ = RotateDevice_injectStyle
/* scopeId */
var RotateDevice___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var RotateDevice___vue_module_identifier__ = null
var RotateDevice_Component = RotateDevice_normalizeComponent(
  RotateDevice,
  base_RotateDevice,
  RotateDevice___vue_template_functional__,
  RotateDevice___vue_styles__,
  RotateDevice___vue_scopeId__,
  RotateDevice___vue_module_identifier__
)

/* harmony default export */ var components_base_RotateDevice = (RotateDevice_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/Root.vue

//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Root = ({
    name: 'App',
    components: {
        Preloader: components_base_Preloader,
        RotateDevice: components_base_RotateDevice,
        LayoutMain: components_layout_LayoutMain,
        MenuRibbon: app_components_MenuRibbon,
        PixiBackground: app_components_PixiBackground
    },
    computed: extends_default()({}, Object(vuex_esm["f" /* mapState */])({
        started: function started(state) {
            return !state.app.loading;
        }
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3df0f56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/Root.vue
var Root_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"App",attrs:{"id":"app"}},[(_vm.started)?[_c('layout-main'),_vm._v(" "),_c('pixi-background'),_vm._v(" "),_c('menu-ribbon'),_vm._v(" "),_c('rotate-device')]:_c('preloader',{attrs:{"transitionMode":"out-in"}})],2)}
var Root_staticRenderFns = []
var Root_esExports = { render: Root_render, staticRenderFns: Root_staticRenderFns }
/* harmony default export */ var app_Root = (Root_esExports);
// CONCATENATED MODULE: ./src/app/Root.vue
function Root_injectStyle (ssrContext) {
  __webpack_require__("VFFm")
}
var Root_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Root___vue_template_functional__ = false
/* styles */
var Root___vue_styles__ = Root_injectStyle
/* scopeId */
var Root___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Root___vue_module_identifier__ = null
var Root_Component = Root_normalizeComponent(
  Root,
  app_Root,
  Root___vue_template_functional__,
  Root___vue_styles__,
  Root___vue_scopeId__,
  Root___vue_module_identifier__
)

/* harmony default export */ var src_app_Root = (Root_Component.exports);

// CONCATENATED MODULE: ./src/app/App.js











// VUE PLUGINS




// VUE ROUTER







vue_runtime_esm["a" /* default */].config.performance = "production" !== "production";
app_routes.base = config_environment.url.subdirectory;
var router = new vue_router_esm["a" /* default */](app_routes);

var App_App = function (_AbstractApp) {
    inherits_default()(App, _AbstractApp);

    function App() {
        classCallCheck_default()(this, App);

        // Define default easings
        var _this = possibleConstructorReturn_default()(this, (App.__proto__ || get_prototype_of_default()(App)).call(this));

        gsap_TweenMax["TweenLite"].defaultEase = gsap_TweenMax["Quart"].easeIn;
        gsap_TweenMax["TweenMax"].defaultEase = gsap_TweenMax["Quart"].easeIn;

        vue_runtime_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
        vue_runtime_esm["a" /* default */].use(core_VueFoo);
        vue_runtime_esm["a" /* default */].use(vue_youtube_default.a);
        vue_runtime_esm["a" /* default */].use(VueAnalytics, {
            adapters: config_environment.analytics
        });
        return _this;
    }

    createClass_default()(App, [{
        key: "renderApp",
        value: function renderApp() {
            this.router = router;
            router.beforeEach(function (to, from, next) {
                next();
            });
            Object(vuex_router_sync["sync"])(store, router);
            var i18n = locale_LocaleManager.i18n;
            /* eslint-disable no-new */
            new vue_runtime_esm["a" /* default */]({
                el: "#app",
                store: store,
                router: router,
                i18n: i18n,
                render: function render(h) {
                    return h(src_app_Root);
                }
            });
        }
    }]);

    return App;
}(core_AbstractApp);

/* harmony default export */ var app_App = (App_App);
// CONCATENATED MODULE: ./src/app/index.js


if (false) {
    var Stats = require('stats.js');
    var stats = new Stats();
    document.body.appendChild(stats.domElement);
    var app_render = function render() {
        stats.update();
        window.requestAnimationFrame(render);
    };
    window.requestAnimationFrame(app_render);
}

var app_app = new app_App();
/* harmony default export */ var src_app = (app_app);
// CONCATENATED MODULE: ./src/main.js










/***/ }),

/***/ "QUV6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/PAULINA_JAIMES.bcd24fb.jpg";

/***/ }),

/***/ "SJ7A":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/CILER.79b755c.jpg";

/***/ }),

/***/ "TGEO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/CESAR_CORDOVA.6936028.jpg";

/***/ }),

/***/ "Trvm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VFFm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VHsx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/MALAFACHA.b17ee94.jpg";

/***/ }),

/***/ "VYjE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vbty":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/LUIS_URREA.4ca83f4.jpg";

/***/ }),

/***/ "VhkR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ALBERTO_MONTT.02fb887.jpg";

/***/ }),

/***/ "Weh9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wf2R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X1wz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/OLIVER_JEFFERS.5d152ec.jpg";

/***/ }),

/***/ "XCQw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/HORACIO_QUIROZ.75b8ac3.jpg";

/***/ }),

/***/ "Xg4b":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("EKrm");
__webpack_require__("ommR").polyfill();

/***/ }),

/***/ "XzHR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/JAVIER_SIERRA.6b866c7.jpg";

/***/ }),

/***/ "YfPi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aa5y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/MATIAS_PRADO.74278a4.jpg";

/***/ }),

/***/ "aqVO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bRbH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dLd/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.288f340.png";

/***/ }),

/***/ "fMN5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fa/7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gLCN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gSHU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/TAQUITO.08c054b.jpg";

/***/ }),

/***/ "gtvh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hhQz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iZyl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iaWA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/TALLAECHE.b085cc9.jpg";

/***/ }),

/***/ "jUnm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/data/tracking.98ac05d.json";

/***/ }),

/***/ "lrTa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mKng":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/MARIA_DUENAS.497f3cb.jpg";

/***/ }),

/***/ "mXYG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/FRANCISCO_TOLEDO.3b76c21.jpg";

/***/ }),

/***/ "mabu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/SABINO_GUISU.90e33b9.jpg";

/***/ }),

/***/ "nTYG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rNb/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t4ke":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ELENA_PONIATOWSKA.ec3ecdf.jpg";

/***/ }),

/***/ "tLzU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tVLB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uSRS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xvzA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5c7da3f6a8b83a252e9b.js